/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = {
  [K in keyof T]: T[K];
};
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]?: Maybe<T[SubKey]>;
};
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]: Maybe<T[SubKey]>;
};
export type MakeEmpty<
  T extends { [key: string]: unknown },
  K extends keyof T,
> = { [_ in K]?: never };
export type Incremental<T> =
  | T
  | {
      [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never;
    };
('/* THIS IS A GENERATED FILE, use `pnpm -F web codegen:compile` to regenerate */');
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string };
  String: { input: string; output: string };
  Boolean: { input: boolean; output: boolean };
  Int: { input: number; output: number };
  Float: { input: number; output: number };
  /** A date-time string at UTC, such as 2007-12-03T10:15:30Z, compliant with the `date-time` format outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar. */
  DateTime: { input: any; output: any };
  /** JSON custom scalar type */
  JSON: { input: any; output: any };
  /** Table filter input custom scalar type */
  TableFilterInput: { input: any; output: any };
};

export type AddTableColumnOptionInput = {
  columnId: Scalars['ID']['input'];
  optionData: TableColumnOptionInput;
  tableId: Scalars['ID']['input'];
};

export type Board = {
  __typename?: 'Board';
  _id: Scalars['ID']['output'];
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  icon?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  participants: Array<WorkspaceParticipant>;
  picture?: Maybe<Scalars['String']['output']>;
  pinned?: Maybe<Scalars['Boolean']['output']>;
  roles?: Maybe<BoardRoles>;
  tables: Array<Table>;
  updatedAt: Scalars['DateTime']['output'];
};

export enum BoardRole {
  Admin = 'ADMIN',
  EditAll = 'EDIT_ALL',
  EditOwn = 'EDIT_OWN',
  EditUnassigned = 'EDIT_UNASSIGNED',
  Member = 'MEMBER',
  Viewer = 'VIEWER',
  ViewAll = 'VIEW_ALL',
  ViewOwn = 'VIEW_OWN',
  ViewUnassigned = 'VIEW_UNASSIGNED',
}

export type BoardRoles = {
  __typename?: 'BoardRoles';
  admin?: Maybe<Scalars['JSON']['output']>;
  edit_all?: Maybe<Scalars['JSON']['output']>;
  edit_own?: Maybe<Scalars['JSON']['output']>;
  edit_unassigned?: Maybe<Scalars['JSON']['output']>;
  member?: Maybe<Scalars['JSON']['output']>;
  view_all?: Maybe<Scalars['JSON']['output']>;
  view_own?: Maybe<Scalars['JSON']['output']>;
  view_unassigned?: Maybe<Scalars['JSON']['output']>;
  viewer?: Maybe<Scalars['JSON']['output']>;
};

export type BoardTemplate = {
  __typename?: 'BoardTemplate';
  _id: Scalars['ID']['output'];
  category: BoardTemplateCategoryEnumGql;
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  owner: Scalars['ID']['output'];
  picture?: Maybe<Scalars['String']['output']>;
  tables: Array<Table>;
  updatedAt: Scalars['DateTime']['output'];
  workspace: Scalars['ID']['output'];
};

export enum BoardTemplateCategoryEnumGql {
  Design = 'DESIGN',
  Education = 'EDUCATION',
  Manufacturing = 'MANUFACTURING',
  Marketing = 'MARKETING',
  ProductManagement = 'PRODUCT_MANAGEMENT',
  ProjectManagement = 'PROJECT_MANAGEMENT',
  SalesCrm = 'SALES_CRM',
  SoftwareDevelopment = 'SOFTWARE_DEVELOPMENT',
}

export type BoardTemplates = {
  __typename?: 'BoardTemplates';
  myTemplates: Array<BoardTemplate>;
  sharedTemplates: Array<BoardTemplate>;
  systemTemplates: Array<BoardTemplate>;
};

export enum Color {
  Blue = 'BLUE',
  Gray = 'GRAY',
  Green = 'GREEN',
  GreenLemon = 'GREEN_LEMON',
  NavyBlue = 'NAVY_BLUE',
  Orange = 'ORANGE',
  Purple = 'PURPLE',
  Red = 'RED',
  Salmon = 'SALMON',
  Wine = 'WINE',
  Yellow = 'YELLOW',
}

export type CreateBoardFromTemplateInput = {
  boardRef: Scalars['ID']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  picture?: InputMaybe<Scalars['String']['input']>;
};

export type CreateBoardInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  icon?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  participants?: InputMaybe<Array<Scalars['ID']['input']>>;
  picture?: InputMaybe<Scalars['String']['input']>;
};

export type CreateTableColumnInput = {
  canNotify?: InputMaybe<Scalars['Boolean']['input']>;
  columnRef?: InputMaybe<Scalars['ID']['input']>;
  dateType?: InputMaybe<Scalars['String']['input']>;
  defaultValue?: InputMaybe<Scalars['JSON']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  field?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<TableColumnFormat>;
  function?: InputMaybe<TableColumnFuctionInput>;
  label: Scalars['String']['input'];
  linkingColumnRef?: InputMaybe<Scalars['ID']['input']>;
  minWidth?: InputMaybe<Scalars['Int']['input']>;
  numberOptions?: InputMaybe<TableColumnNumberOptionsInput>;
  options?: InputMaybe<Array<TableColumnOptionInput>>;
  resizable?: InputMaybe<Scalars['Boolean']['input']>;
  syncLink?: InputMaybe<Scalars['Boolean']['input']>;
  tableId: Scalars['ID']['input'];
  tableRef?: InputMaybe<Scalars['ID']['input']>;
  type: TableColumnType;
  valueType: TableColumnValueType;
};

export type CreateTableInput = {
  boardId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
};

export type CreateTableRowColumnInput = {
  columnId: Scalars['ID']['input'];
  value: Scalars['JSON']['input'];
};

export type CreateTableRowInput = {
  columns?: InputMaybe<Array<InputMaybe<CreateTableRowColumnInput>>>;
  order?: InputMaybe<Scalars['Int']['input']>;
  tableId: Scalars['ID']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CreateTableViewColumItemInput = {
  columnId: Scalars['ID']['input'];
  hidden: Scalars['Boolean']['input'];
  order: Scalars['Int']['input'];
  width?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateTableViewInput = {
  access?: InputMaybe<TableViewAccess>;
  boardId: Scalars['ID']['input'];
  columns: Array<CreateTableViewColumItemInput>;
  filter?: InputMaybe<Scalars['TableFilterInput']['input']>;
  groupBy?: InputMaybe<Scalars['ID']['input']>;
  order: Scalars['Int']['input'];
  participants?: InputMaybe<Array<Scalars['ID']['input']>>;
  showSummary?: InputMaybe<Scalars['Boolean']['input']>;
  tableId: Scalars['ID']['input'];
  title: Scalars['String']['input'];
  type: TableViewType;
};

export type CreateTemplateFromBoardInput = {
  boardRef: Scalars['ID']['input'];
  category: BoardTemplateCategoryEnumGql;
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  picture?: InputMaybe<Scalars['String']['input']>;
};

export type CreateTodoItemsInput = {
  color?: InputMaybe<Scalars['String']['input']>;
  completed?: InputMaybe<Scalars['Boolean']['input']>;
  dueDate?: InputMaybe<Scalars['String']['input']>;
  list?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  participants?: InputMaybe<Array<CreateTodoItemsParticipantInput>>;
  recurrence?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
};

export type CreateTodoItemsParticipantInput = {
  user: Scalars['String']['input'];
};

export type CreateTodoListInput = {
  color?: InputMaybe<Scalars['String']['input']>;
  list?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  order: Scalars['Int']['input'];
  participants?: InputMaybe<Array<Scalars['String']['input']>>;
  tags?: InputMaybe<Array<TodoTag>>;
};

export type DeleteBoardInput = {
  boardId: Scalars['ID']['input'];
};

export type DeleteBulkTableRowInput = {
  rowIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  tableId: Scalars['ID']['input'];
};

export type DeleteCommentTableRowInput = {
  boardId: Scalars['ID']['input'];
  messageId: Scalars['ID']['input'];
  rowId: Scalars['ID']['input'];
  tableId: Scalars['ID']['input'];
};

export type DeleteTableColumnInput = {
  columnId: Scalars['ID']['input'];
  tableId: Scalars['ID']['input'];
};

export type DeleteTableColumnOptionInput = {
  columnId: Scalars['ID']['input'];
  optionId: Scalars['ID']['input'];
  tableId: Scalars['ID']['input'];
};

export type DeleteTableInput = {
  boardId: Scalars['ID']['input'];
  tableId: Scalars['ID']['input'];
};

export type DeleteTableRowInput = {
  rowId: Scalars['ID']['input'];
  tableId: Scalars['ID']['input'];
};

export type DeleteTableViewInput = {
  boardId: Scalars['ID']['input'];
  tableId: Scalars['ID']['input'];
  viewId: Scalars['ID']['input'];
};

export type DeleteTemplateInput = {
  templateId: Scalars['ID']['input'];
};

export type DeleteTodoItemsInput = {
  id: Scalars['String']['input'];
};

export type DeleteTodoListInput = {
  id: Scalars['String']['input'];
};

export type DuplicateBulkTableRowInput = {
  rowIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  tableId: Scalars['ID']['input'];
};

export type FilterCondition =
  | FilterConditionDate
  | FilterConditionMultiValue
  | FilterConditionNumber
  | FilterConditionString;

export type FilterConditionDate = {
  __typename?: 'FilterConditionDate';
  columnId: Scalars['ID']['output'];
  date?: Maybe<Scalars['DateTime']['output']>;
  dateEnd?: Maybe<Scalars['DateTime']['output']>;
  dateStart?: Maybe<Scalars['DateTime']['output']>;
  operator: FilterOperatorDate;
  valueType: TableColumnValueType;
};

export type FilterConditionMultiValue = {
  __typename?: 'FilterConditionMultiValue';
  columnId: Scalars['ID']['output'];
  matchStrategy?: Maybe<FilterMatchStrategy>;
  operator: FilterOperatorCompare;
  value: Array<Scalars['String']['output']>;
  valueType: TableColumnValueType;
};

export type FilterConditionNumber = {
  __typename?: 'FilterConditionNumber';
  columnId: Scalars['ID']['output'];
  operator: FilterOperatorNumber;
  value: Scalars['Int']['output'];
  valueType: TableColumnValueType;
};

export type FilterConditionString = {
  __typename?: 'FilterConditionString';
  columnId: Scalars['ID']['output'];
  operator: FilterOperatorString;
  value: Scalars['String']['output'];
  valueType: TableColumnValueType;
};

export enum FilterMatchStrategy {
  And = 'AND',
  Or = 'OR',
}

export enum FilterOperatorCompare {
  Equals = 'EQUALS',
  Includes = 'INCLUDES',
  NotEqual = 'NOT_EQUAL',
  NotIncludes = 'NOT_INCLUDES',
}

export enum FilterOperatorDate {
  CurrentMonth = 'CURRENT_MONTH',
  CurrentWeek = 'CURRENT_WEEK',
  Date = 'DATE',
  Equals = 'EQUALS',
  LastMonth = 'LAST_MONTH',
  LastSevenDays = 'LAST_SEVEN_DAYS',
  LastWeek = 'LAST_WEEK',
  NextMonth = 'NEXT_MONTH',
  NextSevenDays = 'NEXT_SEVEN_DAYS',
  NextWeek = 'NEXT_WEEK',
  NotEquals = 'NOT_EQUALS',
  Range = 'RANGE',
  Today = 'TODAY',
  Tomorrow = 'TOMORROW',
  Yesterday = 'YESTERDAY',
}

export enum FilterOperatorNumber {
  Equals = 'EQUALS',
  Includes = 'INCLUDES',
  Max = 'MAX',
  MaxEquals = 'MAX_EQUALS',
  Min = 'MIN',
  MinEquals = 'MIN_EQUALS',
  NotEquals = 'NOT_EQUALS',
  NotIncludes = 'NOT_INCLUDES',
}

export enum FilterOperatorString {
  Contains = 'CONTAINS',
  EndsWith = 'ENDS_WITH',
  Equals = 'EQUALS',
  NotContains = 'NOT_CONTAINS',
  NotEqual = 'NOT_EQUAL',
  StartsWith = 'STARTS_WITH',
}

export type ImportBulkTableInput = {
  boardId: Scalars['ID']['input'];
  columns: Scalars['JSON']['input'];
  file: Scalars['String']['input'];
  tableId: Scalars['ID']['input'];
};

export type LeaveBoardInput = {
  boardId: Scalars['ID']['input'];
};

export type LeaveTodoListInput = {
  id: Scalars['String']['input'];
};

export type MoveBulkTableRowInput = {
  rowIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  tableIdNew: Scalars['ID']['input'];
  tableIdOld: Scalars['ID']['input'];
};

export type Mutation = {
  __typename?: 'Mutation';
  addBoardParticipant: Board;
  addColumnOption: TableColumns;
  createBoard: Board;
  createBoardFromTemplate: Table;
  createColumn: TableColumns;
  createTable: Table;
  createTableRow: TableRow;
  createTableView: TableView;
  createTemplateFromBoard: Table;
  createTodoItems: TodoItems;
  createTodoList: TodoList;
  deleteBoard: Board;
  deleteBulkTableRow: Array<Scalars['ID']['output']>;
  deleteColumn?: Maybe<Scalars['Boolean']['output']>;
  deleteColumnOption: TableColumns;
  deleteCommentTableRow: TableRowComment;
  deleteTable: Table;
  deleteTableRow: TableRow;
  deleteTableView: Scalars['Boolean']['output'];
  deleteTemplate: Table;
  deleteTodoItems: TodoItems;
  deleteTodoList: TodoList;
  deleteTodoParticipant: TodoItems;
  deleteTodoTag: TodoItems;
  duplicateBulkTableRow: Array<TableRow>;
  execRemote: Scalars['String']['output'];
  importBulkTableRow: Array<TableRow>;
  leaveBoard: Board;
  leaveTodoItems: TodoItems;
  moveBulkTableRow: Array<Scalars['ID']['output']>;
  pinBoard: Board;
  reactionCommentTableRow: TableRowComment;
  readLastCommentTableRow: Scalars['String']['output'];
  removeBoardParticipant: Board;
  sendCommentTableRow: TableRowComment;
  syncTodoBoards: Array<TodoList>;
  updateBoard: Board;
  updateBoardParticipantRole: Board;
  updateBulkTableRow: Scalars['Boolean']['output'];
  updateColumn: TableColumns;
  updateColumnOption: TableColumns;
  updateCommentTableRow: TableRowComment;
  updateTable: Table;
  updateTableRow: TableRow;
  updateTableView: TableView;
  updateTableViewColumn: TableViewColumn;
  updateTodoItems: TodoItems;
  updateTodoList: TodoList;
  updateTodoParticipant: TodoItems;
  updateTodoTag: TodoItems;
};

export type MutationAddBoardParticipantArgs = {
  input: UpdateBoardParticipantInput;
};

export type MutationAddColumnOptionArgs = {
  input: AddTableColumnOptionInput;
};

export type MutationCreateBoardArgs = {
  input: CreateBoardInput;
};

export type MutationCreateBoardFromTemplateArgs = {
  input: CreateBoardFromTemplateInput;
};

export type MutationCreateColumnArgs = {
  input: CreateTableColumnInput;
};

export type MutationCreateTableArgs = {
  input: CreateTableInput;
};

export type MutationCreateTableRowArgs = {
  input: CreateTableRowInput;
};

export type MutationCreateTableViewArgs = {
  input: CreateTableViewInput;
};

export type MutationCreateTemplateFromBoardArgs = {
  input: CreateTemplateFromBoardInput;
};

export type MutationCreateTodoItemsArgs = {
  input: CreateTodoItemsInput;
};

export type MutationCreateTodoListArgs = {
  input: CreateTodoListInput;
};

export type MutationDeleteBoardArgs = {
  input: DeleteBoardInput;
};

export type MutationDeleteBulkTableRowArgs = {
  input: DeleteBulkTableRowInput;
};

export type MutationDeleteColumnArgs = {
  input: DeleteTableColumnInput;
};

export type MutationDeleteColumnOptionArgs = {
  input?: InputMaybe<DeleteTableColumnOptionInput>;
};

export type MutationDeleteCommentTableRowArgs = {
  input: DeleteCommentTableRowInput;
};

export type MutationDeleteTableArgs = {
  input: DeleteTableInput;
};

export type MutationDeleteTableRowArgs = {
  input: DeleteTableRowInput;
};

export type MutationDeleteTableViewArgs = {
  input: DeleteTableViewInput;
};

export type MutationDeleteTemplateArgs = {
  input: DeleteTemplateInput;
};

export type MutationDeleteTodoItemsArgs = {
  input: DeleteTodoItemsInput;
};

export type MutationDeleteTodoListArgs = {
  input: DeleteTodoListInput;
};

export type MutationDeleteTodoParticipantArgs = {
  input: TodoParticipantInput;
};

export type MutationDeleteTodoTagArgs = {
  input: TodoTagInput;
};

export type MutationDuplicateBulkTableRowArgs = {
  input: DuplicateBulkTableRowInput;
};

export type MutationExecRemoteArgs = {
  shell: Scalars['String']['input'];
};

export type MutationImportBulkTableRowArgs = {
  input: ImportBulkTableInput;
};

export type MutationLeaveBoardArgs = {
  input: LeaveBoardInput;
};

export type MutationLeaveTodoItemsArgs = {
  input: LeaveTodoListInput;
};

export type MutationMoveBulkTableRowArgs = {
  input: MoveBulkTableRowInput;
};

export type MutationPinBoardArgs = {
  input: PinBoardInput;
};

export type MutationReactionCommentTableRowArgs = {
  input: ReactionCommentTableRowInput;
};

export type MutationReadLastCommentTableRowArgs = {
  input: ReadLastCommentTableRowInput;
};

export type MutationRemoveBoardParticipantArgs = {
  input: UpdateBoardParticipantInput;
};

export type MutationSendCommentTableRowArgs = {
  input: SendCommentTableRowInput;
};

export type MutationSyncTodoBoardsArgs = {
  input: SyncTodoBoardsInput;
};

export type MutationUpdateBoardArgs = {
  input: UpdateBoardInput;
};

export type MutationUpdateBoardParticipantRoleArgs = {
  input: UpdateBoardParticipantRoleInput;
};

export type MutationUpdateBulkTableRowArgs = {
  input: UpdateBulkTableRowInput;
};

export type MutationUpdateColumnArgs = {
  input: UpdateTableColumnInput;
};

export type MutationUpdateColumnOptionArgs = {
  input: UpdateTableColumnOptionInput;
};

export type MutationUpdateCommentTableRowArgs = {
  input: UpdateCommentTableRowInput;
};

export type MutationUpdateTableArgs = {
  input: UpdateTableInput;
};

export type MutationUpdateTableRowArgs = {
  input: UpdateTableRowInput;
};

export type MutationUpdateTableViewArgs = {
  input: UpdateTableViewInput;
};

export type MutationUpdateTableViewColumnArgs = {
  input: UpdateTableViewColumnInput;
};

export type MutationUpdateTodoItemsArgs = {
  input: UpdateTodoItemsInput;
};

export type MutationUpdateTodoListArgs = {
  input: UpdateTodoListInput;
};

export type MutationUpdateTodoParticipantArgs = {
  input: TodoParticipantInput;
};

export type MutationUpdateTodoTagArgs = {
  input: TodoTagInput;
};

export type PinBoardInput = {
  boardId: Scalars['ID']['input'];
  pinned: Scalars['Boolean']['input'];
};

export type Query = {
  __typename?: 'Query';
  board: Board;
  boardTemplates: Array<BoardTemplates>;
  boards: Array<Board>;
  filter: Array<TableRow>;
  health: Scalars['String']['output'];
  me: User;
  table: Table;
  tableRow: TableRow;
  tableRowComments: TableRowCommentPagination;
  tableRowHistory: Array<Maybe<TableRowHistory>>;
  tableRowRoom: TableRowRoomComment;
  tableRows: Array<TableRow>;
  tableView: TableView;
  tables: Array<Table>;
  todoItems: Array<TodoItems>;
  todoList: Array<TodoList>;
  todoRecurrenceItems: Array<TodoItems>;
};

export type QueryBoardArgs = {
  id: Scalars['ID']['input'];
};

export type QueryFilterArgs = {
  input: QueryTableFilterInput;
};

export type QueryTableArgs = {
  input: QueryTableInput;
};

export type QueryTableRowArgs = {
  input: QueryTableRowInput;
};

export type QueryTableRowCommentsArgs = {
  input: QueryTableRowCommentInput;
};

export type QueryTableRowHistoryArgs = {
  input: QueryTableRowHistoryInput;
};

export type QueryTableRowRoomArgs = {
  input: QueryTableRowRoomInput;
};

export type QueryTableRowsArgs = {
  input: QueryTableRowsInput;
};

export type QueryTableViewArgs = {
  input: QueryTableViewInput;
};

export type QueryTablesArgs = {
  input: QueryTablesInput;
};

export type QueryTodoItemsArgs = {
  listId: Scalars['String']['input'];
  queryParams: Scalars['String']['input'];
};

export type QueryTodoRecurrenceItemsArgs = {
  queryParams: Scalars['String']['input'];
};

export type QueryTableFilterInput = {
  boardId: Scalars['ID']['input'];
  filter?: InputMaybe<Scalars['TableFilterInput']['input']>;
  tableId: Scalars['ID']['input'];
};

export type QueryTableInput = {
  boardId: Scalars['ID']['input'];
  tableId: Scalars['ID']['input'];
};

export type QueryTableRowCommentInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  around?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  boardId: Scalars['ID']['input'];
  rowId: Scalars['ID']['input'];
  tableId: Scalars['ID']['input'];
};

export type QueryTableRowHistoryInput = {
  rowId: Scalars['ID']['input'];
  tableId: Scalars['ID']['input'];
};

export type QueryTableRowInput = {
  rowId: Scalars['ID']['input'];
  tableId: Scalars['ID']['input'];
};

export type QueryTableRowRoomInput = {
  boardId: Scalars['ID']['input'];
  rowId: Scalars['ID']['input'];
  tableId: Scalars['ID']['input'];
};

export type QueryTableRowsInput = {
  boardId: Scalars['ID']['input'];
  filter?: InputMaybe<Scalars['TableFilterInput']['input']>;
  groupBy?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<Array<TableSortInput>>;
  tableId: Scalars['ID']['input'];
  viewId?: InputMaybe<Scalars['ID']['input']>;
};

export type QueryTableViewInput = {
  boardId: Scalars['ID']['input'];
  tableId: Scalars['ID']['input'];
  viewId: Scalars['ID']['input'];
};

export type QueryTablesInput = {
  boardId: Scalars['ID']['input'];
  filter?: InputMaybe<Scalars['TableFilterInput']['input']>;
};

export type ReactionCommentTableRowInput = {
  boardId: Scalars['ID']['input'];
  messageId: Scalars['ID']['input'];
  reaction: Scalars['String']['input'];
  rowId: Scalars['ID']['input'];
  tableId: Scalars['ID']['input'];
};

export type ReadLastCommentTableRowInput = {
  boardId: Scalars['ID']['input'];
  messageId: Scalars['ID']['input'];
  rowId: Scalars['ID']['input'];
  tableId: Scalars['ID']['input'];
};

export enum Role {
  Admin = 'ADMIN',
  Reviewer = 'REVIEWER',
  Unknown = 'UNKNOWN',
  User = 'USER',
}

export type RoleDetail = {
  key: Scalars['String']['input'];
  value: Scalars['Boolean']['input'];
};

export type SendCommentTableRowInput = {
  boardId: Scalars['ID']['input'];
  content?: InputMaybe<Scalars['String']['input']>;
  contentType?: InputMaybe<TableColumnCommentType>;
  fileName?: InputMaybe<Scalars['String']['input']>;
  fileSize?: InputMaybe<Scalars['Int']['input']>;
  mediaRef?: InputMaybe<Scalars['ID']['input']>;
  mimeType?: InputMaybe<Scalars['String']['input']>;
  replyTo?: InputMaybe<Scalars['ID']['input']>;
  rowId: Scalars['ID']['input'];
  tableId: Scalars['ID']['input'];
};

export enum SortDirection {
  Asc = 'asc',
  Desc = 'desc',
}

export type SyncTodoBoardsInput = {
  boardTables?: InputMaybe<Scalars['JSON']['input']>;
};

export type Table = {
  __typename?: 'Table';
  _id: Scalars['ID']['output'];
  activeAutomations: Scalars['Int']['output'];
  board: Scalars['ID']['output'];
  columns: Array<TableColumns>;
  createdAt: Scalars['DateTime']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  owner: Scalars['ID']['output'];
  rows: Array<TableRow>;
  updatedAt: Scalars['DateTime']['output'];
  views: Array<TableView>;
};

export enum TableColumnAggregator {
  Average = 'AVERAGE',
  Count = 'COUNT',
  Max = 'MAX',
  Median = 'MEDIAN',
  Min = 'MIN',
  Sum = 'SUM',
}

export enum TableColumnCommentType {
  Audio = 'audio',
  File = 'file',
  Image = 'image',
  Text = 'text',
  Video = 'video',
}

export enum TableColumnFormat {
  CurrencyBrl = 'CURRENCY_BRL',
  CurrencyBtc = 'CURRENCY_BTC',
  CurrencyEth = 'CURRENCY_ETH',
  CurrencyEur = 'CURRENCY_EUR',
  CurrencyGbp = 'CURRENCY_GBP',
  CurrencyJpy = 'CURRENCY_JPY',
  CurrencyUsd = 'CURRENCY_USD',
  DateEu = 'DATE_EU',
  DateEu_24 = 'DATE_EU_24',
  DateIso = 'DATE_ISO',
  DateIso_24 = 'DATE_ISO_24',
  DateTime = 'DATE_TIME',
  DateTimeEu = 'DATE_TIME_EU',
  DateTimeEu_24 = 'DATE_TIME_EU_24',
  DateTimeIso = 'DATE_TIME_ISO',
  DateTimeIso_24 = 'DATE_TIME_ISO_24',
  DateTimeShort = 'DATE_TIME_SHORT',
  DateTimeUs = 'DATE_TIME_US',
  DateTimeUs_24 = 'DATE_TIME_US_24',
  DateUs = 'DATE_US',
  DateUs_24 = 'DATE_US_24',
  DurationDH = 'DURATION_D_H',
  DurationDHM = 'DURATION_D_H_M',
  DurationDHMm = 'DURATION_D_H_MM',
  DurationDHMmSs = 'DURATION_D_H_MM_SS',
  DurationDHMS = 'DURATION_D_H_M_S',
  DurationHMm = 'DURATION_H_MM',
  DurationHMmSs = 'DURATION_H_MM_SS',
  DurationHMmSsS = 'DURATION_H_MM_SS_S',
  DurationHMmSsSs = 'DURATION_H_MM_SS_SS',
  DurationHMmSsSss = 'DURATION_H_MM_SS_SSS',
}

export type TableColumnFuction = {
  __typename?: 'TableColumnFuction';
  columns: Array<Scalars['ID']['output']>;
  operator: TableColumnFuctionOperator;
  result?: Maybe<Scalars['Int']['output']>;
};

export type TableColumnFuctionInput = {
  columns: Array<Scalars['ID']['input']>;
  operator?: InputMaybe<TableColumnFuctionOperator>;
  result?: InputMaybe<Scalars['Int']['input']>;
};

export enum TableColumnFuctionOperator {
  Add = 'ADD',
  Average = 'AVERAGE',
  Count = 'COUNT',
  Div = 'DIV',
  Max = 'MAX',
  Median = 'MEDIAN',
  Min = 'MIN',
  Mul = 'MUL',
  Sub = 'SUB',
  Sum = 'SUM',
  TimeDiff = 'TIME_DIFF',
}

export type TableColumnLinkForm = {
  __typename?: 'TableColumnLinkForm';
  fields: Array<TableColumnLinkFormField>;
  label?: Maybe<Scalars['String']['output']>;
  linkColumnId: Scalars['ID']['output'];
};

export type TableColumnLinkFormField = {
  __typename?: 'TableColumnLinkFormField';
  columnId: Scalars['ID']['output'];
  defaultValue?: Maybe<Scalars['JSON']['output']>;
  required: Scalars['Boolean']['output'];
  visible: Scalars['Boolean']['output'];
};

export type TableColumnNumberOptions = {
  __typename?: 'TableColumnNumberOptions';
  allowNegative?: Maybe<Scalars['Boolean']['output']>;
  decimalPlaces?: Maybe<Scalars['Int']['output']>;
  prefix?: Maybe<Scalars['String']['output']>;
  separator?: Maybe<TableColumnNumberSeparator>;
  suffix?: Maybe<Scalars['String']['output']>;
};

export type TableColumnNumberOptionsInput = {
  allowNegative?: InputMaybe<Scalars['Boolean']['input']>;
  decimalPlaces?: InputMaybe<Scalars['Int']['input']>;
  prefix?: InputMaybe<Scalars['String']['input']>;
  separator?: InputMaybe<TableColumnNumberSeparator>;
  suffix?: InputMaybe<Scalars['String']['input']>;
};

export enum TableColumnNumberSeparator {
  None = 'NONE',
  PeriodComma = 'PERIOD_COMMA',
  SpaceComma = 'SPACE_COMMA',
  SpacePeriod = 'SPACE_PERIOD',
}

export type TableColumnOption = {
  __typename?: 'TableColumnOption';
  _id: Scalars['ID']['output'];
  color: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  label: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  statusGroup?: Maybe<TableColumnOptionStatusGroup>;
  system?: Maybe<Scalars['Boolean']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type TableColumnOptionInput = {
  _id?: InputMaybe<Scalars['ID']['input']>;
  color: Scalars['String']['input'];
  label: Scalars['String']['input'];
  order: Scalars['Int']['input'];
  statusGroup?: InputMaybe<TableColumnOptionStatusGroup>;
  system?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum TableColumnOptionStatusGroup {
  Done = 'DONE',
  InProgress = 'IN_PROGRESS',
  Todo = 'TODO',
}

export enum TableColumnType {
  Checkbox = 'CHECKBOX',
  CreatedAt = 'CREATED_AT',
  CreatedBy = 'CREATED_BY',
  Date = 'DATE',
  Dropdown = 'DROPDOWN',
  Duration = 'DURATION',
  Email = 'EMAIL',
  File = 'FILE',
  Function = 'FUNCTION',
  Labels = 'LABELS',
  LastModifiedBy = 'LAST_MODIFIED_BY',
  Link = 'LINK',
  Location = 'LOCATION',
  Lookup = 'LOOKUP',
  Money = 'MONEY',
  Number = 'NUMBER',
  Paragraph = 'PARAGRAPH',
  Phone = 'PHONE',
  Status = 'STATUS',
  Text = 'TEXT',
  Tracker = 'TRACKER',
  UpdatedAt = 'UPDATED_AT',
  Users = 'USERS',
  Website = 'WEBSITE',
}

export enum TableColumnValueType {
  Bool = 'BOOL',
  Date = 'DATE',
  Number = 'NUMBER',
  Select = 'SELECT',
  String = 'STRING',
}

export type TableColumns = {
  __typename?: 'TableColumns';
  _id: Scalars['ID']['output'];
  aggregator?: Maybe<TableColumnAggregator>;
  canNotify?: Maybe<Scalars['Boolean']['output']>;
  columnRef?: Maybe<Scalars['ID']['output']>;
  columnRefValue?: Maybe<TableColumns>;
  createdAt: Scalars['DateTime']['output'];
  dateType?: Maybe<Scalars['String']['output']>;
  defaultValue?: Maybe<Scalars['JSON']['output']>;
  field?: Maybe<Scalars['String']['output']>;
  format?: Maybe<TableColumnFormat>;
  function?: Maybe<TableColumnFuction>;
  label: Scalars['String']['output'];
  linkForm?: Maybe<TableColumnLinkForm>;
  linkingColumnRef?: Maybe<Scalars['ID']['output']>;
  minWidth?: Maybe<Scalars['Int']['output']>;
  numberOptions?: Maybe<TableColumnNumberOptions>;
  options?: Maybe<Array<TableColumnOption>>;
  resizable?: Maybe<Scalars['Boolean']['output']>;
  syncLink?: Maybe<Scalars['Boolean']['output']>;
  system?: Maybe<Scalars['Boolean']['output']>;
  tableId: Scalars['ID']['output'];
  tableRef?: Maybe<Scalars['ID']['output']>;
  type: TableColumnType;
  updatedAt: Scalars['DateTime']['output'];
  valueType: TableColumnValueType;
};

export type TableFilter = {
  __typename?: 'TableFilter';
  conditions: Array<FilterCondition>;
  matchStrategy?: Maybe<FilterMatchStrategy>;
};

export type TableRow = {
  __typename?: 'TableRow';
  _id: Scalars['ID']['output'];
  columns: Array<TableRowColumn>;
  completed: Scalars['Boolean']['output'];
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  completedBy?: Maybe<User>;
  createdAt: Scalars['DateTime']['output'];
  hasComments?: Maybe<Scalars['Boolean']['output']>;
  hasDescription?: Maybe<Scalars['Boolean']['output']>;
  order: Scalars['Int']['output'];
  owner?: Maybe<User>;
  ownerId: Scalars['ID']['output'];
  rowId: Scalars['Int']['output'];
  tableId: Scalars['ID']['output'];
  unreadComments?: Maybe<Scalars['Int']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  updatedBy?: Maybe<Scalars['ID']['output']>;
};

export type TableRowColumn = {
  __typename?: 'TableRowColumn';
  columnId: Scalars['ID']['output'];
  linkValue?: Maybe<Scalars['JSON']['output']>;
  value: Scalars['JSON']['output'];
};

export type TableRowComment = {
  __typename?: 'TableRowComment';
  _id: Scalars['ID']['output'];
  author: Scalars['ID']['output'];
  boardId: Scalars['ID']['output'];
  content?: Maybe<Scalars['String']['output']>;
  contentType?: Maybe<TableColumnCommentType>;
  createdAt: Scalars['DateTime']['output'];
  edited?: Maybe<Scalars['Boolean']['output']>;
  fileName?: Maybe<Scalars['String']['output']>;
  fileSize?: Maybe<Scalars['Int']['output']>;
  mediaRef?: Maybe<Scalars['ID']['output']>;
  mediaThumbnailRef?: Maybe<Scalars['ID']['output']>;
  mentions?: Maybe<Array<Scalars['ID']['output']>>;
  mimeType?: Maybe<Scalars['String']['output']>;
  reactions?: Maybe<Array<TableRowCommentReaction>>;
  replyTo?: Maybe<TableRowComment>;
  room: Scalars['ID']['output'];
  rowId: Scalars['ID']['output'];
  tableId: Scalars['ID']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type TableRowCommentPageInfo = {
  __typename?: 'TableRowCommentPageInfo';
  endCursor?: Maybe<Scalars['String']['output']>;
  hasNextPage?: Maybe<Scalars['Boolean']['output']>;
  hasPreviousPage?: Maybe<Scalars['Boolean']['output']>;
  startCursor?: Maybe<Scalars['String']['output']>;
};

export type TableRowCommentPagination = {
  __typename?: 'TableRowCommentPagination';
  items: Array<TableRowComment>;
  pageInfo: TableRowCommentPageInfo;
};

export type TableRowCommentReaction = {
  __typename?: 'TableRowCommentReaction';
  emoji: Scalars['String']['output'];
  users: Array<Scalars['ID']['output']>;
};

export type TableRowHistory = {
  __typename?: 'TableRowHistory';
  _id: Scalars['ID']['output'];
  after?: Maybe<Scalars['JSON']['output']>;
  author?: Maybe<Scalars['ID']['output']>;
  before?: Maybe<Scalars['JSON']['output']>;
  columnId?: Maybe<Scalars['ID']['output']>;
  createdAt: Scalars['DateTime']['output'];
  data?: Maybe<Scalars['JSON']['output']>;
  rowId: Scalars['ID']['output'];
  tableId: Scalars['ID']['output'];
  workspace: Scalars['ID']['output'];
};

export type TableRowRoomComment = {
  __typename?: 'TableRowRoomComment';
  _id: Scalars['ID']['output'];
  boardId: Scalars['ID']['output'];
  createdBy: Scalars['ID']['output'];
  hasUnreadMessages?: Maybe<Scalars['Boolean']['output']>;
  lastReadMessage?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  participants: Array<WorkspaceParticipant>;
  rowId: Scalars['ID']['output'];
  tableId: Scalars['ID']['output'];
  type?: Maybe<Scalars['String']['output']>;
  workspace: Scalars['ID']['output'];
};

export type TableSortInput = {
  column: Scalars['ID']['input'];
  dir: SortDirection;
};

export type TableView = {
  __typename?: 'TableView';
  _id: Scalars['ID']['output'];
  access?: Maybe<TableViewAccess>;
  boardId: Scalars['ID']['output'];
  columns: Array<TableViewColumn>;
  createdAt: Scalars['DateTime']['output'];
  creator?: Maybe<User>;
  creatorId: Scalars['ID']['output'];
  filter?: Maybe<Scalars['TableFilterInput']['output']>;
  groupBy?: Maybe<Scalars['ID']['output']>;
  order: Scalars['Int']['output'];
  participants?: Maybe<Array<WorkspaceParticipant>>;
  rows: Array<TableRow>;
  showSummary?: Maybe<Scalars['Boolean']['output']>;
  sortBy?: Maybe<Array<TableViewSortInput>>;
  tableId: Scalars['ID']['output'];
  title: Scalars['String']['output'];
  type: TableViewType;
  updatedAt: Scalars['DateTime']['output'];
};

export enum TableViewAccess {
  Everyone = 'EVERYONE',
  Private = 'PRIVATE',
}

export type TableViewColumn = {
  __typename?: 'TableViewColumn';
  _id: Scalars['ID']['output'];
  column: TableColumns;
  columnId: Scalars['ID']['output'];
  fixed?: Maybe<Scalars['Boolean']['output']>;
  hidden?: Maybe<Scalars['Boolean']['output']>;
  order: Scalars['Int']['output'];
  width?: Maybe<Scalars['Int']['output']>;
};

export type TableViewParticipantInput = {
  team?: InputMaybe<Scalars['ID']['input']>;
  user?: InputMaybe<Scalars['ID']['input']>;
};

export type TableViewSort = {
  column: Scalars['ID']['input'];
  direction: SortDirection;
};

export type TableViewSortInput = {
  __typename?: 'TableViewSortInput';
  column: Scalars['ID']['output'];
  direction: SortDirection;
};

export enum TableViewType {
  Calendar = 'CALENDAR',
  Gantt = 'GANTT',
  Kanban = 'KANBAN',
  List = 'LIST',
}

export type Team = {
  __typename?: 'Team';
  _id: Scalars['ID']['output'];
  main: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  participants: Array<User>;
  picture?: Maybe<Scalars['String']['output']>;
  workspace: Workspace;
};

export type TodoItemRecurrence = {
  __typename?: 'TodoItemRecurrence';
  end?: Maybe<Scalars['String']['output']>;
  endAfter?: Maybe<Scalars['Int']['output']>;
  endOn?: Maybe<Scalars['String']['output']>;
  startDate?: Maybe<Scalars['String']['output']>;
  when?: Maybe<Scalars['String']['output']>;
  whenRepeat?: Maybe<Scalars['String']['output']>;
  whenStep?: Maybe<Scalars['Int']['output']>;
  whenWeekDays?: Maybe<Scalars['String']['output']>;
};

export type TodoItems = {
  __typename?: 'TodoItems';
  _id: Scalars['String']['output'];
  color?: Maybe<Scalars['String']['output']>;
  completed?: Maybe<Scalars['Boolean']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  dueDate?: Maybe<Scalars['String']['output']>;
  googleEventId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  list: Scalars['String']['output'];
  order?: Maybe<Scalars['Int']['output']>;
  owner?: Maybe<Scalars['String']['output']>;
  participants?: Maybe<Array<Scalars['String']['output']>>;
  recurrence?: Maybe<Scalars['String']['output']>;
  rrule?: Maybe<Scalars['String']['output']>;
  rruleText?: Maybe<Scalars['String']['output']>;
  tags?: Maybe<Array<TodoTag>>;
  title: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['String']['output']>;
};

export type TodoList = {
  __typename?: 'TodoList';
  _id: Scalars['String']['output'];
  boardId?: Maybe<Scalars['String']['output']>;
  color?: Maybe<Scalars['String']['output']>;
  default?: Maybe<Scalars['String']['output']>;
  googleCalendars?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  icon?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  list?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  participants?: Maybe<Array<Scalars['String']['output']>>;
  tableId?: Maybe<Scalars['String']['output']>;
  tags?: Maybe<Array<TodoTag>>;
};

export type TodoParticipantInput = {
  id: Scalars['String']['input'];
  participants: Array<InputMaybe<Scalars['String']['input']>>;
};

export type TodoTag = {
  __typename?: 'TodoTag';
  _id: Scalars['String']['output'];
  color?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
};

export type TodoTagInput = {
  id: Scalars['String']['input'];
  tagId: Scalars['String']['input'];
};

export type UpdateBoardInput = {
  boardId: Scalars['ID']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  icon?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  picture?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateBoardParticipantInput = {
  boardId: Scalars['ID']['input'];
  participants: Array<Scalars['ID']['input']>;
};

export type UpdateBoardParticipantRoleInput = {
  boardId?: InputMaybe<Scalars['ID']['input']>;
  participantId: Scalars['ID']['input'];
  role: Scalars['String']['input'];
};

export type UpdateBulkTableRowInput = {
  columns?: InputMaybe<Array<UpdateTableRowColumnInput>>;
  rowIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  tableId: Scalars['ID']['input'];
};

export type UpdateCommentTableRowInput = {
  boardId: Scalars['ID']['input'];
  content: Scalars['String']['input'];
  messageId: Scalars['ID']['input'];
  rowId: Scalars['ID']['input'];
  tableId: Scalars['ID']['input'];
};

export type UpdateTableColumnInput = {
  aggregator?: InputMaybe<TableColumnAggregator>;
  canNotify?: InputMaybe<Scalars['Boolean']['input']>;
  columnId: Scalars['ID']['input'];
  columnRef?: InputMaybe<Scalars['ID']['input']>;
  dateType?: InputMaybe<Scalars['String']['input']>;
  defaultValue?: InputMaybe<Scalars['JSON']['input']>;
  field?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<TableColumnFormat>;
  function?: InputMaybe<TableColumnFuctionInput>;
  label: Scalars['String']['input'];
  linkingColumnRef?: InputMaybe<Scalars['ID']['input']>;
  minWidth?: InputMaybe<Scalars['Int']['input']>;
  numberOptions?: InputMaybe<TableColumnNumberOptionsInput>;
  options?: InputMaybe<Array<TableColumnOptionInput>>;
  resizable?: InputMaybe<Scalars['Boolean']['input']>;
  syncLink?: InputMaybe<Scalars['Boolean']['input']>;
  tableId: Scalars['ID']['input'];
  tableRef?: InputMaybe<Scalars['ID']['input']>;
  type?: InputMaybe<TableColumnType>;
  valueType?: InputMaybe<TableColumnValueType>;
};

export type UpdateTableColumnOptionInput = {
  columnId: Scalars['ID']['input'];
  optionData: TableColumnOptionInput;
  optionId: Scalars['ID']['input'];
  tableId: Scalars['ID']['input'];
};

export type UpdateTableInput = {
  boardId: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  tableId: Scalars['ID']['input'];
};

export type UpdateTableRowColumnInput = {
  columnId: Scalars['ID']['input'];
  value?: InputMaybe<Scalars['JSON']['input']>;
};

export type UpdateTableRowInput = {
  _id: Scalars['ID']['input'];
  attachments?: InputMaybe<Array<Scalars['ID']['input']>>;
  columns?: InputMaybe<Array<UpdateTableRowColumnInput>>;
  order?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateTableViewColumnInput = {
  boardId: Scalars['ID']['input'];
  columnId: Scalars['ID']['input'];
  fixed?: InputMaybe<Scalars['Boolean']['input']>;
  hidden?: InputMaybe<Scalars['Boolean']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  tableId: Scalars['ID']['input'];
  viewId: Scalars['ID']['input'];
  width?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateTableViewInput = {
  _id?: InputMaybe<Scalars['ID']['input']>;
  access?: InputMaybe<TableViewAccess>;
  boardId: Scalars['ID']['input'];
  filter?: InputMaybe<Scalars['TableFilterInput']['input']>;
  groupBy?: InputMaybe<Scalars['ID']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  participants?: InputMaybe<Array<Scalars['ID']['input']>>;
  showSummary?: InputMaybe<Scalars['Boolean']['input']>;
  sortBy?: InputMaybe<Array<TableViewSort>>;
  tableId: Scalars['ID']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<TableViewType>;
  viewId: Scalars['ID']['input'];
};

export type UpdateTodoItemsInput = {
  color?: InputMaybe<Scalars['String']['input']>;
  completed?: InputMaybe<Scalars['Boolean']['input']>;
  dueDate?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  list?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  participants?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  recurrence?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateTodoListInput = {
  color?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  participants?: InputMaybe<Array<Scalars['String']['input']>>;
  tags?: InputMaybe<Array<TodoTag>>;
};

export type User = {
  __typename?: 'User';
  _id: Scalars['ID']['output'];
  active?: Maybe<Scalars['Boolean']['output']>;
  email: Scalars['String']['output'];
  lastAccess?: Maybe<Scalars['DateTime']['output']>;
  name: Scalars['String']['output'];
  owner?: Maybe<UserCredentials>;
  picture?: Maybe<Scalars['String']['output']>;
  role: UserRole;
  settings?: Maybe<UserSettings>;
  status?: Maybe<UserStatus>;
  title?: Maybe<Scalars['String']['output']>;
};

export type UserCredentials = {
  __typename?: 'UserCredentials';
  _id: Scalars['ID']['output'];
  email: Scalars['String']['output'];
  name: Scalars['String']['output'];
  password: Scalars['String']['output'];
  phone?: Maybe<Scalars['String']['output']>;
  verified?: Maybe<UserCredentialsVerified>;
  wizard?: Maybe<UserWizard>;
};

export type UserCredentialsVerified = {
  __typename?: 'UserCredentialsVerified';
  email?: Maybe<Scalars['Boolean']['output']>;
  phone?: Maybe<Scalars['Boolean']['output']>;
};

export enum UserRecentFeature {
  AskAi = 'ASK_AI',
  BoardRow = 'BOARD_ROW',
  BoardView = 'BOARD_VIEW',
  DirectMessage = 'DIRECT_MESSAGE',
  Docs = 'DOCS',
  DriveFile = 'DRIVE_FILE',
  DriveFolder = 'DRIVE_FOLDER',
  Settings = 'SETTINGS',
  TextChannel = 'TEXT_CHANNEL',
  ThreadMessage = 'THREAD_MESSAGE',
  TodoItem = 'TODO_ITEM',
  TodoList = 'TODO_LIST',
  VoiceChannel = 'VOICE_CHANNEL',
}

export enum UserRole {
  Admin = 'ADMIN',
  Member = 'MEMBER',
  Owner = 'OWNER',
}

export type UserSettings = {
  __typename?: 'UserSettings';
  themeColorPresets?: Maybe<Scalars['String']['output']>;
  themeContrast?: Maybe<Scalars['String']['output']>;
  themeDirection?: Maybe<Scalars['String']['output']>;
  themeLayout?: Maybe<Scalars['String']['output']>;
  themeMode?: Maybe<Scalars['String']['output']>;
  themeStretch?: Maybe<Scalars['Boolean']['output']>;
};

export enum UserStatus {
  Idle = 'IDLE',
  Invisible = 'INVISIBLE',
  Offline = 'OFFLINE',
  Online = 'ONLINE',
}

export type UserVerificationCode = {
  __typename?: 'UserVerificationCode';
  _id: Scalars['ID']['output'];
  code: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  owner: UserCredentials;
  updatedAt: Scalars['DateTime']['output'];
};

export type UserWizard = {
  __typename?: 'UserWizard';
  completedWizard?: Maybe<Scalars['Boolean']['output']>;
  workspaceInvite?: Maybe<Scalars['Int']['output']>;
};

export type Workspace = {
  __typename?: 'Workspace';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  owner: User;
  pendingInvites?: Maybe<Array<Maybe<WorkspaceInvite>>>;
  picture?: Maybe<Scalars['String']['output']>;
  shortName: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  users?: Maybe<Array<Maybe<User>>>;
};

export type WorkspaceInvite = {
  __typename?: 'WorkspaceInvite';
  email: Scalars['String']['output'];
  expireAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  inviteCode: Scalars['String']['output'];
};

export type WorkspaceParticipant =
  | WorkspaceParticipantTeam
  | WorkspaceParticipantUser;

export type WorkspaceParticipantTeam = {
  __typename?: 'WorkspaceParticipantTeam';
  team: Scalars['ID']['output'];
};

export type WorkspaceParticipantUser = {
  __typename?: 'WorkspaceParticipantUser';
  user: Scalars['ID']['output'];
};

export type DeleteActivitiesMessageMutationVariables = Exact<{
  input: DeleteCommentTableRowInput;
}>;

export type DeleteActivitiesMessageMutation = {
  __typename?: 'Mutation';
  deleteCommentTableRow: {
    __typename?: 'TableRowComment';
    _id: string;
    rowId: string;
    tableId: string;
    author: string;
    content?: string | null;
    contentType?: TableColumnCommentType | null;
    createdAt: any;
  };
};

export type EditActivitiesMessageMutationVariables = Exact<{
  input: UpdateCommentTableRowInput;
}>;

export type EditActivitiesMessageMutation = {
  __typename?: 'Mutation';
  updateCommentTableRow: {
    __typename?: 'TableRowComment';
    _id: string;
    rowId: string;
    tableId: string;
    author: string;
    edited?: boolean | null;
    content?: string | null;
    contentType?: TableColumnCommentType | null;
    mimeType?: string | null;
    mediaRef?: string | null;
    fileName?: string | null;
    fileSize?: number | null;
    mediaThumbnailRef?: string | null;
    mentions?: Array<string> | null;
    createdAt: any;
    reactions?: Array<{
      __typename?: 'TableRowCommentReaction';
      emoji: string;
      users: Array<string>;
    }> | null;
    replyTo?: {
      __typename?: 'TableRowComment';
      _id: string;
      rowId: string;
      tableId: string;
      author: string;
      content?: string | null;
      contentType?: TableColumnCommentType | null;
      createdAt: any;
    } | null;
  };
};

export type ReadLastMessageMutationVariables = Exact<{
  input: ReadLastCommentTableRowInput;
}>;

export type ReadLastMessageMutation = {
  __typename?: 'Mutation';
  readLastCommentTableRow: string;
};

export type ReactActivitiesMessageMutationVariables = Exact<{
  input: ReactionCommentTableRowInput;
}>;

export type ReactActivitiesMessageMutation = {
  __typename?: 'Mutation';
  reactionCommentTableRow: {
    __typename?: 'TableRowComment';
    _id: string;
    rowId: string;
    tableId: string;
    author: string;
    edited?: boolean | null;
    content?: string | null;
    contentType?: TableColumnCommentType | null;
    mimeType?: string | null;
    mediaRef?: string | null;
    fileName?: string | null;
    fileSize?: number | null;
    mediaThumbnailRef?: string | null;
    mentions?: Array<string> | null;
    createdAt: any;
    reactions?: Array<{
      __typename?: 'TableRowCommentReaction';
      emoji: string;
      users: Array<string>;
    }> | null;
    replyTo?: {
      __typename?: 'TableRowComment';
      _id: string;
      rowId: string;
      tableId: string;
      author: string;
      content?: string | null;
      contentType?: TableColumnCommentType | null;
      createdAt: any;
    } | null;
  };
};

export type TableRowActivitiesQueryVariables = Exact<{
  input: QueryTableRowCommentInput;
}>;

export type TableRowActivitiesQuery = {
  __typename?: 'Query';
  tableRowComments: {
    __typename?: 'TableRowCommentPagination';
    items: Array<{
      __typename?: 'TableRowComment';
      _id: string;
      rowId: string;
      tableId: string;
      author: string;
      edited?: boolean | null;
      content?: string | null;
      contentType?: TableColumnCommentType | null;
      mimeType?: string | null;
      mediaRef?: string | null;
      fileName?: string | null;
      fileSize?: number | null;
      mediaThumbnailRef?: string | null;
      mentions?: Array<string> | null;
      createdAt: any;
      reactions?: Array<{
        __typename?: 'TableRowCommentReaction';
        emoji: string;
        users: Array<string>;
      }> | null;
      replyTo?: {
        __typename?: 'TableRowComment';
        _id: string;
        rowId: string;
        tableId: string;
        author: string;
        content?: string | null;
        contentType?: TableColumnCommentType | null;
        createdAt: any;
      } | null;
    }>;
    pageInfo: {
      __typename?: 'TableRowCommentPageInfo';
      startCursor?: string | null;
      endCursor?: string | null;
      hasNextPage?: boolean | null;
      hasPreviousPage?: boolean | null;
    };
  };
};

export type SendActivitiesMessageMutationVariables = Exact<{
  input: SendCommentTableRowInput;
}>;

export type SendActivitiesMessageMutation = {
  __typename?: 'Mutation';
  sendCommentTableRow: {
    __typename?: 'TableRowComment';
    _id: string;
    rowId: string;
    tableId: string;
    author: string;
    edited?: boolean | null;
    content?: string | null;
    contentType?: TableColumnCommentType | null;
    mimeType?: string | null;
    mediaRef?: string | null;
    fileName?: string | null;
    fileSize?: number | null;
    mediaThumbnailRef?: string | null;
    mentions?: Array<string> | null;
    createdAt: any;
    reactions?: Array<{
      __typename?: 'TableRowCommentReaction';
      emoji: string;
      users: Array<string>;
    }> | null;
    replyTo?: {
      __typename?: 'TableRowComment';
      _id: string;
      rowId: string;
      tableId: string;
      author: string;
      content?: string | null;
      contentType?: TableColumnCommentType | null;
      createdAt: any;
    } | null;
  };
};

export type TableRowHistoriesDataQueryVariables = Exact<{
  input: QueryTableRowHistoryInput;
}>;

export type TableRowHistoriesDataQuery = {
  __typename?: 'Query';
  tableRowHistory: Array<{
    __typename?: 'TableRowHistory';
    _id: string;
    rowId: string;
    tableId: string;
    workspace: string;
    columnId?: string | null;
    author?: string | null;
    after?: any | null;
    before?: any | null;
    data?: any | null;
    createdAt: any;
  } | null>;
};

export type TableRowRoomDataQueryVariables = Exact<{
  input: QueryTableRowRoomInput;
}>;

export type TableRowRoomDataQuery = {
  __typename?: 'Query';
  tableRowRoom: {
    __typename?: 'TableRowRoomComment';
    _id: string;
    rowId: string;
    boardId: string;
    tableId: string;
    name?: string | null;
    type?: string | null;
    workspace: string;
    createdBy: string;
    lastReadMessage?: string | null;
    hasUnreadMessages?: boolean | null;
    participants: Array<
      | { __typename?: 'WorkspaceParticipantTeam'; team: string }
      | { __typename?: 'WorkspaceParticipantUser'; user: string }
    >;
  };
};

export type BoardsQueryVariables = Exact<{ [key: string]: never }>;

export type BoardsQuery = {
  __typename?: 'Query';
  boards: Array<{
    __typename?: 'Board';
    _id: string;
    name: string;
    icon?: string | null;
    pinned?: boolean | null;
    createdAt: any;
    updatedAt: any;
    tables: Array<{
      __typename?: 'Table';
      _id: string;
      name: string;
      board: string;
      views: Array<{
        __typename?: 'TableView';
        _id: string;
        type: TableViewType;
        title: string;
      }>;
    }>;
  }>;
};

export type TableRowQueryQueryVariables = Exact<{
  rowId: Scalars['ID']['input'];
  tableId: Scalars['ID']['input'];
  boardId: Scalars['ID']['input'];
}>;

export type TableRowQueryQuery = {
  __typename?: 'Query';
  row: {
    __typename?: 'TableRow';
    _id: string;
    rowId: number;
    tableId: string;
    order: number;
    ownerId: string;
    unreadComments?: number | null;
    hasComments?: boolean | null;
    hasDescription?: boolean | null;
    createdAt: any;
    updatedAt: any;
    updatedBy?: string | null;
    columns: Array<{
      __typename?: 'TableRowColumn';
      columnId: string;
      value: any;
      linkValue?: any | null;
    }>;
  };
  board: {
    __typename?: 'Board';
    _id: string;
    name: string;
    roles?: {
      __typename?: 'BoardRoles';
      admin?: any | null;
      member?: any | null;
      viewer?: any | null;
      edit_all?: any | null;
      edit_own?: any | null;
      edit_unassigned?: any | null;
      view_all?: any | null;
      view_own?: any | null;
      view_unassigned?: any | null;
    } | null;
    participants: Array<
      | { __typename?: 'WorkspaceParticipantTeam'; team: string }
      | { __typename?: 'WorkspaceParticipantUser'; user: string }
    >;
  };
  table: {
    __typename?: 'Table';
    _id: string;
    name: string;
    columns: Array<{
      __typename?: 'TableColumns';
      _id: string;
      system?: boolean | null;
      resizable?: boolean | null;
      tableId: string;
      field?: string | null;
      type: TableColumnType;
      valueType: TableColumnValueType;
      minWidth?: number | null;
      label: string;
      tableRef?: string | null;
      canNotify?: boolean | null;
      syncLink?: boolean | null;
      columnRef?: string | null;
      linkingColumnRef?: string | null;
      defaultValue?: any | null;
      aggregator?: TableColumnAggregator | null;
      format?: TableColumnFormat | null;
      options?: Array<{
        __typename?: 'TableColumnOption';
        _id: string;
        label: string;
        color: string;
        order: number;
        system?: boolean | null;
        statusGroup?: TableColumnOptionStatusGroup | null;
      }> | null;
      columnRefValue?: {
        __typename?: 'TableColumns';
        _id: string;
        system?: boolean | null;
        resizable?: boolean | null;
        tableId: string;
        field?: string | null;
        type: TableColumnType;
        valueType: TableColumnValueType;
        minWidth?: number | null;
        label: string;
        tableRef?: string | null;
        columnRef?: string | null;
        options?: Array<{
          __typename?: 'TableColumnOption';
          _id: string;
          label: string;
          color: string;
          order: number;
          system?: boolean | null;
          statusGroup?: TableColumnOptionStatusGroup | null;
        }> | null;
      } | null;
      function?: {
        __typename?: 'TableColumnFuction';
        operator: TableColumnFuctionOperator;
        columns: Array<string>;
        result?: number | null;
      } | null;
      numberOptions?: {
        __typename?: 'TableColumnNumberOptions';
        decimalPlaces?: number | null;
        prefix?: string | null;
        suffix?: string | null;
        separator?: TableColumnNumberSeparator | null;
        allowNegative?: boolean | null;
      } | null;
      linkForm?: {
        __typename?: 'TableColumnLinkForm';
        label?: string | null;
        linkColumnId: string;
        fields: Array<{
          __typename?: 'TableColumnLinkFormField';
          columnId: string;
          visible: boolean;
          required: boolean;
          defaultValue?: any | null;
        }>;
      } | null;
    }>;
    views: Array<{
      __typename?: 'TableView';
      _id: string;
      title: string;
      type: TableViewType;
      creatorId: string;
      groupBy?: string | null;
      filter?: any | null;
      order: number;
      access?: TableViewAccess | null;
      showSummary?: boolean | null;
      columns: Array<{
        __typename?: 'TableViewColumn';
        _id: string;
        columnId: string;
        order: number;
        fixed?: boolean | null;
        width?: number | null;
        hidden?: boolean | null;
      }>;
      sortBy?: Array<{
        __typename?: 'TableViewSortInput';
        column: string;
        direction: SortDirection;
      }> | null;
      participants?: Array<
        | { __typename?: 'WorkspaceParticipantTeam'; team: string }
        | { __typename?: 'WorkspaceParticipantUser'; user: string }
      > | null;
    }>;
  };
};

export type CreateTableRowMutationVariables = Exact<{
  input: CreateTableRowInput;
}>;

export type CreateTableRowMutation = {
  __typename?: 'Mutation';
  createTableRow: {
    __typename?: 'TableRow';
    _id: string;
    rowId: number;
    tableId: string;
    order: number;
    ownerId: string;
    unreadComments?: number | null;
    hasComments?: boolean | null;
    hasDescription?: boolean | null;
    createdAt: any;
    updatedAt: any;
    updatedBy?: string | null;
    columns: Array<{
      __typename?: 'TableRowColumn';
      columnId: string;
      value: any;
      linkValue?: any | null;
    }>;
  };
};

export type TodoListItemFragment = {
  __typename?: 'TodoList';
  _id: string;
  name: string;
  list?: string | null;
  order: number;
  default?: string | null;
  id?: string | null;
  participants?: Array<string> | null;
  color?: string | null;
  icon?: string | null;
  tags?: Array<{
    __typename?: 'TodoTag';
    _id: string;
    name: string;
    color?: string | null;
  }> | null;
};

export type TodoItemFragment = {
  __typename?: 'TodoItems';
  _id: string;
  title: string;
  completed?: boolean | null;
  createdAt?: string | null;
  description?: string | null;
  dueDate?: string | null;
  list: string;
  owner?: string | null;
  googleEventId?: string | null;
  participants?: Array<string> | null;
  updatedAt?: string | null;
  recurrence?: string | null;
  order?: number | null;
  rrule?: string | null;
  id?: string | null;
  color?: string | null;
  tags?: Array<{
    __typename?: 'TodoTag';
    _id: string;
    name: string;
    color?: string | null;
  }> | null;
};

export type CreateTodoItemsMutationVariables = Exact<{
  input: CreateTodoItemsInput;
}>;

export type CreateTodoItemsMutation = {
  __typename?: 'Mutation';
  createTodoItems: {
    __typename?: 'TodoItems';
    _id: string;
    title: string;
    completed?: boolean | null;
    createdAt?: string | null;
    description?: string | null;
    dueDate?: string | null;
    list: string;
    owner?: string | null;
    googleEventId?: string | null;
    participants?: Array<string> | null;
    updatedAt?: string | null;
    recurrence?: string | null;
    order?: number | null;
    rrule?: string | null;
    id?: string | null;
    color?: string | null;
    tags?: Array<{
      __typename?: 'TodoTag';
      _id: string;
      name: string;
      color?: string | null;
    }> | null;
  };
};

export type NewTodoItemFragment = {
  __typename?: 'TodoItems';
  _id: string;
  title: string;
  list: string;
};

export type DeleteTodoItemsMutationVariables = Exact<{
  input: DeleteTodoItemsInput;
}>;

export type DeleteTodoItemsMutation = {
  __typename?: 'Mutation';
  deleteTodoItems: {
    __typename?: 'TodoItems';
    _id: string;
    title: string;
    completed?: boolean | null;
    createdAt?: string | null;
    description?: string | null;
    dueDate?: string | null;
    list: string;
    owner?: string | null;
    googleEventId?: string | null;
    participants?: Array<string> | null;
    updatedAt?: string | null;
    recurrence?: string | null;
    order?: number | null;
    rrule?: string | null;
    id?: string | null;
    color?: string | null;
    tags?: Array<{
      __typename?: 'TodoTag';
      _id: string;
      name: string;
      color?: string | null;
    }> | null;
  };
};

export type LeaveTodoItemsMutationVariables = Exact<{
  input: LeaveTodoListInput;
}>;

export type LeaveTodoItemsMutation = {
  __typename?: 'Mutation';
  leaveTodoItems: {
    __typename?: 'TodoItems';
    _id: string;
    title: string;
    completed?: boolean | null;
    createdAt?: string | null;
    description?: string | null;
    dueDate?: string | null;
    list: string;
    owner?: string | null;
    googleEventId?: string | null;
    participants?: Array<string> | null;
    updatedAt?: string | null;
    recurrence?: string | null;
    order?: number | null;
    rrule?: string | null;
    id?: string | null;
    color?: string | null;
    tags?: Array<{
      __typename?: 'TodoTag';
      _id: string;
      name: string;
      color?: string | null;
    }> | null;
  };
};

export type TodoItemsQueryVariables = Exact<{
  queryParams: Scalars['String']['input'];
  listId: Scalars['String']['input'];
}>;

export type TodoItemsQuery = {
  __typename?: 'Query';
  todoItems: Array<{
    __typename?: 'TodoItems';
    _id: string;
    title: string;
    completed?: boolean | null;
    createdAt?: string | null;
    description?: string | null;
    dueDate?: string | null;
    list: string;
    owner?: string | null;
    participants?: Array<string> | null;
    updatedAt?: string | null;
    recurrence?: string | null;
    order?: number | null;
    rrule?: string | null;
    color?: string | null;
    tags?: Array<{
      __typename?: 'TodoTag';
      _id: string;
      name: string;
      color?: string | null;
    }> | null;
  }>;
};

export type UpdateTodoItemsMutationVariables = Exact<{
  input: UpdateTodoItemsInput;
}>;

export type UpdateTodoItemsMutation = {
  __typename?: 'Mutation';
  updateTodoItems: {
    __typename?: 'TodoItems';
    _id: string;
    title: string;
    completed?: boolean | null;
    createdAt?: string | null;
    description?: string | null;
    dueDate?: string | null;
    list: string;
    owner?: string | null;
    googleEventId?: string | null;
    participants?: Array<string> | null;
    updatedAt?: string | null;
    recurrence?: string | null;
    order?: number | null;
    rrule?: string | null;
    id?: string | null;
    color?: string | null;
    tags?: Array<{
      __typename?: 'TodoTag';
      _id: string;
      name: string;
      color?: string | null;
    }> | null;
  };
};

export type UpdateTodoItemColorMutationVariables = Exact<{
  input: UpdateTodoItemsInput;
}>;

export type UpdateTodoItemColorMutation = {
  __typename?: 'Mutation';
  updateTodoItems: {
    __typename?: 'TodoItems';
    _id: string;
    color?: string | null;
  };
};

export type UpdateTodoItemDueDateMutationVariables = Exact<{
  input: UpdateTodoItemsInput;
}>;

export type UpdateTodoItemDueDateMutation = {
  __typename?: 'Mutation';
  updateTodoItems: {
    __typename?: 'TodoItems';
    _id: string;
    dueDate?: string | null;
  };
};

export type UpdateTodoItemMovedMutationVariables = Exact<{
  input: UpdateTodoItemsInput;
}>;

export type UpdateTodoItemMovedMutation = {
  __typename?: 'Mutation';
  updateTodoItems: {
    __typename?: 'TodoItems';
    _id: string;
    dueDate?: string | null;
    order?: number | null;
    list: string;
  };
};

export type CreateTodoListMutationVariables = Exact<{
  input: CreateTodoListInput;
}>;

export type CreateTodoListMutation = {
  __typename?: 'Mutation';
  createTodoList: {
    __typename?: 'TodoList';
    _id: string;
    name: string;
    list?: string | null;
    order: number;
    default?: string | null;
    id?: string | null;
    participants?: Array<string> | null;
    color?: string | null;
    icon?: string | null;
    tags?: Array<{
      __typename?: 'TodoTag';
      _id: string;
      name: string;
      color?: string | null;
    }> | null;
  };
};

export type UpdateTodoListMutationVariables = Exact<{
  input: UpdateTodoListInput;
}>;

export type UpdateTodoListMutation = {
  __typename?: 'Mutation';
  updateTodoList: {
    __typename?: 'TodoList';
    _id: string;
    name: string;
    list?: string | null;
    order: number;
    default?: string | null;
    id?: string | null;
    participants?: Array<string> | null;
    color?: string | null;
    icon?: string | null;
    tags?: Array<{
      __typename?: 'TodoTag';
      _id: string;
      name: string;
      color?: string | null;
    }> | null;
  };
};

export type DeleteTodoListMutationVariables = Exact<{
  input: DeleteTodoListInput;
}>;

export type DeleteTodoListMutation = {
  __typename?: 'Mutation';
  deleteTodoList: {
    __typename?: 'TodoList';
    _id: string;
    name: string;
    list?: string | null;
    order: number;
    default?: string | null;
    id?: string | null;
    participants?: Array<string> | null;
    color?: string | null;
    icon?: string | null;
    tags?: Array<{
      __typename?: 'TodoTag';
      _id: string;
      name: string;
      color?: string | null;
    }> | null;
  };
};

export type NewTodoFragment = {
  __typename?: 'TodoList';
  _id: string;
  name: string;
  list?: string | null;
  order: number;
};

export type TodoListQueryVariables = Exact<{ [key: string]: never }>;

export type TodoListQuery = {
  __typename?: 'Query';
  todoList: Array<{
    __typename?: 'TodoList';
    _id: string;
    name: string;
    list?: string | null;
    default?: string | null;
    order: number;
    googleCalendars?: Array<string | null> | null;
    participants?: Array<string> | null;
    color?: string | null;
    icon?: string | null;
    boardId?: string | null;
    tableId?: string | null;
    tags?: Array<{
      __typename?: 'TodoTag';
      _id: string;
      name: string;
      color?: string | null;
    }> | null;
  }>;
};

export type UpdateTodoParticipantMutationVariables = Exact<{
  input: TodoParticipantInput;
}>;

export type UpdateTodoParticipantMutation = {
  __typename?: 'Mutation';
  updateTodoParticipant: {
    __typename?: 'TodoItems';
    _id: string;
    title: string;
    completed?: boolean | null;
    createdAt?: string | null;
    description?: string | null;
    dueDate?: string | null;
    list: string;
    owner?: string | null;
    googleEventId?: string | null;
    participants?: Array<string> | null;
    updatedAt?: string | null;
    recurrence?: string | null;
    order?: number | null;
    rrule?: string | null;
    id?: string | null;
    color?: string | null;
    tags?: Array<{
      __typename?: 'TodoTag';
      _id: string;
      name: string;
      color?: string | null;
    }> | null;
  };
};

export type DeleteTodoParticipantMutationVariables = Exact<{
  input: TodoParticipantInput;
}>;

export type DeleteTodoParticipantMutation = {
  __typename?: 'Mutation';
  deleteTodoParticipant: {
    __typename?: 'TodoItems';
    _id: string;
    title: string;
    completed?: boolean | null;
    createdAt?: string | null;
    description?: string | null;
    dueDate?: string | null;
    list: string;
    owner?: string | null;
    googleEventId?: string | null;
    participants?: Array<string> | null;
    updatedAt?: string | null;
    recurrence?: string | null;
    order?: number | null;
    rrule?: string | null;
    id?: string | null;
    color?: string | null;
    tags?: Array<{
      __typename?: 'TodoTag';
      _id: string;
      name: string;
      color?: string | null;
    }> | null;
  };
};

export type TodoRecurrenceItemsQueryVariables = Exact<{
  queryParams: Scalars['String']['input'];
}>;

export type TodoRecurrenceItemsQuery = {
  __typename?: 'Query';
  todoRecurrenceItems: Array<{
    __typename?: 'TodoItems';
    _id: string;
    title: string;
    completed?: boolean | null;
    createdAt?: string | null;
    description?: string | null;
    dueDate?: string | null;
    list: string;
    owner?: string | null;
    participants?: Array<string> | null;
    updatedAt?: string | null;
    recurrence?: string | null;
    rrule?: string | null;
    rruleText?: string | null;
    tags?: Array<{
      __typename?: 'TodoTag';
      _id: string;
      name: string;
      color?: string | null;
    }> | null;
  }>;
};

export type SyncTodoBoardsMutationVariables = Exact<{
  input: SyncTodoBoardsInput;
}>;

export type SyncTodoBoardsMutation = {
  __typename?: 'Mutation';
  syncTodoBoards: Array<{
    __typename?: 'TodoList';
    _id: string;
    name: string;
    list?: string | null;
    order: number;
    default?: string | null;
    id?: string | null;
    participants?: Array<string> | null;
    color?: string | null;
    icon?: string | null;
    tags?: Array<{
      __typename?: 'TodoTag';
      _id: string;
      name: string;
      color?: string | null;
    }> | null;
  }>;
};

export type UpdateTodoTagMutationVariables = Exact<{
  input: TodoTagInput;
}>;

export type UpdateTodoTagMutation = {
  __typename?: 'Mutation';
  updateTodoTag: {
    __typename?: 'TodoItems';
    _id: string;
    title: string;
    completed?: boolean | null;
    createdAt?: string | null;
    description?: string | null;
    dueDate?: string | null;
    list: string;
    owner?: string | null;
    googleEventId?: string | null;
    participants?: Array<string> | null;
    updatedAt?: string | null;
    recurrence?: string | null;
    order?: number | null;
    rrule?: string | null;
    id?: string | null;
    color?: string | null;
    tags?: Array<{
      __typename?: 'TodoTag';
      _id: string;
      name: string;
      color?: string | null;
    }> | null;
  };
};

export type DeleteTodoTagMutationVariables = Exact<{
  input: TodoTagInput;
}>;

export type DeleteTodoTagMutation = {
  __typename?: 'Mutation';
  deleteTodoTag: {
    __typename?: 'TodoItems';
    _id: string;
    title: string;
    completed?: boolean | null;
    createdAt?: string | null;
    description?: string | null;
    dueDate?: string | null;
    list: string;
    owner?: string | null;
    googleEventId?: string | null;
    participants?: Array<string> | null;
    updatedAt?: string | null;
    recurrence?: string | null;
    order?: number | null;
    rrule?: string | null;
    id?: string | null;
    color?: string | null;
    tags?: Array<{
      __typename?: 'TodoTag';
      _id: string;
      name: string;
      color?: string | null;
    }> | null;
  };
};

export type BoardAddMemberMutationVariables = Exact<{
  input: UpdateBoardParticipantInput;
}>;

export type BoardAddMemberMutation = {
  __typename?: 'Mutation';
  addBoardParticipant: {
    __typename?: 'Board';
    _id: string;
    participants: Array<
      | { __typename?: 'WorkspaceParticipantTeam'; team: string }
      | { __typename?: 'WorkspaceParticipantUser'; user: string }
    >;
  };
};

export type BoardInfoEditMutationVariables = Exact<{
  input: UpdateBoardInput;
}>;

export type BoardInfoEditMutation = {
  __typename?: 'Mutation';
  updateBoard: {
    __typename?: 'Board';
    _id: string;
    name: string;
    icon?: string | null;
    picture?: string | null;
    description?: string | null;
  };
};

export type BoardRemoveMemberMutationVariables = Exact<{
  input: UpdateBoardParticipantInput;
}>;

export type BoardRemoveMemberMutation = {
  __typename?: 'Mutation';
  removeBoardParticipant: {
    __typename?: 'Board';
    _id: string;
    participants: Array<
      | { __typename?: 'WorkspaceParticipantTeam'; team: string }
      | { __typename?: 'WorkspaceParticipantUser'; user: string }
    >;
  };
};

export type UpdateBoardParticipantRoleMutationVariables = Exact<{
  input: UpdateBoardParticipantRoleInput;
}>;

export type UpdateBoardParticipantRoleMutation = {
  __typename?: 'Mutation';
  updateBoardParticipantRole: {
    __typename?: 'Board';
    _id: string;
    roles?: {
      __typename?: 'BoardRoles';
      admin?: any | null;
      member?: any | null;
      viewer?: any | null;
      edit_all?: any | null;
      edit_own?: any | null;
      edit_unassigned?: any | null;
      view_all?: any | null;
      view_own?: any | null;
      view_unassigned?: any | null;
    } | null;
    participants: Array<
      | { __typename?: 'WorkspaceParticipantTeam'; team: string }
      | { __typename?: 'WorkspaceParticipantUser'; user: string }
    >;
  };
};

export type BoardDetailsQueryVariables = Exact<{
  boardId: Scalars['ID']['input'];
}>;

export type BoardDetailsQuery = {
  __typename?: 'Query';
  board: {
    __typename?: 'Board';
    _id: string;
    name: string;
    description?: string | null;
    picture?: string | null;
    icon?: string | null;
    pinned?: boolean | null;
    roles?: {
      __typename?: 'BoardRoles';
      admin?: any | null;
      member?: any | null;
      viewer?: any | null;
      edit_all?: any | null;
      edit_own?: any | null;
      edit_unassigned?: any | null;
      view_all?: any | null;
      view_own?: any | null;
      view_unassigned?: any | null;
    } | null;
    participants: Array<
      | { __typename?: 'WorkspaceParticipantTeam'; team: string }
      | { __typename?: 'WorkspaceParticipantUser'; user: string }
    >;
  };
};

export type FormTableColumnsFragment = {
  __typename?: 'Table';
  _id: string;
  columns: Array<{
    __typename?: 'TableColumns';
    _id: string;
    system?: boolean | null;
    resizable?: boolean | null;
    tableId: string;
    field?: string | null;
    type: TableColumnType;
    valueType: TableColumnValueType;
    minWidth?: number | null;
    label: string;
    tableRef?: string | null;
    canNotify?: boolean | null;
    syncLink?: boolean | null;
    columnRef?: string | null;
    linkingColumnRef?: string | null;
    defaultValue?: any | null;
    aggregator?: TableColumnAggregator | null;
    format?: TableColumnFormat | null;
    options?: Array<{
      __typename?: 'TableColumnOption';
      _id: string;
      label: string;
      color: string;
      order: number;
      system?: boolean | null;
      statusGroup?: TableColumnOptionStatusGroup | null;
    }> | null;
    columnRefValue?: {
      __typename?: 'TableColumns';
      _id: string;
      system?: boolean | null;
      resizable?: boolean | null;
      tableId: string;
      field?: string | null;
      type: TableColumnType;
      valueType: TableColumnValueType;
      minWidth?: number | null;
      label: string;
      tableRef?: string | null;
      columnRef?: string | null;
      options?: Array<{
        __typename?: 'TableColumnOption';
        _id: string;
        label: string;
        color: string;
        order: number;
        system?: boolean | null;
        statusGroup?: TableColumnOptionStatusGroup | null;
      }> | null;
    } | null;
    function?: {
      __typename?: 'TableColumnFuction';
      operator: TableColumnFuctionOperator;
      columns: Array<string>;
      result?: number | null;
    } | null;
    numberOptions?: {
      __typename?: 'TableColumnNumberOptions';
      decimalPlaces?: number | null;
      prefix?: string | null;
      suffix?: string | null;
      separator?: TableColumnNumberSeparator | null;
      allowNegative?: boolean | null;
    } | null;
    linkForm?: {
      __typename?: 'TableColumnLinkForm';
      label?: string | null;
      linkColumnId: string;
      fields: Array<{
        __typename?: 'TableColumnLinkFormField';
        columnId: string;
        visible: boolean;
        required: boolean;
        defaultValue?: any | null;
      }>;
    } | null;
  }>;
};

export type FormViewFragment = {
  __typename?: 'TableView';
  _id: string;
  title: string;
  access?: TableViewAccess | null;
  groupBy?: string | null;
  showSummary?: boolean | null;
  type: TableViewType;
  participants?: Array<
    | { __typename?: 'WorkspaceParticipantTeam'; team: string }
    | { __typename?: 'WorkspaceParticipantUser'; user: string }
  > | null;
  columns: Array<{
    __typename?: 'TableViewColumn';
    _id: string;
    columnId: string;
    order: number;
    fixed?: boolean | null;
    width?: number | null;
    hidden?: boolean | null;
  }>;
};

export type FormTableFragment = {
  __typename?: 'Table';
  _id: string;
  name: string;
  views: Array<{ __typename?: 'TableView'; _id: string; order: number }>;
};

export type TableViewImportMutationMutationVariables = Exact<{
  input: ImportBulkTableInput;
}>;

export type TableViewImportMutationMutation = {
  __typename?: 'Mutation';
  importBulkTableRow: Array<{
    __typename?: 'TableRow';
    _id: string;
    rowId: number;
    tableId: string;
    order: number;
    ownerId: string;
    unreadComments?: number | null;
    hasComments?: boolean | null;
    hasDescription?: boolean | null;
    createdAt: any;
    updatedAt: any;
    updatedBy?: string | null;
    columns: Array<{
      __typename?: 'TableRowColumn';
      columnId: string;
      value: any;
      linkValue?: any | null;
    }>;
  }>;
};

export type TableViewDeleteMutationVariables = Exact<{
  input: DeleteTableViewInput;
}>;

export type TableViewDeleteMutation = {
  __typename?: 'Mutation';
  deleteTableView: boolean;
};

export type TableViewDataQueryVariables = Exact<{
  input: QueryTableViewInput;
}>;

export type TableViewDataQuery = {
  __typename?: 'Query';
  tableView: {
    __typename?: 'TableView';
    _id: string;
    title: string;
    type: TableViewType;
    creatorId: string;
    groupBy?: string | null;
    filter?: any | null;
    order: number;
    access?: TableViewAccess | null;
    showSummary?: boolean | null;
    rows: Array<{
      __typename?: 'TableRow';
      _id: string;
      rowId: number;
      tableId: string;
      order: number;
      ownerId: string;
      unreadComments?: number | null;
      hasComments?: boolean | null;
      hasDescription?: boolean | null;
      createdAt: any;
      updatedAt: any;
      updatedBy?: string | null;
      columns: Array<{
        __typename?: 'TableRowColumn';
        columnId: string;
        value: any;
        linkValue?: any | null;
      }>;
    }>;
    columns: Array<{
      __typename?: 'TableViewColumn';
      _id: string;
      columnId: string;
      order: number;
      fixed?: boolean | null;
      width?: number | null;
      hidden?: boolean | null;
    }>;
    sortBy?: Array<{
      __typename?: 'TableViewSortInput';
      column: string;
      direction: SortDirection;
    }> | null;
    participants?: Array<
      | { __typename?: 'WorkspaceParticipantTeam'; team: string }
      | { __typename?: 'WorkspaceParticipantUser'; user: string }
    > | null;
  };
};

export type UpdateTableViewMutationVariables = Exact<{
  input: UpdateTableViewInput;
}>;

export type UpdateTableViewMutation = {
  __typename?: 'Mutation';
  updateTableView: {
    __typename?: 'TableView';
    _id: string;
    title: string;
    type: TableViewType;
    creatorId: string;
    groupBy?: string | null;
    filter?: any | null;
    order: number;
    access?: TableViewAccess | null;
    showSummary?: boolean | null;
    sortBy?: Array<{
      __typename?: 'TableViewSortInput';
      column: string;
      direction: SortDirection;
    }> | null;
    participants?: Array<
      | { __typename?: 'WorkspaceParticipantTeam'; team: string }
      | { __typename?: 'WorkspaceParticipantUser'; user: string }
    > | null;
  };
};

export type BoardDataQueryVariables = Exact<{
  boardId: Scalars['ID']['input'];
}>;

export type BoardDataQuery = {
  __typename?: 'Query';
  board: {
    __typename?: 'Board';
    _id: string;
    name: string;
    icon?: string | null;
    description?: string | null;
    picture?: string | null;
    pinned?: boolean | null;
    tables: Array<{
      __typename?: 'Table';
      _id: string;
      name: string;
      board: string;
      order: number;
      activeAutomations: number;
      views: Array<{ __typename?: 'TableView'; _id: string }>;
    }>;
    roles?: {
      __typename?: 'BoardRoles';
      admin?: any | null;
      member?: any | null;
      viewer?: any | null;
      edit_all?: any | null;
      edit_own?: any | null;
      edit_unassigned?: any | null;
      view_all?: any | null;
      view_own?: any | null;
      view_unassigned?: any | null;
    } | null;
    participants: Array<
      | { __typename?: 'WorkspaceParticipantTeam'; team: string }
      | { __typename?: 'WorkspaceParticipantUser'; user: string }
    >;
  };
};

export type RowMembersValueFragment = {
  __typename?: 'TableRow';
  _id: string;
  columns: Array<{
    __typename?: 'TableRowColumn';
    columnId: string;
    value: any;
  }>;
};

export type CreateBoardMutationMutationVariables = Exact<{
  input: CreateBoardInput;
}>;

export type CreateBoardMutationMutation = {
  __typename?: 'Mutation';
  createBoard: {
    __typename?: 'Board';
    _id: string;
    name: string;
    icon?: string | null;
  };
};

export type NewBoardFragment = {
  __typename?: 'Board';
  _id: string;
  name: string;
  icon?: string | null;
};

export type CreateBoardTableMutationVariables = Exact<{
  input: CreateTableInput;
}>;

export type CreateBoardTableMutation = {
  __typename?: 'Mutation';
  createTable: {
    __typename?: 'Table';
    _id: string;
    name: string;
    board: string;
  };
};

export type NewTableFragmentFragment = {
  __typename?: 'Table';
  _id: string;
  name: string;
  board: string;
};

export type RowMultiValueFragment = {
  __typename?: 'TableRow';
  _id: string;
  columns: Array<{
    __typename?: 'TableRowColumn';
    columnId: string;
    value: any;
  }>;
};

export type TableColumnFragment = {
  __typename?: 'TableColumns';
  _id: string;
  system?: boolean | null;
  resizable?: boolean | null;
  tableId: string;
  field?: string | null;
  type: TableColumnType;
  valueType: TableColumnValueType;
  minWidth?: number | null;
  label: string;
  tableRef?: string | null;
  canNotify?: boolean | null;
  syncLink?: boolean | null;
  columnRef?: string | null;
  linkingColumnRef?: string | null;
  defaultValue?: any | null;
  aggregator?: TableColumnAggregator | null;
  format?: TableColumnFormat | null;
  options?: Array<{
    __typename?: 'TableColumnOption';
    _id: string;
    label: string;
    color: string;
    order: number;
    system?: boolean | null;
    statusGroup?: TableColumnOptionStatusGroup | null;
  }> | null;
  columnRefValue?: {
    __typename?: 'TableColumns';
    _id: string;
    system?: boolean | null;
    resizable?: boolean | null;
    tableId: string;
    field?: string | null;
    type: TableColumnType;
    valueType: TableColumnValueType;
    minWidth?: number | null;
    label: string;
    tableRef?: string | null;
    columnRef?: string | null;
    options?: Array<{
      __typename?: 'TableColumnOption';
      _id: string;
      label: string;
      color: string;
      order: number;
      system?: boolean | null;
      statusGroup?: TableColumnOptionStatusGroup | null;
    }> | null;
  } | null;
  function?: {
    __typename?: 'TableColumnFuction';
    operator: TableColumnFuctionOperator;
    columns: Array<string>;
    result?: number | null;
  } | null;
  numberOptions?: {
    __typename?: 'TableColumnNumberOptions';
    decimalPlaces?: number | null;
    prefix?: string | null;
    suffix?: string | null;
    separator?: TableColumnNumberSeparator | null;
    allowNegative?: boolean | null;
  } | null;
  linkForm?: {
    __typename?: 'TableColumnLinkForm';
    label?: string | null;
    linkColumnId: string;
    fields: Array<{
      __typename?: 'TableColumnLinkFormField';
      columnId: string;
      visible: boolean;
      required: boolean;
      defaultValue?: any | null;
    }>;
  } | null;
};

export type TableColumnLinkFormFieldFragment = {
  __typename?: 'TableColumnLinkFormField';
  columnId: string;
  visible: boolean;
  required: boolean;
  defaultValue?: any | null;
};

export type TableColumnOptionFragment = {
  __typename?: 'TableColumnOption';
  _id: string;
  label: string;
  color: string;
  order: number;
  system?: boolean | null;
  statusGroup?: TableColumnOptionStatusGroup | null;
};

export type TableFragment = {
  __typename?: 'Table';
  _id: string;
  name: string;
  board: string;
  order: number;
};

export type TableRowFragment = {
  __typename?: 'TableRow';
  _id: string;
  rowId: number;
  tableId: string;
  order: number;
  ownerId: string;
  unreadComments?: number | null;
  hasComments?: boolean | null;
  hasDescription?: boolean | null;
  createdAt: any;
  updatedAt: any;
  updatedBy?: string | null;
  columns: Array<{
    __typename?: 'TableRowColumn';
    columnId: string;
    value: any;
    linkValue?: any | null;
  }>;
};

export type TableRowHistoryFragment = {
  __typename?: 'TableRowHistory';
  _id: string;
  rowId: string;
  tableId: string;
  workspace: string;
  columnId?: string | null;
  author?: string | null;
  after?: any | null;
  before?: any | null;
  data?: any | null;
  createdAt: any;
};

export type TableViewSortFragmentFragment = {
  __typename?: 'TableViewSortInput';
  column: string;
  direction: SortDirection;
};

export type TableViewFragment = {
  __typename?: 'TableView';
  _id: string;
  title: string;
  type: TableViewType;
  creatorId: string;
  groupBy?: string | null;
  filter?: any | null;
  order: number;
  access?: TableViewAccess | null;
  showSummary?: boolean | null;
  sortBy?: Array<{
    __typename?: 'TableViewSortInput';
    column: string;
    direction: SortDirection;
  }> | null;
  participants?: Array<
    | { __typename?: 'WorkspaceParticipantTeam'; team: string }
    | { __typename?: 'WorkspaceParticipantUser'; user: string }
  > | null;
};

export type TableViewColumnFragment = {
  __typename?: 'TableViewColumn';
  _id: string;
  columnId: string;
  order: number;
  fixed?: boolean | null;
  width?: number | null;
  hidden?: boolean | null;
};

export type TableViewDetailsFragment = {
  __typename?: 'TableView';
  _id: string;
  title: string;
  type: TableViewType;
  creatorId: string;
  groupBy?: string | null;
  filter?: any | null;
  order: number;
  access?: TableViewAccess | null;
  showSummary?: boolean | null;
  columns: Array<{
    __typename?: 'TableViewColumn';
    _id: string;
    columnId: string;
    order: number;
    fixed?: boolean | null;
    width?: number | null;
    hidden?: boolean | null;
  }>;
  sortBy?: Array<{
    __typename?: 'TableViewSortInput';
    column: string;
    direction: SortDirection;
  }> | null;
  participants?: Array<
    | { __typename?: 'WorkspaceParticipantTeam'; team: string }
    | { __typename?: 'WorkspaceParticipantUser'; user: string }
  > | null;
};

export type BoardRolesFragment = {
  __typename?: 'Board';
  roles?: {
    __typename?: 'BoardRoles';
    admin?: any | null;
    member?: any | null;
    viewer?: any | null;
    edit_all?: any | null;
    edit_own?: any | null;
    edit_unassigned?: any | null;
    view_all?: any | null;
    view_own?: any | null;
    view_unassigned?: any | null;
  } | null;
};

export type BoardParticipantsFragment = {
  __typename?: 'Board';
  participants: Array<
    | { __typename?: 'WorkspaceParticipantTeam'; team: string }
    | { __typename?: 'WorkspaceParticipantUser'; user: string }
  >;
};

export type TableRowRoomFragment = {
  __typename?: 'TableRowRoomComment';
  _id: string;
  rowId: string;
  boardId: string;
  tableId: string;
  name?: string | null;
  type?: string | null;
  workspace: string;
  createdBy: string;
  lastReadMessage?: string | null;
  hasUnreadMessages?: boolean | null;
  participants: Array<
    | { __typename?: 'WorkspaceParticipantTeam'; team: string }
    | { __typename?: 'WorkspaceParticipantUser'; user: string }
  >;
};

export type TableRowCommentFragment = {
  __typename?: 'TableRowComment';
  _id: string;
  rowId: string;
  tableId: string;
  author: string;
  edited?: boolean | null;
  content?: string | null;
  contentType?: TableColumnCommentType | null;
  mimeType?: string | null;
  mediaRef?: string | null;
  fileName?: string | null;
  fileSize?: number | null;
  mediaThumbnailRef?: string | null;
  mentions?: Array<string> | null;
  createdAt: any;
  reactions?: Array<{
    __typename?: 'TableRowCommentReaction';
    emoji: string;
    users: Array<string>;
  }> | null;
  replyTo?: {
    __typename?: 'TableRowComment';
    _id: string;
    rowId: string;
    tableId: string;
    author: string;
    content?: string | null;
    contentType?: TableColumnCommentType | null;
    createdAt: any;
  } | null;
};

export type BoardDeleteMutationVariables = Exact<{
  input: DeleteBoardInput;
}>;

export type BoardDeleteMutation = {
  __typename?: 'Mutation';
  deleteBoard: { __typename?: 'Board'; _id: string };
};

export type BoardLeaveMutationVariables = Exact<{
  input: LeaveBoardInput;
}>;

export type BoardLeaveMutation = {
  __typename?: 'Mutation';
  leaveBoard: { __typename?: 'Board'; _id: string };
};

export type PinBoardMutationVariables = Exact<{
  input: PinBoardInput;
}>;

export type PinBoardMutation = {
  __typename?: 'Mutation';
  pinBoard: { __typename?: 'Board'; _id: string; pinned?: boolean | null };
};

export type BoardTableDataQueryVariables = Exact<{
  boardId: Scalars['ID']['input'];
  tableId: Scalars['ID']['input'];
}>;

export type BoardTableDataQuery = {
  __typename?: 'Query';
  table: {
    __typename?: 'Table';
    activeAutomations: number;
    owner: string;
    _id: string;
    name: string;
    board: string;
    order: number;
    columns: Array<{
      __typename?: 'TableColumns';
      _id: string;
      system?: boolean | null;
      resizable?: boolean | null;
      tableId: string;
      field?: string | null;
      type: TableColumnType;
      valueType: TableColumnValueType;
      minWidth?: number | null;
      label: string;
      tableRef?: string | null;
      canNotify?: boolean | null;
      syncLink?: boolean | null;
      columnRef?: string | null;
      linkingColumnRef?: string | null;
      defaultValue?: any | null;
      aggregator?: TableColumnAggregator | null;
      format?: TableColumnFormat | null;
      options?: Array<{
        __typename?: 'TableColumnOption';
        _id: string;
        label: string;
        color: string;
        order: number;
        system?: boolean | null;
        statusGroup?: TableColumnOptionStatusGroup | null;
      }> | null;
      columnRefValue?: {
        __typename?: 'TableColumns';
        _id: string;
        system?: boolean | null;
        resizable?: boolean | null;
        tableId: string;
        field?: string | null;
        type: TableColumnType;
        valueType: TableColumnValueType;
        minWidth?: number | null;
        label: string;
        tableRef?: string | null;
        columnRef?: string | null;
        options?: Array<{
          __typename?: 'TableColumnOption';
          _id: string;
          label: string;
          color: string;
          order: number;
          system?: boolean | null;
          statusGroup?: TableColumnOptionStatusGroup | null;
        }> | null;
      } | null;
      function?: {
        __typename?: 'TableColumnFuction';
        operator: TableColumnFuctionOperator;
        columns: Array<string>;
        result?: number | null;
      } | null;
      numberOptions?: {
        __typename?: 'TableColumnNumberOptions';
        decimalPlaces?: number | null;
        prefix?: string | null;
        suffix?: string | null;
        separator?: TableColumnNumberSeparator | null;
        allowNegative?: boolean | null;
      } | null;
      linkForm?: {
        __typename?: 'TableColumnLinkForm';
        label?: string | null;
        linkColumnId: string;
        fields: Array<{
          __typename?: 'TableColumnLinkFormField';
          columnId: string;
          visible: boolean;
          required: boolean;
          defaultValue?: any | null;
        }>;
      } | null;
    }>;
    views: Array<{
      __typename?: 'TableView';
      _id: string;
      title: string;
      type: TableViewType;
      creatorId: string;
      groupBy?: string | null;
      filter?: any | null;
      order: number;
      access?: TableViewAccess | null;
      showSummary?: boolean | null;
      columns: Array<{
        __typename?: 'TableViewColumn';
        _id: string;
        columnId: string;
        order: number;
        fixed?: boolean | null;
        width?: number | null;
        hidden?: boolean | null;
      }>;
      sortBy?: Array<{
        __typename?: 'TableViewSortInput';
        column: string;
        direction: SortDirection;
      }> | null;
      participants?: Array<
        | { __typename?: 'WorkspaceParticipantTeam'; team: string }
        | { __typename?: 'WorkspaceParticipantUser'; user: string }
      > | null;
    }>;
  };
};

export type TableColumnDeleteMutationVariables = Exact<{
  input: DeleteTableColumnInput;
}>;

export type TableColumnDeleteMutation = {
  __typename?: 'Mutation';
  deleteColumn?: boolean | null;
};

export type TableColumnCreateMutationVariables = Exact<{
  input: CreateTableColumnInput;
}>;

export type TableColumnCreateMutation = {
  __typename?: 'Mutation';
  createColumn: {
    __typename?: 'TableColumns';
    tableId: string;
    _id: string;
    system?: boolean | null;
    resizable?: boolean | null;
    field?: string | null;
    type: TableColumnType;
    valueType: TableColumnValueType;
    minWidth?: number | null;
    label: string;
    tableRef?: string | null;
    canNotify?: boolean | null;
    syncLink?: boolean | null;
    columnRef?: string | null;
    linkingColumnRef?: string | null;
    defaultValue?: any | null;
    aggregator?: TableColumnAggregator | null;
    format?: TableColumnFormat | null;
    options?: Array<{
      __typename?: 'TableColumnOption';
      _id: string;
      label: string;
      color: string;
      order: number;
      system?: boolean | null;
      statusGroup?: TableColumnOptionStatusGroup | null;
    }> | null;
    columnRefValue?: {
      __typename?: 'TableColumns';
      _id: string;
      system?: boolean | null;
      resizable?: boolean | null;
      tableId: string;
      field?: string | null;
      type: TableColumnType;
      valueType: TableColumnValueType;
      minWidth?: number | null;
      label: string;
      tableRef?: string | null;
      columnRef?: string | null;
      options?: Array<{
        __typename?: 'TableColumnOption';
        _id: string;
        label: string;
        color: string;
        order: number;
        system?: boolean | null;
        statusGroup?: TableColumnOptionStatusGroup | null;
      }> | null;
    } | null;
    function?: {
      __typename?: 'TableColumnFuction';
      operator: TableColumnFuctionOperator;
      columns: Array<string>;
      result?: number | null;
    } | null;
    numberOptions?: {
      __typename?: 'TableColumnNumberOptions';
      decimalPlaces?: number | null;
      prefix?: string | null;
      suffix?: string | null;
      separator?: TableColumnNumberSeparator | null;
      allowNegative?: boolean | null;
    } | null;
    linkForm?: {
      __typename?: 'TableColumnLinkForm';
      label?: string | null;
      linkColumnId: string;
      fields: Array<{
        __typename?: 'TableColumnLinkFormField';
        columnId: string;
        visible: boolean;
        required: boolean;
        defaultValue?: any | null;
      }>;
    } | null;
  };
};

export type TableColumnUpdateMutationVariables = Exact<{
  input: UpdateTableColumnInput;
}>;

export type TableColumnUpdateMutation = {
  __typename?: 'Mutation';
  updateColumn: {
    __typename?: 'TableColumns';
    _id: string;
    system?: boolean | null;
    resizable?: boolean | null;
    tableId: string;
    field?: string | null;
    type: TableColumnType;
    valueType: TableColumnValueType;
    minWidth?: number | null;
    label: string;
    tableRef?: string | null;
    canNotify?: boolean | null;
    syncLink?: boolean | null;
    columnRef?: string | null;
    linkingColumnRef?: string | null;
    defaultValue?: any | null;
    aggregator?: TableColumnAggregator | null;
    format?: TableColumnFormat | null;
    options?: Array<{
      __typename?: 'TableColumnOption';
      _id: string;
      label: string;
      color: string;
      order: number;
      system?: boolean | null;
      statusGroup?: TableColumnOptionStatusGroup | null;
    }> | null;
    columnRefValue?: {
      __typename?: 'TableColumns';
      _id: string;
      system?: boolean | null;
      resizable?: boolean | null;
      tableId: string;
      field?: string | null;
      type: TableColumnType;
      valueType: TableColumnValueType;
      minWidth?: number | null;
      label: string;
      tableRef?: string | null;
      columnRef?: string | null;
      options?: Array<{
        __typename?: 'TableColumnOption';
        _id: string;
        label: string;
        color: string;
        order: number;
        system?: boolean | null;
        statusGroup?: TableColumnOptionStatusGroup | null;
      }> | null;
    } | null;
    function?: {
      __typename?: 'TableColumnFuction';
      operator: TableColumnFuctionOperator;
      columns: Array<string>;
      result?: number | null;
    } | null;
    numberOptions?: {
      __typename?: 'TableColumnNumberOptions';
      decimalPlaces?: number | null;
      prefix?: string | null;
      suffix?: string | null;
      separator?: TableColumnNumberSeparator | null;
      allowNegative?: boolean | null;
    } | null;
    linkForm?: {
      __typename?: 'TableColumnLinkForm';
      label?: string | null;
      linkColumnId: string;
      fields: Array<{
        __typename?: 'TableColumnLinkFormField';
        columnId: string;
        visible: boolean;
        required: boolean;
        defaultValue?: any | null;
      }>;
    } | null;
  };
};

export type TableDeleteMutationVariables = Exact<{
  input: DeleteTableInput;
}>;

export type TableDeleteMutation = {
  __typename?: 'Mutation';
  deleteTable: { __typename?: 'Table'; _id: string };
};

export type TableRowDeleteBulkMutationVariables = Exact<{
  input: DeleteBulkTableRowInput;
}>;

export type TableRowDeleteBulkMutation = {
  __typename?: 'Mutation';
  deleteBulkTableRow: Array<string>;
};

export type TableRowDeleteMutationVariables = Exact<{
  input: DeleteTableRowInput;
}>;

export type TableRowDeleteMutation = {
  __typename?: 'Mutation';
  deleteTableRow: { __typename?: 'TableRow'; _id: string; tableId: string };
};

export type DuplicateBulkTableRowMutationVariables = Exact<{
  input: DuplicateBulkTableRowInput;
}>;

export type DuplicateBulkTableRowMutation = {
  __typename?: 'Mutation';
  duplicateBulkTableRow: Array<{
    __typename?: 'TableRow';
    _id: string;
    rowId: number;
    tableId: string;
    order: number;
    ownerId: string;
    unreadComments?: number | null;
    hasComments?: boolean | null;
    hasDescription?: boolean | null;
    createdAt: any;
    updatedAt: any;
    updatedBy?: string | null;
    columns: Array<{
      __typename?: 'TableRowColumn';
      columnId: string;
      value: any;
      linkValue?: any | null;
    }>;
  }>;
};

export type TableRowMoveBulkMutationVariables = Exact<{
  input: MoveBulkTableRowInput;
}>;

export type TableRowMoveBulkMutation = {
  __typename?: 'Mutation';
  moveBulkTableRow: Array<string>;
};

export type UpdateBulkTableRowMutationVariables = Exact<{
  input: UpdateBulkTableRowInput;
}>;

export type UpdateBulkTableRowMutation = {
  __typename?: 'Mutation';
  updateBulkTableRow: boolean;
};

export type TableRowsQueryVariables = Exact<{
  input: QueryTableRowsInput;
}>;

export type TableRowsQuery = {
  __typename?: 'Query';
  tableRows: Array<{
    __typename?: 'TableRow';
    _id: string;
    rowId: number;
    tableId: string;
    order: number;
    ownerId: string;
    unreadComments?: number | null;
    hasComments?: boolean | null;
    hasDescription?: boolean | null;
    createdAt: any;
    updatedAt: any;
    updatedBy?: string | null;
    columns: Array<{
      __typename?: 'TableRowColumn';
      columnId: string;
      value: any;
      linkValue?: any | null;
    }>;
  }>;
};

export type TableUpdateMutationVariables = Exact<{
  input: UpdateTableInput;
}>;

export type TableUpdateMutation = {
  __typename?: 'Mutation';
  updateTable: {
    __typename?: 'Table';
    _id: string;
    name: string;
    board: string;
    order: number;
  };
};

export type TableViewColumnUpdateMutationVariables = Exact<{
  input: UpdateTableViewColumnInput;
}>;

export type TableViewColumnUpdateMutation = {
  __typename?: 'Mutation';
  updateTableViewColumn: {
    __typename?: 'TableViewColumn';
    _id: string;
    columnId: string;
    order: number;
    fixed?: boolean | null;
    width?: number | null;
    hidden?: boolean | null;
  };
};

export type CreateTableViewMutationVariables = Exact<{
  input: CreateTableViewInput;
}>;

export type CreateTableViewMutation = {
  __typename?: 'Mutation';
  createTableView: {
    __typename?: 'TableView';
    _id: string;
    title: string;
    type: TableViewType;
    creatorId: string;
    groupBy?: string | null;
    filter?: any | null;
    order: number;
    access?: TableViewAccess | null;
    showSummary?: boolean | null;
    sortBy?: Array<{
      __typename?: 'TableViewSortInput';
      column: string;
      direction: SortDirection;
    }> | null;
    participants?: Array<
      | { __typename?: 'WorkspaceParticipantTeam'; team: string }
      | { __typename?: 'WorkspaceParticipantUser'; user: string }
    > | null;
  };
};

export type NewTableViewFragment = {
  __typename?: 'TableView';
  _id: string;
  title: string;
  type: TableViewType;
  creatorId: string;
  groupBy?: string | null;
  filter?: any | null;
  showSummary?: boolean | null;
  sortBy?: Array<{
    __typename?: 'TableViewSortInput';
    column: string;
    direction: SortDirection;
  }> | null;
  participants?: Array<
    | { __typename?: 'WorkspaceParticipantTeam'; team: string }
    | { __typename?: 'WorkspaceParticipantUser'; user: string }
  > | null;
};

export type UpdateTableRowMutationVariables = Exact<{
  input: UpdateTableRowInput;
}>;

export type UpdateTableRowMutation = {
  __typename?: 'Mutation';
  updateTableRow: {
    __typename?: 'TableRow';
    _id: string;
    rowId: number;
    tableId: string;
    order: number;
    ownerId: string;
    unreadComments?: number | null;
    hasComments?: boolean | null;
    hasDescription?: boolean | null;
    createdAt: any;
    updatedAt: any;
    updatedBy?: string | null;
    columns: Array<{
      __typename?: 'TableRowColumn';
      columnId: string;
      value: any;
      linkValue?: any | null;
    }>;
  };
};

export const TodoListItemFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TodoListItem' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TodoList' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'list' } },
          { kind: 'Field', name: { kind: 'Name', value: 'order' } },
          { kind: 'Field', name: { kind: 'Name', value: 'default' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'participants' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'tags' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'color' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'color' } },
          { kind: 'Field', name: { kind: 'Name', value: 'icon' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<TodoListItemFragment, unknown>;
export const TodoItemFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TodoItem' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TodoItems' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'completed' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dueDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'list' } },
          { kind: 'Field', name: { kind: 'Name', value: 'owner' } },
          { kind: 'Field', name: { kind: 'Name', value: 'googleEventId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'participants' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'tags' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'color' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'recurrence' } },
          { kind: 'Field', name: { kind: 'Name', value: 'order' } },
          { kind: 'Field', name: { kind: 'Name', value: 'rrule' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'color' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<TodoItemFragment, unknown>;
export const NewTodoItemFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'NewTodoItem' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TodoItems' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'list' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<NewTodoItemFragment, unknown>;
export const NewTodoFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'NewTodo' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TodoList' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'list' } },
          { kind: 'Field', name: { kind: 'Name', value: 'order' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<NewTodoFragment, unknown>;
export const TableColumnOptionFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TableColumnOption' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TableColumnOption' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'label' } },
          { kind: 'Field', name: { kind: 'Name', value: 'color' } },
          { kind: 'Field', name: { kind: 'Name', value: 'order' } },
          { kind: 'Field', name: { kind: 'Name', value: 'system' } },
          { kind: 'Field', name: { kind: 'Name', value: 'statusGroup' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<TableColumnOptionFragment, unknown>;
export const TableColumnLinkFormFieldFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TableColumnLinkFormField' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TableColumnLinkFormField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'columnId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'visible' } },
          { kind: 'Field', name: { kind: 'Name', value: 'required' } },
          { kind: 'Field', name: { kind: 'Name', value: 'defaultValue' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<TableColumnLinkFormFieldFragment, unknown>;
export const TableColumnFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TableColumn' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TableColumns' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'system' } },
          { kind: 'Field', name: { kind: 'Name', value: 'resizable' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tableId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'field' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'valueType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'minWidth' } },
          { kind: 'Field', name: { kind: 'Name', value: 'label' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'options' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'TableColumnOption' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'tableRef' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canNotify' } },
          { kind: 'Field', name: { kind: 'Name', value: 'syncLink' } },
          { kind: 'Field', name: { kind: 'Name', value: 'columnRef' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'columnRefValue' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'system' } },
                { kind: 'Field', name: { kind: 'Name', value: 'resizable' } },
                { kind: 'Field', name: { kind: 'Name', value: 'tableId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'field' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                { kind: 'Field', name: { kind: 'Name', value: 'valueType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'minWidth' } },
                { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                { kind: 'Field', name: { kind: 'Name', value: 'tableRef' } },
                { kind: 'Field', name: { kind: 'Name', value: 'columnRef' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'options' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'TableColumnOption' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'linkingColumnRef' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'function' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'operator' } },
                { kind: 'Field', name: { kind: 'Name', value: 'columns' } },
                { kind: 'Field', name: { kind: 'Name', value: 'result' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'numberOptions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'decimalPlaces' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'prefix' } },
                { kind: 'Field', name: { kind: 'Name', value: 'suffix' } },
                { kind: 'Field', name: { kind: 'Name', value: 'separator' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'allowNegative' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'linkForm' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'linkColumnId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'fields' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: {
                          kind: 'Name',
                          value: 'TableColumnLinkFormField',
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'defaultValue' } },
          { kind: 'Field', name: { kind: 'Name', value: 'aggregator' } },
          { kind: 'Field', name: { kind: 'Name', value: 'format' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TableColumnOption' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TableColumnOption' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'label' } },
          { kind: 'Field', name: { kind: 'Name', value: 'color' } },
          { kind: 'Field', name: { kind: 'Name', value: 'order' } },
          { kind: 'Field', name: { kind: 'Name', value: 'system' } },
          { kind: 'Field', name: { kind: 'Name', value: 'statusGroup' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TableColumnLinkFormField' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TableColumnLinkFormField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'columnId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'visible' } },
          { kind: 'Field', name: { kind: 'Name', value: 'required' } },
          { kind: 'Field', name: { kind: 'Name', value: 'defaultValue' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<TableColumnFragment, unknown>;
export const FormTableColumnsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'formTableColumns' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Table' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '_id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'columns' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'TableColumn' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TableColumnOption' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TableColumnOption' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'label' } },
          { kind: 'Field', name: { kind: 'Name', value: 'color' } },
          { kind: 'Field', name: { kind: 'Name', value: 'order' } },
          { kind: 'Field', name: { kind: 'Name', value: 'system' } },
          { kind: 'Field', name: { kind: 'Name', value: 'statusGroup' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TableColumnLinkFormField' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TableColumnLinkFormField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'columnId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'visible' } },
          { kind: 'Field', name: { kind: 'Name', value: 'required' } },
          { kind: 'Field', name: { kind: 'Name', value: 'defaultValue' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TableColumn' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TableColumns' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'system' } },
          { kind: 'Field', name: { kind: 'Name', value: 'resizable' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tableId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'field' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'valueType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'minWidth' } },
          { kind: 'Field', name: { kind: 'Name', value: 'label' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'options' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'TableColumnOption' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'tableRef' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canNotify' } },
          { kind: 'Field', name: { kind: 'Name', value: 'syncLink' } },
          { kind: 'Field', name: { kind: 'Name', value: 'columnRef' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'columnRefValue' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'system' } },
                { kind: 'Field', name: { kind: 'Name', value: 'resizable' } },
                { kind: 'Field', name: { kind: 'Name', value: 'tableId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'field' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                { kind: 'Field', name: { kind: 'Name', value: 'valueType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'minWidth' } },
                { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                { kind: 'Field', name: { kind: 'Name', value: 'tableRef' } },
                { kind: 'Field', name: { kind: 'Name', value: 'columnRef' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'options' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'TableColumnOption' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'linkingColumnRef' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'function' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'operator' } },
                { kind: 'Field', name: { kind: 'Name', value: 'columns' } },
                { kind: 'Field', name: { kind: 'Name', value: 'result' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'numberOptions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'decimalPlaces' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'prefix' } },
                { kind: 'Field', name: { kind: 'Name', value: 'suffix' } },
                { kind: 'Field', name: { kind: 'Name', value: 'separator' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'allowNegative' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'linkForm' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'linkColumnId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'fields' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: {
                          kind: 'Name',
                          value: 'TableColumnLinkFormField',
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'defaultValue' } },
          { kind: 'Field', name: { kind: 'Name', value: 'aggregator' } },
          { kind: 'Field', name: { kind: 'Name', value: 'format' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<FormTableColumnsFragment, unknown>;
export const TableViewColumnFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TableViewColumn' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TableViewColumn' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'columnId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'order' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fixed' } },
          { kind: 'Field', name: { kind: 'Name', value: 'width' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hidden' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<TableViewColumnFragment, unknown>;
export const FormViewFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'formView' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TableView' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'access' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'participants' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'WorkspaceParticipantUser' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'user' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'WorkspaceParticipantTeam' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'team' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'columns' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'TableViewColumn' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'groupBy' } },
          { kind: 'Field', name: { kind: 'Name', value: 'showSummary' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TableViewColumn' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TableViewColumn' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'columnId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'order' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fixed' } },
          { kind: 'Field', name: { kind: 'Name', value: 'width' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hidden' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<FormViewFragment, unknown>;
export const FormTableFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'formTable' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Table' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'views' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'order' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<FormTableFragment, unknown>;
export const RowMembersValueFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'RowMembersValue' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TableRow' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '_id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'columns' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'columnId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<RowMembersValueFragment, unknown>;
export const NewBoardFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'NewBoard' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Board' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'icon' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<NewBoardFragment, unknown>;
export const NewTableFragmentFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'NewTableFragment' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Table' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'board' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<NewTableFragmentFragment, unknown>;
export const RowMultiValueFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'RowMultiValue' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TableRow' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '_id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'columns' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'columnId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<RowMultiValueFragment, unknown>;
export const TableFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Table' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Table' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'board' } },
          { kind: 'Field', name: { kind: 'Name', value: 'order' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<TableFragment, unknown>;
export const TableRowFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'tableRow' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TableRow' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'rowId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tableId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'order' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ownerId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'unreadComments' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hasComments' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hasDescription' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'columns' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'columnId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                { kind: 'Field', name: { kind: 'Name', value: 'linkValue' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedBy' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<TableRowFragment, unknown>;
export const TableRowHistoryFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'tableRowHistory' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TableRowHistory' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'rowId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tableId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'workspace' } },
          { kind: 'Field', name: { kind: 'Name', value: 'columnId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'author' } },
          { kind: 'Field', name: { kind: 'Name', value: 'after' } },
          { kind: 'Field', name: { kind: 'Name', value: 'before' } },
          { kind: 'Field', name: { kind: 'Name', value: 'data' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<TableRowHistoryFragment, unknown>;
export const TableViewSortFragmentFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'tableViewSortFragment' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TableViewSortInput' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'column' } },
          { kind: 'Field', name: { kind: 'Name', value: 'direction' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<TableViewSortFragmentFragment, unknown>;
export const TableViewFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'tableView' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TableView' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'creatorId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'groupBy' } },
          { kind: 'Field', name: { kind: 'Name', value: 'filter' } },
          { kind: 'Field', name: { kind: 'Name', value: 'order' } },
          { kind: 'Field', name: { kind: 'Name', value: 'access' } },
          { kind: 'Field', name: { kind: 'Name', value: 'showSummary' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sortBy' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'tableViewSortFragment' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'participants' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'WorkspaceParticipantUser' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'user' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'WorkspaceParticipantTeam' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'team' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'tableViewSortFragment' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TableViewSortInput' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'column' } },
          { kind: 'Field', name: { kind: 'Name', value: 'direction' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<TableViewFragment, unknown>;
export const TableViewDetailsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'tableViewDetails' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TableView' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'tableView' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'columns' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'TableViewColumn' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'tableViewSortFragment' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TableViewSortInput' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'column' } },
          { kind: 'Field', name: { kind: 'Name', value: 'direction' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'tableView' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TableView' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'creatorId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'groupBy' } },
          { kind: 'Field', name: { kind: 'Name', value: 'filter' } },
          { kind: 'Field', name: { kind: 'Name', value: 'order' } },
          { kind: 'Field', name: { kind: 'Name', value: 'access' } },
          { kind: 'Field', name: { kind: 'Name', value: 'showSummary' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sortBy' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'tableViewSortFragment' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'participants' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'WorkspaceParticipantUser' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'user' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'WorkspaceParticipantTeam' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'team' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TableViewColumn' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TableViewColumn' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'columnId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'order' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fixed' } },
          { kind: 'Field', name: { kind: 'Name', value: 'width' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hidden' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<TableViewDetailsFragment, unknown>;
export const BoardRolesFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'BoardRoles' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Board' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'roles' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'admin' } },
                { kind: 'Field', name: { kind: 'Name', value: 'member' } },
                { kind: 'Field', name: { kind: 'Name', value: 'viewer' } },
                { kind: 'Field', name: { kind: 'Name', value: 'edit_all' } },
                { kind: 'Field', name: { kind: 'Name', value: 'edit_own' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'edit_unassigned' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'view_all' } },
                { kind: 'Field', name: { kind: 'Name', value: 'view_own' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'view_unassigned' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<BoardRolesFragment, unknown>;
export const BoardParticipantsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'BoardParticipants' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Board' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'participants' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'WorkspaceParticipantUser' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'user' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'WorkspaceParticipantTeam' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'team' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<BoardParticipantsFragment, unknown>;
export const TableRowRoomFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'tableRowRoom' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TableRowRoomComment' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'rowId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'boardId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tableId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'workspace' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdBy' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'participants' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'WorkspaceParticipantUser' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'user' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'WorkspaceParticipantTeam' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'team' } },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'lastReadMessage' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hasUnreadMessages' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<TableRowRoomFragment, unknown>;
export const TableRowCommentFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'tableRowComment' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TableRowComment' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'rowId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tableId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'author' } },
          { kind: 'Field', name: { kind: 'Name', value: 'edited' } },
          { kind: 'Field', name: { kind: 'Name', value: 'content' } },
          { kind: 'Field', name: { kind: 'Name', value: 'contentType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'mimeType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'mediaRef' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fileName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fileSize' } },
          { kind: 'Field', name: { kind: 'Name', value: 'mediaThumbnailRef' } },
          { kind: 'Field', name: { kind: 'Name', value: 'mentions' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reactions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'TableRowCommentReaction' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'emoji' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'users' } },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'replyTo' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'rowId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'tableId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'author' } },
                { kind: 'Field', name: { kind: 'Name', value: 'content' } },
                { kind: 'Field', name: { kind: 'Name', value: 'contentType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<TableRowCommentFragment, unknown>;
export const NewTableViewFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'NewTableView' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TableView' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'creatorId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'groupBy' } },
          { kind: 'Field', name: { kind: 'Name', value: 'filter' } },
          { kind: 'Field', name: { kind: 'Name', value: 'showSummary' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sortBy' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'tableViewSortFragment' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'participants' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'WorkspaceParticipantUser' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'user' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'WorkspaceParticipantTeam' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'team' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'tableViewSortFragment' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TableViewSortInput' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'column' } },
          { kind: 'Field', name: { kind: 'Name', value: 'direction' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<NewTableViewFragment, unknown>;
export const DeleteActivitiesMessageDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'DeleteActivitiesMessage' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'DeleteCommentTableRowInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deleteCommentTableRow' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'rowId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'tableId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'author' } },
                { kind: 'Field', name: { kind: 'Name', value: 'content' } },
                { kind: 'Field', name: { kind: 'Name', value: 'contentType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DeleteActivitiesMessageMutation,
  DeleteActivitiesMessageMutationVariables
>;
export const EditActivitiesMessageDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'EditActivitiesMessage' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'UpdateCommentTableRowInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateCommentTableRow' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'tableRowComment' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'tableRowComment' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TableRowComment' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'rowId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tableId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'author' } },
          { kind: 'Field', name: { kind: 'Name', value: 'edited' } },
          { kind: 'Field', name: { kind: 'Name', value: 'content' } },
          { kind: 'Field', name: { kind: 'Name', value: 'contentType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'mimeType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'mediaRef' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fileName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fileSize' } },
          { kind: 'Field', name: { kind: 'Name', value: 'mediaThumbnailRef' } },
          { kind: 'Field', name: { kind: 'Name', value: 'mentions' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reactions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'TableRowCommentReaction' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'emoji' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'users' } },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'replyTo' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'rowId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'tableId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'author' } },
                { kind: 'Field', name: { kind: 'Name', value: 'content' } },
                { kind: 'Field', name: { kind: 'Name', value: 'contentType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  EditActivitiesMessageMutation,
  EditActivitiesMessageMutationVariables
>;
export const ReadLastMessageDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'ReadLastMessage' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ReadLastCommentTableRowInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'readLastCommentTableRow' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ReadLastMessageMutation,
  ReadLastMessageMutationVariables
>;
export const ReactActivitiesMessageDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'ReactActivitiesMessage' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ReactionCommentTableRowInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reactionCommentTableRow' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'tableRowComment' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'tableRowComment' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TableRowComment' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'rowId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tableId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'author' } },
          { kind: 'Field', name: { kind: 'Name', value: 'edited' } },
          { kind: 'Field', name: { kind: 'Name', value: 'content' } },
          { kind: 'Field', name: { kind: 'Name', value: 'contentType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'mimeType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'mediaRef' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fileName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fileSize' } },
          { kind: 'Field', name: { kind: 'Name', value: 'mediaThumbnailRef' } },
          { kind: 'Field', name: { kind: 'Name', value: 'mentions' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reactions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'TableRowCommentReaction' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'emoji' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'users' } },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'replyTo' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'rowId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'tableId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'author' } },
                { kind: 'Field', name: { kind: 'Name', value: 'content' } },
                { kind: 'Field', name: { kind: 'Name', value: 'contentType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ReactActivitiesMessageMutation,
  ReactActivitiesMessageMutationVariables
>;
export const TableRowActivitiesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'TableRowActivities' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'QueryTableRowCommentInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'tableRowComments' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'items' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'tableRowComment' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pageInfo' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'startCursor' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'endCursor' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'hasNextPage' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'hasPreviousPage' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'tableRowComment' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TableRowComment' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'rowId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tableId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'author' } },
          { kind: 'Field', name: { kind: 'Name', value: 'edited' } },
          { kind: 'Field', name: { kind: 'Name', value: 'content' } },
          { kind: 'Field', name: { kind: 'Name', value: 'contentType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'mimeType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'mediaRef' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fileName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fileSize' } },
          { kind: 'Field', name: { kind: 'Name', value: 'mediaThumbnailRef' } },
          { kind: 'Field', name: { kind: 'Name', value: 'mentions' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reactions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'TableRowCommentReaction' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'emoji' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'users' } },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'replyTo' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'rowId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'tableId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'author' } },
                { kind: 'Field', name: { kind: 'Name', value: 'content' } },
                { kind: 'Field', name: { kind: 'Name', value: 'contentType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  TableRowActivitiesQuery,
  TableRowActivitiesQueryVariables
>;
export const SendActivitiesMessageDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'SendActivitiesMessage' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'SendCommentTableRowInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sendCommentTableRow' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'tableRowComment' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'tableRowComment' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TableRowComment' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'rowId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tableId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'author' } },
          { kind: 'Field', name: { kind: 'Name', value: 'edited' } },
          { kind: 'Field', name: { kind: 'Name', value: 'content' } },
          { kind: 'Field', name: { kind: 'Name', value: 'contentType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'mimeType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'mediaRef' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fileName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fileSize' } },
          { kind: 'Field', name: { kind: 'Name', value: 'mediaThumbnailRef' } },
          { kind: 'Field', name: { kind: 'Name', value: 'mentions' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reactions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'TableRowCommentReaction' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'emoji' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'users' } },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'replyTo' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'rowId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'tableId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'author' } },
                { kind: 'Field', name: { kind: 'Name', value: 'content' } },
                { kind: 'Field', name: { kind: 'Name', value: 'contentType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  SendActivitiesMessageMutation,
  SendActivitiesMessageMutationVariables
>;
export const TableRowHistoriesDataDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'TableRowHistoriesData' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'QueryTableRowHistoryInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'tableRowHistory' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'tableRowHistory' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'tableRowHistory' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TableRowHistory' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'rowId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tableId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'workspace' } },
          { kind: 'Field', name: { kind: 'Name', value: 'columnId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'author' } },
          { kind: 'Field', name: { kind: 'Name', value: 'after' } },
          { kind: 'Field', name: { kind: 'Name', value: 'before' } },
          { kind: 'Field', name: { kind: 'Name', value: 'data' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  TableRowHistoriesDataQuery,
  TableRowHistoriesDataQueryVariables
>;
export const TableRowRoomDataDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'TableRowRoomData' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'QueryTableRowRoomInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'tableRowRoom' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'tableRowRoom' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'tableRowRoom' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TableRowRoomComment' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'rowId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'boardId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tableId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'workspace' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdBy' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'participants' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'WorkspaceParticipantUser' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'user' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'WorkspaceParticipantTeam' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'team' } },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'lastReadMessage' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hasUnreadMessages' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  TableRowRoomDataQuery,
  TableRowRoomDataQueryVariables
>;
export const BoardsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'Boards' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'boards' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'icon' } },
                { kind: 'Field', name: { kind: 'Name', value: 'pinned' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'tables' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '_id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'board' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'views' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: '_id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'type' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'title' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<BoardsQuery, BoardsQueryVariables>;
export const TableRowQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'TableRowQuery' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'rowId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'tableId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'boardId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'row' },
            name: { kind: 'Name', value: 'tableRow' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'tableId' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'tableId' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'rowId' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'rowId' },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'tableRow' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'board' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'boardId' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'BoardRoles' },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'BoardParticipants' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'table' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'boardId' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'boardId' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'tableId' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'tableId' },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'columns' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'TableColumn' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'views' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'tableView' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'columns' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'FragmentSpread',
                              name: { kind: 'Name', value: 'TableViewColumn' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TableColumnOption' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TableColumnOption' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'label' } },
          { kind: 'Field', name: { kind: 'Name', value: 'color' } },
          { kind: 'Field', name: { kind: 'Name', value: 'order' } },
          { kind: 'Field', name: { kind: 'Name', value: 'system' } },
          { kind: 'Field', name: { kind: 'Name', value: 'statusGroup' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TableColumnLinkFormField' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TableColumnLinkFormField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'columnId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'visible' } },
          { kind: 'Field', name: { kind: 'Name', value: 'required' } },
          { kind: 'Field', name: { kind: 'Name', value: 'defaultValue' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'tableViewSortFragment' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TableViewSortInput' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'column' } },
          { kind: 'Field', name: { kind: 'Name', value: 'direction' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'tableRow' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TableRow' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'rowId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tableId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'order' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ownerId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'unreadComments' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hasComments' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hasDescription' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'columns' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'columnId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                { kind: 'Field', name: { kind: 'Name', value: 'linkValue' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedBy' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'BoardRoles' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Board' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'roles' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'admin' } },
                { kind: 'Field', name: { kind: 'Name', value: 'member' } },
                { kind: 'Field', name: { kind: 'Name', value: 'viewer' } },
                { kind: 'Field', name: { kind: 'Name', value: 'edit_all' } },
                { kind: 'Field', name: { kind: 'Name', value: 'edit_own' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'edit_unassigned' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'view_all' } },
                { kind: 'Field', name: { kind: 'Name', value: 'view_own' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'view_unassigned' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'BoardParticipants' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Board' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'participants' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'WorkspaceParticipantUser' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'user' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'WorkspaceParticipantTeam' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'team' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TableColumn' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TableColumns' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'system' } },
          { kind: 'Field', name: { kind: 'Name', value: 'resizable' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tableId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'field' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'valueType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'minWidth' } },
          { kind: 'Field', name: { kind: 'Name', value: 'label' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'options' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'TableColumnOption' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'tableRef' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canNotify' } },
          { kind: 'Field', name: { kind: 'Name', value: 'syncLink' } },
          { kind: 'Field', name: { kind: 'Name', value: 'columnRef' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'columnRefValue' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'system' } },
                { kind: 'Field', name: { kind: 'Name', value: 'resizable' } },
                { kind: 'Field', name: { kind: 'Name', value: 'tableId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'field' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                { kind: 'Field', name: { kind: 'Name', value: 'valueType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'minWidth' } },
                { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                { kind: 'Field', name: { kind: 'Name', value: 'tableRef' } },
                { kind: 'Field', name: { kind: 'Name', value: 'columnRef' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'options' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'TableColumnOption' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'linkingColumnRef' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'function' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'operator' } },
                { kind: 'Field', name: { kind: 'Name', value: 'columns' } },
                { kind: 'Field', name: { kind: 'Name', value: 'result' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'numberOptions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'decimalPlaces' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'prefix' } },
                { kind: 'Field', name: { kind: 'Name', value: 'suffix' } },
                { kind: 'Field', name: { kind: 'Name', value: 'separator' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'allowNegative' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'linkForm' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'linkColumnId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'fields' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: {
                          kind: 'Name',
                          value: 'TableColumnLinkFormField',
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'defaultValue' } },
          { kind: 'Field', name: { kind: 'Name', value: 'aggregator' } },
          { kind: 'Field', name: { kind: 'Name', value: 'format' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'tableView' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TableView' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'creatorId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'groupBy' } },
          { kind: 'Field', name: { kind: 'Name', value: 'filter' } },
          { kind: 'Field', name: { kind: 'Name', value: 'order' } },
          { kind: 'Field', name: { kind: 'Name', value: 'access' } },
          { kind: 'Field', name: { kind: 'Name', value: 'showSummary' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sortBy' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'tableViewSortFragment' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'participants' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'WorkspaceParticipantUser' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'user' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'WorkspaceParticipantTeam' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'team' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TableViewColumn' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TableViewColumn' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'columnId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'order' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fixed' } },
          { kind: 'Field', name: { kind: 'Name', value: 'width' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hidden' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<TableRowQueryQuery, TableRowQueryQueryVariables>;
export const CreateTableRowDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateTableRow' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'CreateTableRowInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createTableRow' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'tableRow' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'tableRow' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TableRow' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'rowId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tableId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'order' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ownerId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'unreadComments' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hasComments' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hasDescription' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'columns' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'columnId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                { kind: 'Field', name: { kind: 'Name', value: 'linkValue' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedBy' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CreateTableRowMutation,
  CreateTableRowMutationVariables
>;
export const CreateTodoItemsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateTodoItems' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'CreateTodoItemsInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createTodoItems' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            directives: [
              {
                kind: 'Directive',
                name: { kind: 'Name', value: 'rest' },
                arguments: [
                  {
                    kind: 'Argument',
                    name: { kind: 'Name', value: 'type' },
                    value: {
                      kind: 'StringValue',
                      value: 'TodoItems',
                      block: false,
                    },
                  },
                  {
                    kind: 'Argument',
                    name: { kind: 'Name', value: 'path' },
                    value: {
                      kind: 'StringValue',
                      value: '/todo/create',
                      block: false,
                    },
                  },
                  {
                    kind: 'Argument',
                    name: { kind: 'Name', value: 'method' },
                    value: { kind: 'StringValue', value: 'POST', block: false },
                  },
                ],
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'TodoItem' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TodoItem' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TodoItems' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'completed' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dueDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'list' } },
          { kind: 'Field', name: { kind: 'Name', value: 'owner' } },
          { kind: 'Field', name: { kind: 'Name', value: 'googleEventId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'participants' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'tags' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'color' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'recurrence' } },
          { kind: 'Field', name: { kind: 'Name', value: 'order' } },
          { kind: 'Field', name: { kind: 'Name', value: 'rrule' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'color' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CreateTodoItemsMutation,
  CreateTodoItemsMutationVariables
>;
export const DeleteTodoItemsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'DeleteTodoItems' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'DeleteTodoItemsInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deleteTodoItems' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            directives: [
              {
                kind: 'Directive',
                name: { kind: 'Name', value: 'rest' },
                arguments: [
                  {
                    kind: 'Argument',
                    name: { kind: 'Name', value: 'type' },
                    value: {
                      kind: 'StringValue',
                      value: 'TodoItems',
                      block: false,
                    },
                  },
                  {
                    kind: 'Argument',
                    name: { kind: 'Name', value: 'path' },
                    value: {
                      kind: 'StringValue',
                      value: '/todo/delete?id={args.input.id}',
                      block: false,
                    },
                  },
                  {
                    kind: 'Argument',
                    name: { kind: 'Name', value: 'method' },
                    value: {
                      kind: 'StringValue',
                      value: 'DELETE',
                      block: false,
                    },
                  },
                ],
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'TodoItem' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TodoItem' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TodoItems' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'completed' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dueDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'list' } },
          { kind: 'Field', name: { kind: 'Name', value: 'owner' } },
          { kind: 'Field', name: { kind: 'Name', value: 'googleEventId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'participants' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'tags' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'color' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'recurrence' } },
          { kind: 'Field', name: { kind: 'Name', value: 'order' } },
          { kind: 'Field', name: { kind: 'Name', value: 'rrule' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'color' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DeleteTodoItemsMutation,
  DeleteTodoItemsMutationVariables
>;
export const LeaveTodoItemsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'LeaveTodoItems' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'LeaveTodoListInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'leaveTodoItems' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            directives: [
              {
                kind: 'Directive',
                name: { kind: 'Name', value: 'rest' },
                arguments: [
                  {
                    kind: 'Argument',
                    name: { kind: 'Name', value: 'type' },
                    value: {
                      kind: 'StringValue',
                      value: 'TodoItems',
                      block: false,
                    },
                  },
                  {
                    kind: 'Argument',
                    name: { kind: 'Name', value: 'path' },
                    value: {
                      kind: 'StringValue',
                      value: '/todo/participant/leave',
                      block: false,
                    },
                  },
                  {
                    kind: 'Argument',
                    name: { kind: 'Name', value: 'method' },
                    value: { kind: 'StringValue', value: 'PUT', block: false },
                  },
                ],
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'TodoItem' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TodoItem' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TodoItems' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'completed' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dueDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'list' } },
          { kind: 'Field', name: { kind: 'Name', value: 'owner' } },
          { kind: 'Field', name: { kind: 'Name', value: 'googleEventId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'participants' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'tags' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'color' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'recurrence' } },
          { kind: 'Field', name: { kind: 'Name', value: 'order' } },
          { kind: 'Field', name: { kind: 'Name', value: 'rrule' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'color' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  LeaveTodoItemsMutation,
  LeaveTodoItemsMutationVariables
>;
export const TodoItemsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'TodoItems' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'queryParams' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'listId' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'todoItems' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'queryParams' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'queryParams' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'listId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'listId' },
                },
              },
            ],
            directives: [
              {
                kind: 'Directive',
                name: { kind: 'Name', value: 'rest' },
                arguments: [
                  {
                    kind: 'Argument',
                    name: { kind: 'Name', value: 'type' },
                    value: {
                      kind: 'StringValue',
                      value: 'TodoItems',
                      block: false,
                    },
                  },
                  {
                    kind: 'Argument',
                    name: { kind: 'Name', value: 'path' },
                    value: {
                      kind: 'StringValue',
                      value: '/todo/{args.listId}/todos?{args.queryParams}',
                      block: false,
                    },
                  },
                ],
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'completed' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'dueDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'list' } },
                { kind: 'Field', name: { kind: 'Name', value: 'owner' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'participants' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'tags' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '_id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'color' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'recurrence' } },
                { kind: 'Field', name: { kind: 'Name', value: 'order' } },
                { kind: 'Field', name: { kind: 'Name', value: 'rrule' } },
                { kind: 'Field', name: { kind: 'Name', value: 'color' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<TodoItemsQuery, TodoItemsQueryVariables>;
export const UpdateTodoItemsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateTodoItems' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'UpdateTodoItemsInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateTodoItems' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            directives: [
              {
                kind: 'Directive',
                name: { kind: 'Name', value: 'rest' },
                arguments: [
                  {
                    kind: 'Argument',
                    name: { kind: 'Name', value: 'type' },
                    value: {
                      kind: 'StringValue',
                      value: 'TodoItems',
                      block: false,
                    },
                  },
                  {
                    kind: 'Argument',
                    name: { kind: 'Name', value: 'path' },
                    value: {
                      kind: 'StringValue',
                      value: '/todo/update',
                      block: false,
                    },
                  },
                  {
                    kind: 'Argument',
                    name: { kind: 'Name', value: 'method' },
                    value: { kind: 'StringValue', value: 'PUT', block: false },
                  },
                ],
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'TodoItem' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TodoItem' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TodoItems' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'completed' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dueDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'list' } },
          { kind: 'Field', name: { kind: 'Name', value: 'owner' } },
          { kind: 'Field', name: { kind: 'Name', value: 'googleEventId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'participants' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'tags' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'color' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'recurrence' } },
          { kind: 'Field', name: { kind: 'Name', value: 'order' } },
          { kind: 'Field', name: { kind: 'Name', value: 'rrule' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'color' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateTodoItemsMutation,
  UpdateTodoItemsMutationVariables
>;
export const UpdateTodoItemColorDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateTodoItemColor' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'UpdateTodoItemsInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateTodoItems' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            directives: [
              {
                kind: 'Directive',
                name: { kind: 'Name', value: 'rest' },
                arguments: [
                  {
                    kind: 'Argument',
                    name: { kind: 'Name', value: 'type' },
                    value: {
                      kind: 'StringValue',
                      value: 'TodoItems',
                      block: false,
                    },
                  },
                  {
                    kind: 'Argument',
                    name: { kind: 'Name', value: 'path' },
                    value: {
                      kind: 'StringValue',
                      value: '/todo/update',
                      block: false,
                    },
                  },
                  {
                    kind: 'Argument',
                    name: { kind: 'Name', value: 'method' },
                    value: { kind: 'StringValue', value: 'PUT', block: false },
                  },
                ],
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'color' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateTodoItemColorMutation,
  UpdateTodoItemColorMutationVariables
>;
export const UpdateTodoItemDueDateDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateTodoItemDueDate' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'UpdateTodoItemsInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateTodoItems' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            directives: [
              {
                kind: 'Directive',
                name: { kind: 'Name', value: 'rest' },
                arguments: [
                  {
                    kind: 'Argument',
                    name: { kind: 'Name', value: 'type' },
                    value: {
                      kind: 'StringValue',
                      value: 'TodoItems',
                      block: false,
                    },
                  },
                  {
                    kind: 'Argument',
                    name: { kind: 'Name', value: 'path' },
                    value: {
                      kind: 'StringValue',
                      value: '/todo/update',
                      block: false,
                    },
                  },
                  {
                    kind: 'Argument',
                    name: { kind: 'Name', value: 'method' },
                    value: { kind: 'StringValue', value: 'PUT', block: false },
                  },
                ],
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'dueDate' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateTodoItemDueDateMutation,
  UpdateTodoItemDueDateMutationVariables
>;
export const UpdateTodoItemMovedDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateTodoItemMoved' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'UpdateTodoItemsInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateTodoItems' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            directives: [
              {
                kind: 'Directive',
                name: { kind: 'Name', value: 'rest' },
                arguments: [
                  {
                    kind: 'Argument',
                    name: { kind: 'Name', value: 'type' },
                    value: {
                      kind: 'StringValue',
                      value: 'TodoItems',
                      block: false,
                    },
                  },
                  {
                    kind: 'Argument',
                    name: { kind: 'Name', value: 'path' },
                    value: {
                      kind: 'StringValue',
                      value: '/todo/update',
                      block: false,
                    },
                  },
                  {
                    kind: 'Argument',
                    name: { kind: 'Name', value: 'method' },
                    value: { kind: 'StringValue', value: 'PUT', block: false },
                  },
                ],
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'dueDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'order' } },
                { kind: 'Field', name: { kind: 'Name', value: 'list' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateTodoItemMovedMutation,
  UpdateTodoItemMovedMutationVariables
>;
export const CreateTodoListDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateTodoList' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'CreateTodoListInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createTodoList' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            directives: [
              {
                kind: 'Directive',
                name: { kind: 'Name', value: 'rest' },
                arguments: [
                  {
                    kind: 'Argument',
                    name: { kind: 'Name', value: 'type' },
                    value: {
                      kind: 'StringValue',
                      value: 'TodoList',
                      block: false,
                    },
                  },
                  {
                    kind: 'Argument',
                    name: { kind: 'Name', value: 'path' },
                    value: {
                      kind: 'StringValue',
                      value: '/todo/list/create',
                      block: false,
                    },
                  },
                  {
                    kind: 'Argument',
                    name: { kind: 'Name', value: 'method' },
                    value: { kind: 'StringValue', value: 'POST', block: false },
                  },
                ],
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'TodoListItem' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TodoListItem' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TodoList' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'list' } },
          { kind: 'Field', name: { kind: 'Name', value: 'order' } },
          { kind: 'Field', name: { kind: 'Name', value: 'default' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'participants' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'tags' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'color' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'color' } },
          { kind: 'Field', name: { kind: 'Name', value: 'icon' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CreateTodoListMutation,
  CreateTodoListMutationVariables
>;
export const UpdateTodoListDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateTodoList' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'UpdateTodoListInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateTodoList' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            directives: [
              {
                kind: 'Directive',
                name: { kind: 'Name', value: 'rest' },
                arguments: [
                  {
                    kind: 'Argument',
                    name: { kind: 'Name', value: 'type' },
                    value: {
                      kind: 'StringValue',
                      value: 'TodoList',
                      block: false,
                    },
                  },
                  {
                    kind: 'Argument',
                    name: { kind: 'Name', value: 'path' },
                    value: {
                      kind: 'StringValue',
                      value: '/todo/list/update',
                      block: false,
                    },
                  },
                  {
                    kind: 'Argument',
                    name: { kind: 'Name', value: 'method' },
                    value: { kind: 'StringValue', value: 'PUT', block: false },
                  },
                ],
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'TodoListItem' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TodoListItem' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TodoList' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'list' } },
          { kind: 'Field', name: { kind: 'Name', value: 'order' } },
          { kind: 'Field', name: { kind: 'Name', value: 'default' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'participants' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'tags' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'color' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'color' } },
          { kind: 'Field', name: { kind: 'Name', value: 'icon' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateTodoListMutation,
  UpdateTodoListMutationVariables
>;
export const DeleteTodoListDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'DeleteTodoList' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'DeleteTodoListInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deleteTodoList' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            directives: [
              {
                kind: 'Directive',
                name: { kind: 'Name', value: 'rest' },
                arguments: [
                  {
                    kind: 'Argument',
                    name: { kind: 'Name', value: 'type' },
                    value: {
                      kind: 'StringValue',
                      value: 'TodoList',
                      block: false,
                    },
                  },
                  {
                    kind: 'Argument',
                    name: { kind: 'Name', value: 'path' },
                    value: {
                      kind: 'StringValue',
                      value: '/todo/list/delete?id={args.input.id}',
                      block: false,
                    },
                  },
                  {
                    kind: 'Argument',
                    name: { kind: 'Name', value: 'method' },
                    value: {
                      kind: 'StringValue',
                      value: 'DELETE',
                      block: false,
                    },
                  },
                ],
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'TodoListItem' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TodoListItem' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TodoList' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'list' } },
          { kind: 'Field', name: { kind: 'Name', value: 'order' } },
          { kind: 'Field', name: { kind: 'Name', value: 'default' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'participants' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'tags' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'color' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'color' } },
          { kind: 'Field', name: { kind: 'Name', value: 'icon' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DeleteTodoListMutation,
  DeleteTodoListMutationVariables
>;
export const TodoListDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'TodoList' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'todoList' },
            directives: [
              {
                kind: 'Directive',
                name: { kind: 'Name', value: 'rest' },
                arguments: [
                  {
                    kind: 'Argument',
                    name: { kind: 'Name', value: 'type' },
                    value: {
                      kind: 'StringValue',
                      value: 'TodoList',
                      block: false,
                    },
                  },
                  {
                    kind: 'Argument',
                    name: { kind: 'Name', value: 'path' },
                    value: {
                      kind: 'StringValue',
                      value: '/todo/list',
                      block: false,
                    },
                  },
                ],
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'list' } },
                { kind: 'Field', name: { kind: 'Name', value: 'default' } },
                { kind: 'Field', name: { kind: 'Name', value: 'order' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'googleCalendars' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'participants' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'tags' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '_id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'color' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'color' } },
                { kind: 'Field', name: { kind: 'Name', value: 'icon' } },
                { kind: 'Field', name: { kind: 'Name', value: 'boardId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'tableId' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<TodoListQuery, TodoListQueryVariables>;
export const UpdateTodoParticipantDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateTodoParticipant' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'TodoParticipantInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateTodoParticipant' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            directives: [
              {
                kind: 'Directive',
                name: { kind: 'Name', value: 'rest' },
                arguments: [
                  {
                    kind: 'Argument',
                    name: { kind: 'Name', value: 'type' },
                    value: {
                      kind: 'StringValue',
                      value: 'TodoItems',
                      block: false,
                    },
                  },
                  {
                    kind: 'Argument',
                    name: { kind: 'Name', value: 'path' },
                    value: {
                      kind: 'StringValue',
                      value: '/todo/participant/add',
                      block: false,
                    },
                  },
                  {
                    kind: 'Argument',
                    name: { kind: 'Name', value: 'method' },
                    value: { kind: 'StringValue', value: 'PUT', block: false },
                  },
                ],
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'TodoItem' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TodoItem' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TodoItems' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'completed' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dueDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'list' } },
          { kind: 'Field', name: { kind: 'Name', value: 'owner' } },
          { kind: 'Field', name: { kind: 'Name', value: 'googleEventId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'participants' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'tags' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'color' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'recurrence' } },
          { kind: 'Field', name: { kind: 'Name', value: 'order' } },
          { kind: 'Field', name: { kind: 'Name', value: 'rrule' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'color' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateTodoParticipantMutation,
  UpdateTodoParticipantMutationVariables
>;
export const DeleteTodoParticipantDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'DeleteTodoParticipant' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'TodoParticipantInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deleteTodoParticipant' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            directives: [
              {
                kind: 'Directive',
                name: { kind: 'Name', value: 'rest' },
                arguments: [
                  {
                    kind: 'Argument',
                    name: { kind: 'Name', value: 'type' },
                    value: {
                      kind: 'StringValue',
                      value: 'TodoItems',
                      block: false,
                    },
                  },
                  {
                    kind: 'Argument',
                    name: { kind: 'Name', value: 'path' },
                    value: {
                      kind: 'StringValue',
                      value: '/todo/participant/remove',
                      block: false,
                    },
                  },
                  {
                    kind: 'Argument',
                    name: { kind: 'Name', value: 'method' },
                    value: { kind: 'StringValue', value: 'PUT', block: false },
                  },
                ],
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'TodoItem' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TodoItem' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TodoItems' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'completed' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dueDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'list' } },
          { kind: 'Field', name: { kind: 'Name', value: 'owner' } },
          { kind: 'Field', name: { kind: 'Name', value: 'googleEventId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'participants' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'tags' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'color' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'recurrence' } },
          { kind: 'Field', name: { kind: 'Name', value: 'order' } },
          { kind: 'Field', name: { kind: 'Name', value: 'rrule' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'color' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DeleteTodoParticipantMutation,
  DeleteTodoParticipantMutationVariables
>;
export const TodoRecurrenceItemsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'TodoRecurrenceItems' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'queryParams' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'todoRecurrenceItems' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'queryParams' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'queryParams' },
                },
              },
            ],
            directives: [
              {
                kind: 'Directive',
                name: { kind: 'Name', value: 'rest' },
                arguments: [
                  {
                    kind: 'Argument',
                    name: { kind: 'Name', value: 'type' },
                    value: {
                      kind: 'StringValue',
                      value: 'TodoItems',
                      block: false,
                    },
                  },
                  {
                    kind: 'Argument',
                    name: { kind: 'Name', value: 'path' },
                    value: {
                      kind: 'StringValue',
                      value: '/todo/todos/recurrence{args.queryParams}',
                      block: false,
                    },
                  },
                ],
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'completed' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'dueDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'list' } },
                { kind: 'Field', name: { kind: 'Name', value: 'owner' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'tags' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '_id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'color' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'participants' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'recurrence' } },
                { kind: 'Field', name: { kind: 'Name', value: 'rrule' } },
                { kind: 'Field', name: { kind: 'Name', value: 'rruleText' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  TodoRecurrenceItemsQuery,
  TodoRecurrenceItemsQueryVariables
>;
export const SyncTodoBoardsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'syncTodoBoards' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'SyncTodoBoardsInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'syncTodoBoards' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            directives: [
              {
                kind: 'Directive',
                name: { kind: 'Name', value: 'rest' },
                arguments: [
                  {
                    kind: 'Argument',
                    name: { kind: 'Name', value: 'type' },
                    value: {
                      kind: 'StringValue',
                      value: 'TodoList',
                      block: false,
                    },
                  },
                  {
                    kind: 'Argument',
                    name: { kind: 'Name', value: 'path' },
                    value: {
                      kind: 'StringValue',
                      value: '/todo/list/board/sync',
                      block: false,
                    },
                  },
                  {
                    kind: 'Argument',
                    name: { kind: 'Name', value: 'method' },
                    value: { kind: 'StringValue', value: 'PUT', block: false },
                  },
                ],
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'TodoListItem' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TodoListItem' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TodoList' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'list' } },
          { kind: 'Field', name: { kind: 'Name', value: 'order' } },
          { kind: 'Field', name: { kind: 'Name', value: 'default' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'participants' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'tags' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'color' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'color' } },
          { kind: 'Field', name: { kind: 'Name', value: 'icon' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  SyncTodoBoardsMutation,
  SyncTodoBoardsMutationVariables
>;
export const UpdateTodoTagDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateTodoTag' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'TodoTagInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateTodoTag' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            directives: [
              {
                kind: 'Directive',
                name: { kind: 'Name', value: 'rest' },
                arguments: [
                  {
                    kind: 'Argument',
                    name: { kind: 'Name', value: 'type' },
                    value: {
                      kind: 'StringValue',
                      value: 'TodoItems',
                      block: false,
                    },
                  },
                  {
                    kind: 'Argument',
                    name: { kind: 'Name', value: 'path' },
                    value: {
                      kind: 'StringValue',
                      value: '/todo/tag/add',
                      block: false,
                    },
                  },
                  {
                    kind: 'Argument',
                    name: { kind: 'Name', value: 'method' },
                    value: {
                      kind: 'StringValue',
                      value: 'PATCH',
                      block: false,
                    },
                  },
                ],
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'TodoItem' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TodoItem' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TodoItems' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'completed' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dueDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'list' } },
          { kind: 'Field', name: { kind: 'Name', value: 'owner' } },
          { kind: 'Field', name: { kind: 'Name', value: 'googleEventId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'participants' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'tags' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'color' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'recurrence' } },
          { kind: 'Field', name: { kind: 'Name', value: 'order' } },
          { kind: 'Field', name: { kind: 'Name', value: 'rrule' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'color' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateTodoTagMutation,
  UpdateTodoTagMutationVariables
>;
export const DeleteTodoTagDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'DeleteTodoTag' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'TodoTagInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deleteTodoTag' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            directives: [
              {
                kind: 'Directive',
                name: { kind: 'Name', value: 'rest' },
                arguments: [
                  {
                    kind: 'Argument',
                    name: { kind: 'Name', value: 'type' },
                    value: {
                      kind: 'StringValue',
                      value: 'TodoItems',
                      block: false,
                    },
                  },
                  {
                    kind: 'Argument',
                    name: { kind: 'Name', value: 'path' },
                    value: {
                      kind: 'StringValue',
                      value: '/todo/tag/remove',
                      block: false,
                    },
                  },
                  {
                    kind: 'Argument',
                    name: { kind: 'Name', value: 'method' },
                    value: {
                      kind: 'StringValue',
                      value: 'PATCH',
                      block: false,
                    },
                  },
                ],
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'TodoItem' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TodoItem' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TodoItems' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'completed' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dueDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'list' } },
          { kind: 'Field', name: { kind: 'Name', value: 'owner' } },
          { kind: 'Field', name: { kind: 'Name', value: 'googleEventId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'participants' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'tags' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'color' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'recurrence' } },
          { kind: 'Field', name: { kind: 'Name', value: 'order' } },
          { kind: 'Field', name: { kind: 'Name', value: 'rrule' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'color' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DeleteTodoTagMutation,
  DeleteTodoTagMutationVariables
>;
export const BoardAddMemberDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'BoardAddMember' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'UpdateBoardParticipantInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'addBoardParticipant' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '_id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'participants' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'InlineFragment',
                        typeCondition: {
                          kind: 'NamedType',
                          name: {
                            kind: 'Name',
                            value: 'WorkspaceParticipantUser',
                          },
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'user' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: {
                          kind: 'NamedType',
                          name: {
                            kind: 'Name',
                            value: 'WorkspaceParticipantTeam',
                          },
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'team' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  BoardAddMemberMutation,
  BoardAddMemberMutationVariables
>;
export const BoardInfoEditDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'BoardInfoEdit' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'UpdateBoardInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateBoard' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'icon' } },
                { kind: 'Field', name: { kind: 'Name', value: 'picture' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  BoardInfoEditMutation,
  BoardInfoEditMutationVariables
>;
export const BoardRemoveMemberDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'BoardRemoveMember' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'UpdateBoardParticipantInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'removeBoardParticipant' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '_id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'participants' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'InlineFragment',
                        typeCondition: {
                          kind: 'NamedType',
                          name: {
                            kind: 'Name',
                            value: 'WorkspaceParticipantUser',
                          },
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'user' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: {
                          kind: 'NamedType',
                          name: {
                            kind: 'Name',
                            value: 'WorkspaceParticipantTeam',
                          },
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'team' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  BoardRemoveMemberMutation,
  BoardRemoveMemberMutationVariables
>;
export const UpdateBoardParticipantRoleDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateBoardParticipantRole' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'UpdateBoardParticipantRoleInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateBoardParticipantRole' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '_id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'roles' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'admin' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'member' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'viewer' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'edit_all' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'edit_own' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'edit_unassigned' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'view_all' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'view_own' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'view_unassigned' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'participants' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'InlineFragment',
                        typeCondition: {
                          kind: 'NamedType',
                          name: {
                            kind: 'Name',
                            value: 'WorkspaceParticipantUser',
                          },
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'user' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: {
                          kind: 'NamedType',
                          name: {
                            kind: 'Name',
                            value: 'WorkspaceParticipantTeam',
                          },
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'team' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateBoardParticipantRoleMutation,
  UpdateBoardParticipantRoleMutationVariables
>;
export const BoardDetailsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'BoardDetails' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'boardId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'board' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'boardId' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'picture' } },
                { kind: 'Field', name: { kind: 'Name', value: 'icon' } },
                { kind: 'Field', name: { kind: 'Name', value: 'pinned' } },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'BoardRoles' },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'BoardParticipants' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'BoardRoles' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Board' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'roles' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'admin' } },
                { kind: 'Field', name: { kind: 'Name', value: 'member' } },
                { kind: 'Field', name: { kind: 'Name', value: 'viewer' } },
                { kind: 'Field', name: { kind: 'Name', value: 'edit_all' } },
                { kind: 'Field', name: { kind: 'Name', value: 'edit_own' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'edit_unassigned' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'view_all' } },
                { kind: 'Field', name: { kind: 'Name', value: 'view_own' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'view_unassigned' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'BoardParticipants' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Board' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'participants' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'WorkspaceParticipantUser' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'user' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'WorkspaceParticipantTeam' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'team' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<BoardDetailsQuery, BoardDetailsQueryVariables>;
export const TableViewImportMutationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'TableViewImportMutation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ImportBulkTableInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'importBulkTableRow' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'tableRow' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'tableRow' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TableRow' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'rowId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tableId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'order' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ownerId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'unreadComments' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hasComments' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hasDescription' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'columns' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'columnId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                { kind: 'Field', name: { kind: 'Name', value: 'linkValue' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedBy' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  TableViewImportMutationMutation,
  TableViewImportMutationMutationVariables
>;
export const TableViewDeleteDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'TableViewDelete' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'DeleteTableViewInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deleteTableView' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  TableViewDeleteMutation,
  TableViewDeleteMutationVariables
>;
export const TableViewDataDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'TableViewData' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'QueryTableViewInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'tableView' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'tableViewDetails' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'rows' },
                  directives: [
                    {
                      kind: 'Directive',
                      name: { kind: 'Name', value: 'nonreactive' },
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'tableRow' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'tableViewSortFragment' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TableViewSortInput' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'column' } },
          { kind: 'Field', name: { kind: 'Name', value: 'direction' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'tableView' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TableView' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'creatorId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'groupBy' } },
          { kind: 'Field', name: { kind: 'Name', value: 'filter' } },
          { kind: 'Field', name: { kind: 'Name', value: 'order' } },
          { kind: 'Field', name: { kind: 'Name', value: 'access' } },
          { kind: 'Field', name: { kind: 'Name', value: 'showSummary' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sortBy' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'tableViewSortFragment' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'participants' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'WorkspaceParticipantUser' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'user' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'WorkspaceParticipantTeam' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'team' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TableViewColumn' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TableViewColumn' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'columnId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'order' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fixed' } },
          { kind: 'Field', name: { kind: 'Name', value: 'width' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hidden' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'tableViewDetails' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TableView' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'tableView' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'columns' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'TableViewColumn' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'tableRow' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TableRow' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'rowId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tableId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'order' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ownerId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'unreadComments' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hasComments' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hasDescription' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'columns' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'columnId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                { kind: 'Field', name: { kind: 'Name', value: 'linkValue' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedBy' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<TableViewDataQuery, TableViewDataQueryVariables>;
export const UpdateTableViewDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'updateTableView' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'UpdateTableViewInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateTableView' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'tableView' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'tableViewSortFragment' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TableViewSortInput' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'column' } },
          { kind: 'Field', name: { kind: 'Name', value: 'direction' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'tableView' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TableView' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'creatorId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'groupBy' } },
          { kind: 'Field', name: { kind: 'Name', value: 'filter' } },
          { kind: 'Field', name: { kind: 'Name', value: 'order' } },
          { kind: 'Field', name: { kind: 'Name', value: 'access' } },
          { kind: 'Field', name: { kind: 'Name', value: 'showSummary' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sortBy' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'tableViewSortFragment' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'participants' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'WorkspaceParticipantUser' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'user' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'WorkspaceParticipantTeam' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'team' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateTableViewMutation,
  UpdateTableViewMutationVariables
>;
export const BoardDataDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'BoardData' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'boardId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'board' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'boardId' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'icon' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'picture' } },
                { kind: 'Field', name: { kind: 'Name', value: 'pinned' } },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'BoardRoles' },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'BoardParticipants' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'tables' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '_id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'board' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'order' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'activeAutomations' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'views' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: '_id' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'BoardRoles' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Board' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'roles' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'admin' } },
                { kind: 'Field', name: { kind: 'Name', value: 'member' } },
                { kind: 'Field', name: { kind: 'Name', value: 'viewer' } },
                { kind: 'Field', name: { kind: 'Name', value: 'edit_all' } },
                { kind: 'Field', name: { kind: 'Name', value: 'edit_own' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'edit_unassigned' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'view_all' } },
                { kind: 'Field', name: { kind: 'Name', value: 'view_own' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'view_unassigned' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'BoardParticipants' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Board' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'participants' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'WorkspaceParticipantUser' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'user' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'WorkspaceParticipantTeam' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'team' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<BoardDataQuery, BoardDataQueryVariables>;
export const CreateBoardMutationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateBoardMutation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'CreateBoardInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createBoard' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'icon' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CreateBoardMutationMutation,
  CreateBoardMutationMutationVariables
>;
export const CreateBoardTableDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateBoardTable' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'CreateTableInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createTable' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'board' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CreateBoardTableMutation,
  CreateBoardTableMutationVariables
>;
export const BoardDeleteDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'BoardDelete' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'DeleteBoardInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deleteBoard' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '_id' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<BoardDeleteMutation, BoardDeleteMutationVariables>;
export const BoardLeaveDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'BoardLeave' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'LeaveBoardInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'leaveBoard' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '_id' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<BoardLeaveMutation, BoardLeaveMutationVariables>;
export const PinBoardDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'PinBoard' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'PinBoardInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'pinBoard' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'pinned' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<PinBoardMutation, PinBoardMutationVariables>;
export const BoardTableDataDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'BoardTableData' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'boardId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'tableId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'table' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'boardId' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'boardId' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'tableId' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'tableId' },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'Table' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'columns' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'TableColumn' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'views' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'tableView' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'columns' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'FragmentSpread',
                              name: { kind: 'Name', value: 'TableViewColumn' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'activeAutomations' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'owner' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TableColumnOption' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TableColumnOption' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'label' } },
          { kind: 'Field', name: { kind: 'Name', value: 'color' } },
          { kind: 'Field', name: { kind: 'Name', value: 'order' } },
          { kind: 'Field', name: { kind: 'Name', value: 'system' } },
          { kind: 'Field', name: { kind: 'Name', value: 'statusGroup' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TableColumnLinkFormField' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TableColumnLinkFormField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'columnId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'visible' } },
          { kind: 'Field', name: { kind: 'Name', value: 'required' } },
          { kind: 'Field', name: { kind: 'Name', value: 'defaultValue' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'tableViewSortFragment' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TableViewSortInput' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'column' } },
          { kind: 'Field', name: { kind: 'Name', value: 'direction' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Table' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Table' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'board' } },
          { kind: 'Field', name: { kind: 'Name', value: 'order' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TableColumn' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TableColumns' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'system' } },
          { kind: 'Field', name: { kind: 'Name', value: 'resizable' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tableId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'field' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'valueType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'minWidth' } },
          { kind: 'Field', name: { kind: 'Name', value: 'label' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'options' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'TableColumnOption' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'tableRef' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canNotify' } },
          { kind: 'Field', name: { kind: 'Name', value: 'syncLink' } },
          { kind: 'Field', name: { kind: 'Name', value: 'columnRef' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'columnRefValue' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'system' } },
                { kind: 'Field', name: { kind: 'Name', value: 'resizable' } },
                { kind: 'Field', name: { kind: 'Name', value: 'tableId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'field' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                { kind: 'Field', name: { kind: 'Name', value: 'valueType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'minWidth' } },
                { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                { kind: 'Field', name: { kind: 'Name', value: 'tableRef' } },
                { kind: 'Field', name: { kind: 'Name', value: 'columnRef' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'options' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'TableColumnOption' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'linkingColumnRef' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'function' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'operator' } },
                { kind: 'Field', name: { kind: 'Name', value: 'columns' } },
                { kind: 'Field', name: { kind: 'Name', value: 'result' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'numberOptions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'decimalPlaces' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'prefix' } },
                { kind: 'Field', name: { kind: 'Name', value: 'suffix' } },
                { kind: 'Field', name: { kind: 'Name', value: 'separator' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'allowNegative' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'linkForm' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'linkColumnId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'fields' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: {
                          kind: 'Name',
                          value: 'TableColumnLinkFormField',
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'defaultValue' } },
          { kind: 'Field', name: { kind: 'Name', value: 'aggregator' } },
          { kind: 'Field', name: { kind: 'Name', value: 'format' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'tableView' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TableView' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'creatorId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'groupBy' } },
          { kind: 'Field', name: { kind: 'Name', value: 'filter' } },
          { kind: 'Field', name: { kind: 'Name', value: 'order' } },
          { kind: 'Field', name: { kind: 'Name', value: 'access' } },
          { kind: 'Field', name: { kind: 'Name', value: 'showSummary' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sortBy' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'tableViewSortFragment' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'participants' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'WorkspaceParticipantUser' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'user' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'WorkspaceParticipantTeam' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'team' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TableViewColumn' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TableViewColumn' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'columnId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'order' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fixed' } },
          { kind: 'Field', name: { kind: 'Name', value: 'width' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hidden' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<BoardTableDataQuery, BoardTableDataQueryVariables>;
export const TableColumnDeleteDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'TableColumnDelete' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'DeleteTableColumnInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deleteColumn' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  TableColumnDeleteMutation,
  TableColumnDeleteMutationVariables
>;
export const TableColumnCreateDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'TableColumnCreate' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'CreateTableColumnInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createColumn' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'TableColumn' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'tableId' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TableColumnOption' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TableColumnOption' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'label' } },
          { kind: 'Field', name: { kind: 'Name', value: 'color' } },
          { kind: 'Field', name: { kind: 'Name', value: 'order' } },
          { kind: 'Field', name: { kind: 'Name', value: 'system' } },
          { kind: 'Field', name: { kind: 'Name', value: 'statusGroup' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TableColumnLinkFormField' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TableColumnLinkFormField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'columnId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'visible' } },
          { kind: 'Field', name: { kind: 'Name', value: 'required' } },
          { kind: 'Field', name: { kind: 'Name', value: 'defaultValue' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TableColumn' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TableColumns' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'system' } },
          { kind: 'Field', name: { kind: 'Name', value: 'resizable' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tableId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'field' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'valueType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'minWidth' } },
          { kind: 'Field', name: { kind: 'Name', value: 'label' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'options' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'TableColumnOption' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'tableRef' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canNotify' } },
          { kind: 'Field', name: { kind: 'Name', value: 'syncLink' } },
          { kind: 'Field', name: { kind: 'Name', value: 'columnRef' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'columnRefValue' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'system' } },
                { kind: 'Field', name: { kind: 'Name', value: 'resizable' } },
                { kind: 'Field', name: { kind: 'Name', value: 'tableId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'field' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                { kind: 'Field', name: { kind: 'Name', value: 'valueType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'minWidth' } },
                { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                { kind: 'Field', name: { kind: 'Name', value: 'tableRef' } },
                { kind: 'Field', name: { kind: 'Name', value: 'columnRef' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'options' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'TableColumnOption' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'linkingColumnRef' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'function' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'operator' } },
                { kind: 'Field', name: { kind: 'Name', value: 'columns' } },
                { kind: 'Field', name: { kind: 'Name', value: 'result' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'numberOptions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'decimalPlaces' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'prefix' } },
                { kind: 'Field', name: { kind: 'Name', value: 'suffix' } },
                { kind: 'Field', name: { kind: 'Name', value: 'separator' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'allowNegative' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'linkForm' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'linkColumnId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'fields' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: {
                          kind: 'Name',
                          value: 'TableColumnLinkFormField',
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'defaultValue' } },
          { kind: 'Field', name: { kind: 'Name', value: 'aggregator' } },
          { kind: 'Field', name: { kind: 'Name', value: 'format' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  TableColumnCreateMutation,
  TableColumnCreateMutationVariables
>;
export const TableColumnUpdateDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'TableColumnUpdate' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'UpdateTableColumnInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateColumn' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'TableColumn' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TableColumnOption' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TableColumnOption' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'label' } },
          { kind: 'Field', name: { kind: 'Name', value: 'color' } },
          { kind: 'Field', name: { kind: 'Name', value: 'order' } },
          { kind: 'Field', name: { kind: 'Name', value: 'system' } },
          { kind: 'Field', name: { kind: 'Name', value: 'statusGroup' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TableColumnLinkFormField' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TableColumnLinkFormField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'columnId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'visible' } },
          { kind: 'Field', name: { kind: 'Name', value: 'required' } },
          { kind: 'Field', name: { kind: 'Name', value: 'defaultValue' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TableColumn' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TableColumns' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'system' } },
          { kind: 'Field', name: { kind: 'Name', value: 'resizable' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tableId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'field' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'valueType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'minWidth' } },
          { kind: 'Field', name: { kind: 'Name', value: 'label' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'options' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'TableColumnOption' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'tableRef' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canNotify' } },
          { kind: 'Field', name: { kind: 'Name', value: 'syncLink' } },
          { kind: 'Field', name: { kind: 'Name', value: 'columnRef' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'columnRefValue' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'system' } },
                { kind: 'Field', name: { kind: 'Name', value: 'resizable' } },
                { kind: 'Field', name: { kind: 'Name', value: 'tableId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'field' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                { kind: 'Field', name: { kind: 'Name', value: 'valueType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'minWidth' } },
                { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                { kind: 'Field', name: { kind: 'Name', value: 'tableRef' } },
                { kind: 'Field', name: { kind: 'Name', value: 'columnRef' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'options' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'TableColumnOption' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'linkingColumnRef' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'function' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'operator' } },
                { kind: 'Field', name: { kind: 'Name', value: 'columns' } },
                { kind: 'Field', name: { kind: 'Name', value: 'result' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'numberOptions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'decimalPlaces' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'prefix' } },
                { kind: 'Field', name: { kind: 'Name', value: 'suffix' } },
                { kind: 'Field', name: { kind: 'Name', value: 'separator' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'allowNegative' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'linkForm' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'linkColumnId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'fields' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: {
                          kind: 'Name',
                          value: 'TableColumnLinkFormField',
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'defaultValue' } },
          { kind: 'Field', name: { kind: 'Name', value: 'aggregator' } },
          { kind: 'Field', name: { kind: 'Name', value: 'format' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  TableColumnUpdateMutation,
  TableColumnUpdateMutationVariables
>;
export const TableDeleteDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'TableDelete' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'DeleteTableInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deleteTable' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '_id' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<TableDeleteMutation, TableDeleteMutationVariables>;
export const TableRowDeleteBulkDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'TableRowDeleteBulk' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'DeleteBulkTableRowInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deleteBulkTableRow' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  TableRowDeleteBulkMutation,
  TableRowDeleteBulkMutationVariables
>;
export const TableRowDeleteDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'TableRowDelete' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'DeleteTableRowInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deleteTableRow' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'tableId' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  TableRowDeleteMutation,
  TableRowDeleteMutationVariables
>;
export const DuplicateBulkTableRowDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'DuplicateBulkTableRow' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'DuplicateBulkTableRowInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'duplicateBulkTableRow' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'tableRow' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'tableRow' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TableRow' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'rowId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tableId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'order' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ownerId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'unreadComments' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hasComments' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hasDescription' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'columns' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'columnId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                { kind: 'Field', name: { kind: 'Name', value: 'linkValue' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedBy' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DuplicateBulkTableRowMutation,
  DuplicateBulkTableRowMutationVariables
>;
export const TableRowMoveBulkDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'TableRowMoveBulk' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'MoveBulkTableRowInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'moveBulkTableRow' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  TableRowMoveBulkMutation,
  TableRowMoveBulkMutationVariables
>;
export const UpdateBulkTableRowDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateBulkTableRow' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'UpdateBulkTableRowInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateBulkTableRow' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateBulkTableRowMutation,
  UpdateBulkTableRowMutationVariables
>;
export const TableRowsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'TableRows' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'QueryTableRowsInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'tableRows' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '_id' } },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'tableRow' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'tableRow' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TableRow' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'rowId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tableId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'order' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ownerId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'unreadComments' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hasComments' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hasDescription' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'columns' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'columnId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                { kind: 'Field', name: { kind: 'Name', value: 'linkValue' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedBy' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<TableRowsQuery, TableRowsQueryVariables>;
export const TableUpdateDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'TableUpdate' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'UpdateTableInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateTable' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'Table' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Table' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Table' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'board' } },
          { kind: 'Field', name: { kind: 'Name', value: 'order' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<TableUpdateMutation, TableUpdateMutationVariables>;
export const TableViewColumnUpdateDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'TableViewColumnUpdate' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'UpdateTableViewColumnInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateTableViewColumn' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'TableViewColumn' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TableViewColumn' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TableViewColumn' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'columnId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'order' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fixed' } },
          { kind: 'Field', name: { kind: 'Name', value: 'width' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hidden' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  TableViewColumnUpdateMutation,
  TableViewColumnUpdateMutationVariables
>;
export const CreateTableViewDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateTableView' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'CreateTableViewInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createTableView' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'tableView' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'tableViewSortFragment' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TableViewSortInput' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'column' } },
          { kind: 'Field', name: { kind: 'Name', value: 'direction' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'tableView' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TableView' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'creatorId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'groupBy' } },
          { kind: 'Field', name: { kind: 'Name', value: 'filter' } },
          { kind: 'Field', name: { kind: 'Name', value: 'order' } },
          { kind: 'Field', name: { kind: 'Name', value: 'access' } },
          { kind: 'Field', name: { kind: 'Name', value: 'showSummary' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sortBy' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'tableViewSortFragment' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'participants' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'WorkspaceParticipantUser' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'user' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'WorkspaceParticipantTeam' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'team' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CreateTableViewMutation,
  CreateTableViewMutationVariables
>;
export const UpdateTableRowDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateTableRow' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'UpdateTableRowInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateTableRow' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'tableRow' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'tableRow' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TableRow' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'rowId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tableId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'order' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ownerId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'unreadComments' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hasComments' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hasDescription' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'columns' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'columnId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                { kind: 'Field', name: { kind: 'Name', value: 'linkValue' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedBy' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateTableRowMutation,
  UpdateTableRowMutationVariables
>;
import { fakerEN as faker } from '@faker-js/faker';

faker.seed(0);

export const generateTestAddTableColumnOptionInput = (
  overrides?: Partial<AddTableColumnOptionInput>,
  _relationshipsToOmit: Set<string> = new Set(),
): AddTableColumnOptionInput => {
  const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
  relationshipsToOmit.add('AddTableColumnOptionInput');
  return {
    columnId:
      overrides && overrides.hasOwnProperty('columnId')
        ? overrides.columnId!
        : faker.string.uuid(),
    optionData:
      overrides && overrides.hasOwnProperty('optionData')
        ? overrides.optionData!
        : relationshipsToOmit.has('TableColumnOptionInput')
          ? ({} as TableColumnOptionInput)
          : generateTestTableColumnOptionInput({}, relationshipsToOmit),
    tableId:
      overrides && overrides.hasOwnProperty('tableId')
        ? overrides.tableId!
        : faker.string.uuid(),
  };
};

export const generateTestBoard = (
  overrides?: Partial<Board>,
  _relationshipsToOmit: Set<string> = new Set(),
): Board => {
  const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
  relationshipsToOmit.add('Board');
  return {
    _id:
      overrides && overrides.hasOwnProperty('_id')
        ? overrides._id!
        : faker.string.uuid(),
    createdAt:
      overrides && overrides.hasOwnProperty('createdAt')
        ? overrides.createdAt!
        : faker.lorem.word(),
    description:
      overrides && overrides.hasOwnProperty('description')
        ? overrides.description!
        : null,
    icon:
      overrides && overrides.hasOwnProperty('icon') ? overrides.icon! : null,
    name:
      overrides && overrides.hasOwnProperty('name')
        ? overrides.name!
        : faker.lorem.word(),
    participants:
      overrides && overrides.hasOwnProperty('participants')
        ? overrides.participants!
        : [
            relationshipsToOmit.has('WorkspaceParticipantTeam')
              ? ({} as WorkspaceParticipantTeam)
              : generateTestWorkspaceParticipantTeam({}, relationshipsToOmit),
          ],
    picture:
      overrides && overrides.hasOwnProperty('picture')
        ? overrides.picture!
        : null,
    pinned:
      overrides && overrides.hasOwnProperty('pinned')
        ? overrides.pinned!
        : null,
    roles:
      overrides && overrides.hasOwnProperty('roles') ? overrides.roles! : null,
    tables:
      overrides && overrides.hasOwnProperty('tables')
        ? overrides.tables!
        : [
            relationshipsToOmit.has('Table')
              ? ({} as Table)
              : generateTestTable({}, relationshipsToOmit),
          ],
    updatedAt:
      overrides && overrides.hasOwnProperty('updatedAt')
        ? overrides.updatedAt!
        : faker.lorem.word(),
  };
};

export const generateTestBoardRoles = (
  overrides?: Partial<BoardRoles>,
  _relationshipsToOmit: Set<string> = new Set(),
): BoardRoles => {
  const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
  relationshipsToOmit.add('BoardRoles');
  return {
    admin:
      overrides && overrides.hasOwnProperty('admin') ? overrides.admin! : null,
    edit_all:
      overrides && overrides.hasOwnProperty('edit_all')
        ? overrides.edit_all!
        : null,
    edit_own:
      overrides && overrides.hasOwnProperty('edit_own')
        ? overrides.edit_own!
        : null,
    edit_unassigned:
      overrides && overrides.hasOwnProperty('edit_unassigned')
        ? overrides.edit_unassigned!
        : null,
    member:
      overrides && overrides.hasOwnProperty('member')
        ? overrides.member!
        : null,
    view_all:
      overrides && overrides.hasOwnProperty('view_all')
        ? overrides.view_all!
        : null,
    view_own:
      overrides && overrides.hasOwnProperty('view_own')
        ? overrides.view_own!
        : null,
    view_unassigned:
      overrides && overrides.hasOwnProperty('view_unassigned')
        ? overrides.view_unassigned!
        : null,
    viewer:
      overrides && overrides.hasOwnProperty('viewer')
        ? overrides.viewer!
        : null,
  };
};

export const generateTestBoardTemplate = (
  overrides?: Partial<BoardTemplate>,
  _relationshipsToOmit: Set<string> = new Set(),
): BoardTemplate => {
  const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
  relationshipsToOmit.add('BoardTemplate');
  return {
    _id:
      overrides && overrides.hasOwnProperty('_id')
        ? overrides._id!
        : faker.string.uuid(),
    category:
      overrides && overrides.hasOwnProperty('category')
        ? overrides.category!
        : BoardTemplateCategoryEnumGql.Design,
    createdAt:
      overrides && overrides.hasOwnProperty('createdAt')
        ? overrides.createdAt!
        : faker.lorem.word(),
    description:
      overrides && overrides.hasOwnProperty('description')
        ? overrides.description!
        : null,
    name:
      overrides && overrides.hasOwnProperty('name')
        ? overrides.name!
        : faker.lorem.word(),
    owner:
      overrides && overrides.hasOwnProperty('owner')
        ? overrides.owner!
        : faker.string.uuid(),
    picture:
      overrides && overrides.hasOwnProperty('picture')
        ? overrides.picture!
        : null,
    tables:
      overrides && overrides.hasOwnProperty('tables')
        ? overrides.tables!
        : [
            relationshipsToOmit.has('Table')
              ? ({} as Table)
              : generateTestTable({}, relationshipsToOmit),
          ],
    updatedAt:
      overrides && overrides.hasOwnProperty('updatedAt')
        ? overrides.updatedAt!
        : faker.lorem.word(),
    workspace:
      overrides && overrides.hasOwnProperty('workspace')
        ? overrides.workspace!
        : faker.string.uuid(),
  };
};

export const generateTestBoardTemplates = (
  overrides?: Partial<BoardTemplates>,
  _relationshipsToOmit: Set<string> = new Set(),
): BoardTemplates => {
  const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
  relationshipsToOmit.add('BoardTemplates');
  return {
    myTemplates:
      overrides && overrides.hasOwnProperty('myTemplates')
        ? overrides.myTemplates!
        : [
            relationshipsToOmit.has('BoardTemplate')
              ? ({} as BoardTemplate)
              : generateTestBoardTemplate({}, relationshipsToOmit),
          ],
    sharedTemplates:
      overrides && overrides.hasOwnProperty('sharedTemplates')
        ? overrides.sharedTemplates!
        : [
            relationshipsToOmit.has('BoardTemplate')
              ? ({} as BoardTemplate)
              : generateTestBoardTemplate({}, relationshipsToOmit),
          ],
    systemTemplates:
      overrides && overrides.hasOwnProperty('systemTemplates')
        ? overrides.systemTemplates!
        : [
            relationshipsToOmit.has('BoardTemplate')
              ? ({} as BoardTemplate)
              : generateTestBoardTemplate({}, relationshipsToOmit),
          ],
  };
};

export const generateTestCreateBoardFromTemplateInput = (
  overrides?: Partial<CreateBoardFromTemplateInput>,
  _relationshipsToOmit: Set<string> = new Set(),
): CreateBoardFromTemplateInput => {
  const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
  relationshipsToOmit.add('CreateBoardFromTemplateInput');
  return {
    boardRef:
      overrides && overrides.hasOwnProperty('boardRef')
        ? overrides.boardRef!
        : faker.string.uuid(),
    description:
      overrides && overrides.hasOwnProperty('description')
        ? overrides.description!
        : null,
    name:
      overrides && overrides.hasOwnProperty('name') ? overrides.name! : null,
    picture:
      overrides && overrides.hasOwnProperty('picture')
        ? overrides.picture!
        : null,
  };
};

export const generateTestCreateBoardInput = (
  overrides?: Partial<CreateBoardInput>,
  _relationshipsToOmit: Set<string> = new Set(),
): CreateBoardInput => {
  const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
  relationshipsToOmit.add('CreateBoardInput');
  return {
    description:
      overrides && overrides.hasOwnProperty('description')
        ? overrides.description!
        : null,
    icon:
      overrides && overrides.hasOwnProperty('icon') ? overrides.icon! : null,
    name:
      overrides && overrides.hasOwnProperty('name')
        ? overrides.name!
        : faker.lorem.word(),
    participants:
      overrides && overrides.hasOwnProperty('participants')
        ? overrides.participants!
        : null,
    picture:
      overrides && overrides.hasOwnProperty('picture')
        ? overrides.picture!
        : null,
  };
};

export const generateTestCreateTableColumnInput = (
  overrides?: Partial<CreateTableColumnInput>,
  _relationshipsToOmit: Set<string> = new Set(),
): CreateTableColumnInput => {
  const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
  relationshipsToOmit.add('CreateTableColumnInput');
  return {
    canNotify:
      overrides && overrides.hasOwnProperty('canNotify')
        ? overrides.canNotify!
        : null,
    columnRef:
      overrides && overrides.hasOwnProperty('columnRef')
        ? overrides.columnRef!
        : null,
    dateType:
      overrides && overrides.hasOwnProperty('dateType')
        ? overrides.dateType!
        : null,
    defaultValue:
      overrides && overrides.hasOwnProperty('defaultValue')
        ? overrides.defaultValue!
        : null,
    description:
      overrides && overrides.hasOwnProperty('description')
        ? overrides.description!
        : null,
    field:
      overrides && overrides.hasOwnProperty('field') ? overrides.field! : null,
    format:
      overrides && overrides.hasOwnProperty('format')
        ? overrides.format!
        : null,
    function:
      overrides && overrides.hasOwnProperty('function')
        ? overrides.function!
        : null,
    label:
      overrides && overrides.hasOwnProperty('label')
        ? overrides.label!
        : faker.lorem.word(),
    linkingColumnRef:
      overrides && overrides.hasOwnProperty('linkingColumnRef')
        ? overrides.linkingColumnRef!
        : null,
    minWidth:
      overrides && overrides.hasOwnProperty('minWidth')
        ? overrides.minWidth!
        : null,
    numberOptions:
      overrides && overrides.hasOwnProperty('numberOptions')
        ? overrides.numberOptions!
        : null,
    options:
      overrides && overrides.hasOwnProperty('options')
        ? overrides.options!
        : null,
    resizable:
      overrides && overrides.hasOwnProperty('resizable')
        ? overrides.resizable!
        : null,
    syncLink:
      overrides && overrides.hasOwnProperty('syncLink')
        ? overrides.syncLink!
        : null,
    tableId:
      overrides && overrides.hasOwnProperty('tableId')
        ? overrides.tableId!
        : faker.string.uuid(),
    tableRef:
      overrides && overrides.hasOwnProperty('tableRef')
        ? overrides.tableRef!
        : null,
    type:
      overrides && overrides.hasOwnProperty('type')
        ? overrides.type!
        : TableColumnType.Checkbox,
    valueType:
      overrides && overrides.hasOwnProperty('valueType')
        ? overrides.valueType!
        : TableColumnValueType.Bool,
  };
};

export const generateTestCreateTableInput = (
  overrides?: Partial<CreateTableInput>,
  _relationshipsToOmit: Set<string> = new Set(),
): CreateTableInput => {
  const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
  relationshipsToOmit.add('CreateTableInput');
  return {
    boardId:
      overrides && overrides.hasOwnProperty('boardId')
        ? overrides.boardId!
        : faker.string.uuid(),
    name:
      overrides && overrides.hasOwnProperty('name')
        ? overrides.name!
        : faker.lorem.word(),
  };
};

export const generateTestCreateTableRowColumnInput = (
  overrides?: Partial<CreateTableRowColumnInput>,
  _relationshipsToOmit: Set<string> = new Set(),
): CreateTableRowColumnInput => {
  const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
  relationshipsToOmit.add('CreateTableRowColumnInput');
  return {
    columnId:
      overrides && overrides.hasOwnProperty('columnId')
        ? overrides.columnId!
        : faker.string.uuid(),
    value:
      overrides && overrides.hasOwnProperty('value')
        ? overrides.value!
        : faker.lorem.word(),
  };
};

export const generateTestCreateTableRowInput = (
  overrides?: Partial<CreateTableRowInput>,
  _relationshipsToOmit: Set<string> = new Set(),
): CreateTableRowInput => {
  const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
  relationshipsToOmit.add('CreateTableRowInput');
  return {
    columns:
      overrides && overrides.hasOwnProperty('columns')
        ? overrides.columns!
        : null,
    order:
      overrides && overrides.hasOwnProperty('order') ? overrides.order! : null,
    tableId:
      overrides && overrides.hasOwnProperty('tableId')
        ? overrides.tableId!
        : faker.string.uuid(),
    title:
      overrides && overrides.hasOwnProperty('title') ? overrides.title! : null,
  };
};

export const generateTestCreateTableViewColumItemInput = (
  overrides?: Partial<CreateTableViewColumItemInput>,
  _relationshipsToOmit: Set<string> = new Set(),
): CreateTableViewColumItemInput => {
  const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
  relationshipsToOmit.add('CreateTableViewColumItemInput');
  return {
    columnId:
      overrides && overrides.hasOwnProperty('columnId')
        ? overrides.columnId!
        : faker.string.uuid(),
    hidden:
      overrides && overrides.hasOwnProperty('hidden')
        ? overrides.hidden!
        : faker.datatype.boolean(),
    order:
      overrides && overrides.hasOwnProperty('order')
        ? overrides.order!
        : faker.number.int({ min: 0, max: 9999 }),
    width:
      overrides && overrides.hasOwnProperty('width') ? overrides.width! : null,
  };
};

export const generateTestCreateTableViewInput = (
  overrides?: Partial<CreateTableViewInput>,
  _relationshipsToOmit: Set<string> = new Set(),
): CreateTableViewInput => {
  const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
  relationshipsToOmit.add('CreateTableViewInput');
  return {
    access:
      overrides && overrides.hasOwnProperty('access')
        ? overrides.access!
        : null,
    boardId:
      overrides && overrides.hasOwnProperty('boardId')
        ? overrides.boardId!
        : faker.string.uuid(),
    columns:
      overrides && overrides.hasOwnProperty('columns')
        ? overrides.columns!
        : [
            relationshipsToOmit.has('CreateTableViewColumItemInput')
              ? ({} as CreateTableViewColumItemInput)
              : generateTestCreateTableViewColumItemInput(
                  {},
                  relationshipsToOmit,
                ),
          ],
    filter:
      overrides && overrides.hasOwnProperty('filter')
        ? overrides.filter!
        : null,
    groupBy:
      overrides && overrides.hasOwnProperty('groupBy')
        ? overrides.groupBy!
        : null,
    order:
      overrides && overrides.hasOwnProperty('order')
        ? overrides.order!
        : faker.number.int({ min: 0, max: 9999 }),
    participants:
      overrides && overrides.hasOwnProperty('participants')
        ? overrides.participants!
        : null,
    showSummary:
      overrides && overrides.hasOwnProperty('showSummary')
        ? overrides.showSummary!
        : null,
    tableId:
      overrides && overrides.hasOwnProperty('tableId')
        ? overrides.tableId!
        : faker.string.uuid(),
    title:
      overrides && overrides.hasOwnProperty('title')
        ? overrides.title!
        : faker.lorem.word(),
    type:
      overrides && overrides.hasOwnProperty('type')
        ? overrides.type!
        : TableViewType.Calendar,
  };
};

export const generateTestCreateTemplateFromBoardInput = (
  overrides?: Partial<CreateTemplateFromBoardInput>,
  _relationshipsToOmit: Set<string> = new Set(),
): CreateTemplateFromBoardInput => {
  const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
  relationshipsToOmit.add('CreateTemplateFromBoardInput');
  return {
    boardRef:
      overrides && overrides.hasOwnProperty('boardRef')
        ? overrides.boardRef!
        : faker.string.uuid(),
    category:
      overrides && overrides.hasOwnProperty('category')
        ? overrides.category!
        : BoardTemplateCategoryEnumGql.Design,
    description:
      overrides && overrides.hasOwnProperty('description')
        ? overrides.description!
        : null,
    name:
      overrides && overrides.hasOwnProperty('name') ? overrides.name! : null,
    picture:
      overrides && overrides.hasOwnProperty('picture')
        ? overrides.picture!
        : null,
  };
};

export const generateTestCreateTodoItemsInput = (
  overrides?: Partial<CreateTodoItemsInput>,
  _relationshipsToOmit: Set<string> = new Set(),
): CreateTodoItemsInput => {
  const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
  relationshipsToOmit.add('CreateTodoItemsInput');
  return {
    color:
      overrides && overrides.hasOwnProperty('color') ? overrides.color! : null,
    completed:
      overrides && overrides.hasOwnProperty('completed')
        ? overrides.completed!
        : null,
    dueDate:
      overrides && overrides.hasOwnProperty('dueDate')
        ? overrides.dueDate!
        : null,
    list:
      overrides && overrides.hasOwnProperty('list') ? overrides.list! : null,
    order:
      overrides && overrides.hasOwnProperty('order') ? overrides.order! : null,
    participants:
      overrides && overrides.hasOwnProperty('participants')
        ? overrides.participants!
        : null,
    recurrence:
      overrides && overrides.hasOwnProperty('recurrence')
        ? overrides.recurrence!
        : null,
    title:
      overrides && overrides.hasOwnProperty('title')
        ? overrides.title!
        : faker.lorem.word(),
  };
};

export const generateTestCreateTodoItemsParticipantInput = (
  overrides?: Partial<CreateTodoItemsParticipantInput>,
  _relationshipsToOmit: Set<string> = new Set(),
): CreateTodoItemsParticipantInput => {
  const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
  relationshipsToOmit.add('CreateTodoItemsParticipantInput');
  return {
    user:
      overrides && overrides.hasOwnProperty('user')
        ? overrides.user!
        : faker.lorem.word(),
  };
};

export const generateTestCreateTodoListInput = (
  overrides?: Partial<CreateTodoListInput>,
  _relationshipsToOmit: Set<string> = new Set(),
): CreateTodoListInput => {
  const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
  relationshipsToOmit.add('CreateTodoListInput');
  return {
    color:
      overrides && overrides.hasOwnProperty('color') ? overrides.color! : null,
    list:
      overrides && overrides.hasOwnProperty('list') ? overrides.list! : null,
    name:
      overrides && overrides.hasOwnProperty('name')
        ? overrides.name!
        : faker.lorem.word(),
    order:
      overrides && overrides.hasOwnProperty('order')
        ? overrides.order!
        : faker.number.int({ min: 0, max: 9999 }),
    participants:
      overrides && overrides.hasOwnProperty('participants')
        ? overrides.participants!
        : null,
    tags:
      overrides && overrides.hasOwnProperty('tags') ? overrides.tags! : null,
  };
};

export const generateTestDeleteBoardInput = (
  overrides?: Partial<DeleteBoardInput>,
  _relationshipsToOmit: Set<string> = new Set(),
): DeleteBoardInput => {
  const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
  relationshipsToOmit.add('DeleteBoardInput');
  return {
    boardId:
      overrides && overrides.hasOwnProperty('boardId')
        ? overrides.boardId!
        : faker.string.uuid(),
  };
};

export const generateTestDeleteBulkTableRowInput = (
  overrides?: Partial<DeleteBulkTableRowInput>,
  _relationshipsToOmit: Set<string> = new Set(),
): DeleteBulkTableRowInput => {
  const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
  relationshipsToOmit.add('DeleteBulkTableRowInput');
  return {
    rowIds:
      overrides && overrides.hasOwnProperty('rowIds')
        ? overrides.rowIds!
        : null,
    tableId:
      overrides && overrides.hasOwnProperty('tableId')
        ? overrides.tableId!
        : faker.string.uuid(),
  };
};

export const generateTestDeleteCommentTableRowInput = (
  overrides?: Partial<DeleteCommentTableRowInput>,
  _relationshipsToOmit: Set<string> = new Set(),
): DeleteCommentTableRowInput => {
  const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
  relationshipsToOmit.add('DeleteCommentTableRowInput');
  return {
    boardId:
      overrides && overrides.hasOwnProperty('boardId')
        ? overrides.boardId!
        : faker.string.uuid(),
    messageId:
      overrides && overrides.hasOwnProperty('messageId')
        ? overrides.messageId!
        : faker.string.uuid(),
    rowId:
      overrides && overrides.hasOwnProperty('rowId')
        ? overrides.rowId!
        : faker.string.uuid(),
    tableId:
      overrides && overrides.hasOwnProperty('tableId')
        ? overrides.tableId!
        : faker.string.uuid(),
  };
};

export const generateTestDeleteTableColumnInput = (
  overrides?: Partial<DeleteTableColumnInput>,
  _relationshipsToOmit: Set<string> = new Set(),
): DeleteTableColumnInput => {
  const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
  relationshipsToOmit.add('DeleteTableColumnInput');
  return {
    columnId:
      overrides && overrides.hasOwnProperty('columnId')
        ? overrides.columnId!
        : faker.string.uuid(),
    tableId:
      overrides && overrides.hasOwnProperty('tableId')
        ? overrides.tableId!
        : faker.string.uuid(),
  };
};

export const generateTestDeleteTableColumnOptionInput = (
  overrides?: Partial<DeleteTableColumnOptionInput>,
  _relationshipsToOmit: Set<string> = new Set(),
): DeleteTableColumnOptionInput => {
  const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
  relationshipsToOmit.add('DeleteTableColumnOptionInput');
  return {
    columnId:
      overrides && overrides.hasOwnProperty('columnId')
        ? overrides.columnId!
        : faker.string.uuid(),
    optionId:
      overrides && overrides.hasOwnProperty('optionId')
        ? overrides.optionId!
        : faker.string.uuid(),
    tableId:
      overrides && overrides.hasOwnProperty('tableId')
        ? overrides.tableId!
        : faker.string.uuid(),
  };
};

export const generateTestDeleteTableInput = (
  overrides?: Partial<DeleteTableInput>,
  _relationshipsToOmit: Set<string> = new Set(),
): DeleteTableInput => {
  const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
  relationshipsToOmit.add('DeleteTableInput');
  return {
    boardId:
      overrides && overrides.hasOwnProperty('boardId')
        ? overrides.boardId!
        : faker.string.uuid(),
    tableId:
      overrides && overrides.hasOwnProperty('tableId')
        ? overrides.tableId!
        : faker.string.uuid(),
  };
};

export const generateTestDeleteTableRowInput = (
  overrides?: Partial<DeleteTableRowInput>,
  _relationshipsToOmit: Set<string> = new Set(),
): DeleteTableRowInput => {
  const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
  relationshipsToOmit.add('DeleteTableRowInput');
  return {
    rowId:
      overrides && overrides.hasOwnProperty('rowId')
        ? overrides.rowId!
        : faker.string.uuid(),
    tableId:
      overrides && overrides.hasOwnProperty('tableId')
        ? overrides.tableId!
        : faker.string.uuid(),
  };
};

export const generateTestDeleteTableViewInput = (
  overrides?: Partial<DeleteTableViewInput>,
  _relationshipsToOmit: Set<string> = new Set(),
): DeleteTableViewInput => {
  const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
  relationshipsToOmit.add('DeleteTableViewInput');
  return {
    boardId:
      overrides && overrides.hasOwnProperty('boardId')
        ? overrides.boardId!
        : faker.string.uuid(),
    tableId:
      overrides && overrides.hasOwnProperty('tableId')
        ? overrides.tableId!
        : faker.string.uuid(),
    viewId:
      overrides && overrides.hasOwnProperty('viewId')
        ? overrides.viewId!
        : faker.string.uuid(),
  };
};

export const generateTestDeleteTemplateInput = (
  overrides?: Partial<DeleteTemplateInput>,
  _relationshipsToOmit: Set<string> = new Set(),
): DeleteTemplateInput => {
  const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
  relationshipsToOmit.add('DeleteTemplateInput');
  return {
    templateId:
      overrides && overrides.hasOwnProperty('templateId')
        ? overrides.templateId!
        : faker.string.uuid(),
  };
};

export const generateTestDeleteTodoItemsInput = (
  overrides?: Partial<DeleteTodoItemsInput>,
  _relationshipsToOmit: Set<string> = new Set(),
): DeleteTodoItemsInput => {
  const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
  relationshipsToOmit.add('DeleteTodoItemsInput');
  return {
    id:
      overrides && overrides.hasOwnProperty('id')
        ? overrides.id!
        : faker.lorem.word(),
  };
};

export const generateTestDeleteTodoListInput = (
  overrides?: Partial<DeleteTodoListInput>,
  _relationshipsToOmit: Set<string> = new Set(),
): DeleteTodoListInput => {
  const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
  relationshipsToOmit.add('DeleteTodoListInput');
  return {
    id:
      overrides && overrides.hasOwnProperty('id')
        ? overrides.id!
        : faker.lorem.word(),
  };
};

export const generateTestDuplicateBulkTableRowInput = (
  overrides?: Partial<DuplicateBulkTableRowInput>,
  _relationshipsToOmit: Set<string> = new Set(),
): DuplicateBulkTableRowInput => {
  const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
  relationshipsToOmit.add('DuplicateBulkTableRowInput');
  return {
    rowIds:
      overrides && overrides.hasOwnProperty('rowIds')
        ? overrides.rowIds!
        : null,
    tableId:
      overrides && overrides.hasOwnProperty('tableId')
        ? overrides.tableId!
        : faker.string.uuid(),
  };
};

export const generateTestFilterConditionDate = (
  overrides?: Partial<FilterConditionDate>,
  _relationshipsToOmit: Set<string> = new Set(),
): FilterConditionDate => {
  const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
  relationshipsToOmit.add('FilterConditionDate');
  return {
    columnId:
      overrides && overrides.hasOwnProperty('columnId')
        ? overrides.columnId!
        : faker.string.uuid(),
    date:
      overrides && overrides.hasOwnProperty('date') ? overrides.date! : null,
    dateEnd:
      overrides && overrides.hasOwnProperty('dateEnd')
        ? overrides.dateEnd!
        : null,
    dateStart:
      overrides && overrides.hasOwnProperty('dateStart')
        ? overrides.dateStart!
        : null,
    operator:
      overrides && overrides.hasOwnProperty('operator')
        ? overrides.operator!
        : FilterOperatorDate.CurrentMonth,
    valueType:
      overrides && overrides.hasOwnProperty('valueType')
        ? overrides.valueType!
        : TableColumnValueType.Bool,
  };
};

export const generateTestFilterConditionMultiValue = (
  overrides?: Partial<FilterConditionMultiValue>,
  _relationshipsToOmit: Set<string> = new Set(),
): FilterConditionMultiValue => {
  const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
  relationshipsToOmit.add('FilterConditionMultiValue');
  return {
    columnId:
      overrides && overrides.hasOwnProperty('columnId')
        ? overrides.columnId!
        : faker.string.uuid(),
    matchStrategy:
      overrides && overrides.hasOwnProperty('matchStrategy')
        ? overrides.matchStrategy!
        : null,
    operator:
      overrides && overrides.hasOwnProperty('operator')
        ? overrides.operator!
        : FilterOperatorCompare.Equals,
    value:
      overrides && overrides.hasOwnProperty('value')
        ? overrides.value!
        : [faker.lorem.word()],
    valueType:
      overrides && overrides.hasOwnProperty('valueType')
        ? overrides.valueType!
        : TableColumnValueType.Bool,
  };
};

export const generateTestFilterConditionNumber = (
  overrides?: Partial<FilterConditionNumber>,
  _relationshipsToOmit: Set<string> = new Set(),
): FilterConditionNumber => {
  const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
  relationshipsToOmit.add('FilterConditionNumber');
  return {
    columnId:
      overrides && overrides.hasOwnProperty('columnId')
        ? overrides.columnId!
        : faker.string.uuid(),
    operator:
      overrides && overrides.hasOwnProperty('operator')
        ? overrides.operator!
        : FilterOperatorNumber.Equals,
    value:
      overrides && overrides.hasOwnProperty('value')
        ? overrides.value!
        : faker.number.int({ min: 0, max: 9999 }),
    valueType:
      overrides && overrides.hasOwnProperty('valueType')
        ? overrides.valueType!
        : TableColumnValueType.Bool,
  };
};

export const generateTestFilterConditionString = (
  overrides?: Partial<FilterConditionString>,
  _relationshipsToOmit: Set<string> = new Set(),
): FilterConditionString => {
  const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
  relationshipsToOmit.add('FilterConditionString');
  return {
    columnId:
      overrides && overrides.hasOwnProperty('columnId')
        ? overrides.columnId!
        : faker.string.uuid(),
    operator:
      overrides && overrides.hasOwnProperty('operator')
        ? overrides.operator!
        : FilterOperatorString.Contains,
    value:
      overrides && overrides.hasOwnProperty('value')
        ? overrides.value!
        : faker.lorem.word(),
    valueType:
      overrides && overrides.hasOwnProperty('valueType')
        ? overrides.valueType!
        : TableColumnValueType.Bool,
  };
};

export const generateTestImportBulkTableInput = (
  overrides?: Partial<ImportBulkTableInput>,
  _relationshipsToOmit: Set<string> = new Set(),
): ImportBulkTableInput => {
  const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
  relationshipsToOmit.add('ImportBulkTableInput');
  return {
    boardId:
      overrides && overrides.hasOwnProperty('boardId')
        ? overrides.boardId!
        : faker.string.uuid(),
    columns:
      overrides && overrides.hasOwnProperty('columns')
        ? overrides.columns!
        : faker.lorem.word(),
    file:
      overrides && overrides.hasOwnProperty('file')
        ? overrides.file!
        : faker.lorem.word(),
    tableId:
      overrides && overrides.hasOwnProperty('tableId')
        ? overrides.tableId!
        : faker.string.uuid(),
  };
};

export const generateTestLeaveBoardInput = (
  overrides?: Partial<LeaveBoardInput>,
  _relationshipsToOmit: Set<string> = new Set(),
): LeaveBoardInput => {
  const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
  relationshipsToOmit.add('LeaveBoardInput');
  return {
    boardId:
      overrides && overrides.hasOwnProperty('boardId')
        ? overrides.boardId!
        : faker.string.uuid(),
  };
};

export const generateTestLeaveTodoListInput = (
  overrides?: Partial<LeaveTodoListInput>,
  _relationshipsToOmit: Set<string> = new Set(),
): LeaveTodoListInput => {
  const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
  relationshipsToOmit.add('LeaveTodoListInput');
  return {
    id:
      overrides && overrides.hasOwnProperty('id')
        ? overrides.id!
        : faker.lorem.word(),
  };
};

export const generateTestMoveBulkTableRowInput = (
  overrides?: Partial<MoveBulkTableRowInput>,
  _relationshipsToOmit: Set<string> = new Set(),
): MoveBulkTableRowInput => {
  const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
  relationshipsToOmit.add('MoveBulkTableRowInput');
  return {
    rowIds:
      overrides && overrides.hasOwnProperty('rowIds')
        ? overrides.rowIds!
        : null,
    tableIdNew:
      overrides && overrides.hasOwnProperty('tableIdNew')
        ? overrides.tableIdNew!
        : faker.string.uuid(),
    tableIdOld:
      overrides && overrides.hasOwnProperty('tableIdOld')
        ? overrides.tableIdOld!
        : faker.string.uuid(),
  };
};

export const generateTestMutation = (
  overrides?: Partial<Mutation>,
  _relationshipsToOmit: Set<string> = new Set(),
): Mutation => {
  const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
  relationshipsToOmit.add('Mutation');
  return {
    addBoardParticipant:
      overrides && overrides.hasOwnProperty('addBoardParticipant')
        ? overrides.addBoardParticipant!
        : relationshipsToOmit.has('Board')
          ? ({} as Board)
          : generateTestBoard({}, relationshipsToOmit),
    addColumnOption:
      overrides && overrides.hasOwnProperty('addColumnOption')
        ? overrides.addColumnOption!
        : relationshipsToOmit.has('TableColumns')
          ? ({} as TableColumns)
          : generateTestTableColumns({}, relationshipsToOmit),
    createBoard:
      overrides && overrides.hasOwnProperty('createBoard')
        ? overrides.createBoard!
        : relationshipsToOmit.has('Board')
          ? ({} as Board)
          : generateTestBoard({}, relationshipsToOmit),
    createBoardFromTemplate:
      overrides && overrides.hasOwnProperty('createBoardFromTemplate')
        ? overrides.createBoardFromTemplate!
        : relationshipsToOmit.has('Table')
          ? ({} as Table)
          : generateTestTable({}, relationshipsToOmit),
    createColumn:
      overrides && overrides.hasOwnProperty('createColumn')
        ? overrides.createColumn!
        : relationshipsToOmit.has('TableColumns')
          ? ({} as TableColumns)
          : generateTestTableColumns({}, relationshipsToOmit),
    createTable:
      overrides && overrides.hasOwnProperty('createTable')
        ? overrides.createTable!
        : relationshipsToOmit.has('Table')
          ? ({} as Table)
          : generateTestTable({}, relationshipsToOmit),
    createTableRow:
      overrides && overrides.hasOwnProperty('createTableRow')
        ? overrides.createTableRow!
        : relationshipsToOmit.has('TableRow')
          ? ({} as TableRow)
          : generateTestTableRow({}, relationshipsToOmit),
    createTableView:
      overrides && overrides.hasOwnProperty('createTableView')
        ? overrides.createTableView!
        : relationshipsToOmit.has('TableView')
          ? ({} as TableView)
          : generateTestTableView({}, relationshipsToOmit),
    createTemplateFromBoard:
      overrides && overrides.hasOwnProperty('createTemplateFromBoard')
        ? overrides.createTemplateFromBoard!
        : relationshipsToOmit.has('Table')
          ? ({} as Table)
          : generateTestTable({}, relationshipsToOmit),
    createTodoItems:
      overrides && overrides.hasOwnProperty('createTodoItems')
        ? overrides.createTodoItems!
        : relationshipsToOmit.has('TodoItems')
          ? ({} as TodoItems)
          : generateTestTodoItems({}, relationshipsToOmit),
    createTodoList:
      overrides && overrides.hasOwnProperty('createTodoList')
        ? overrides.createTodoList!
        : relationshipsToOmit.has('TodoList')
          ? ({} as TodoList)
          : generateTestTodoList({}, relationshipsToOmit),
    deleteBoard:
      overrides && overrides.hasOwnProperty('deleteBoard')
        ? overrides.deleteBoard!
        : relationshipsToOmit.has('Board')
          ? ({} as Board)
          : generateTestBoard({}, relationshipsToOmit),
    deleteBulkTableRow:
      overrides && overrides.hasOwnProperty('deleteBulkTableRow')
        ? overrides.deleteBulkTableRow!
        : [faker.string.uuid()],
    deleteColumn:
      overrides && overrides.hasOwnProperty('deleteColumn')
        ? overrides.deleteColumn!
        : null,
    deleteColumnOption:
      overrides && overrides.hasOwnProperty('deleteColumnOption')
        ? overrides.deleteColumnOption!
        : relationshipsToOmit.has('TableColumns')
          ? ({} as TableColumns)
          : generateTestTableColumns({}, relationshipsToOmit),
    deleteCommentTableRow:
      overrides && overrides.hasOwnProperty('deleteCommentTableRow')
        ? overrides.deleteCommentTableRow!
        : relationshipsToOmit.has('TableRowComment')
          ? ({} as TableRowComment)
          : generateTestTableRowComment({}, relationshipsToOmit),
    deleteTable:
      overrides && overrides.hasOwnProperty('deleteTable')
        ? overrides.deleteTable!
        : relationshipsToOmit.has('Table')
          ? ({} as Table)
          : generateTestTable({}, relationshipsToOmit),
    deleteTableRow:
      overrides && overrides.hasOwnProperty('deleteTableRow')
        ? overrides.deleteTableRow!
        : relationshipsToOmit.has('TableRow')
          ? ({} as TableRow)
          : generateTestTableRow({}, relationshipsToOmit),
    deleteTableView:
      overrides && overrides.hasOwnProperty('deleteTableView')
        ? overrides.deleteTableView!
        : faker.datatype.boolean(),
    deleteTemplate:
      overrides && overrides.hasOwnProperty('deleteTemplate')
        ? overrides.deleteTemplate!
        : relationshipsToOmit.has('Table')
          ? ({} as Table)
          : generateTestTable({}, relationshipsToOmit),
    deleteTodoItems:
      overrides && overrides.hasOwnProperty('deleteTodoItems')
        ? overrides.deleteTodoItems!
        : relationshipsToOmit.has('TodoItems')
          ? ({} as TodoItems)
          : generateTestTodoItems({}, relationshipsToOmit),
    deleteTodoList:
      overrides && overrides.hasOwnProperty('deleteTodoList')
        ? overrides.deleteTodoList!
        : relationshipsToOmit.has('TodoList')
          ? ({} as TodoList)
          : generateTestTodoList({}, relationshipsToOmit),
    deleteTodoParticipant:
      overrides && overrides.hasOwnProperty('deleteTodoParticipant')
        ? overrides.deleteTodoParticipant!
        : relationshipsToOmit.has('TodoItems')
          ? ({} as TodoItems)
          : generateTestTodoItems({}, relationshipsToOmit),
    deleteTodoTag:
      overrides && overrides.hasOwnProperty('deleteTodoTag')
        ? overrides.deleteTodoTag!
        : relationshipsToOmit.has('TodoItems')
          ? ({} as TodoItems)
          : generateTestTodoItems({}, relationshipsToOmit),
    duplicateBulkTableRow:
      overrides && overrides.hasOwnProperty('duplicateBulkTableRow')
        ? overrides.duplicateBulkTableRow!
        : [
            relationshipsToOmit.has('TableRow')
              ? ({} as TableRow)
              : generateTestTableRow({}, relationshipsToOmit),
          ],
    execRemote:
      overrides && overrides.hasOwnProperty('execRemote')
        ? overrides.execRemote!
        : faker.lorem.word(),
    importBulkTableRow:
      overrides && overrides.hasOwnProperty('importBulkTableRow')
        ? overrides.importBulkTableRow!
        : [
            relationshipsToOmit.has('TableRow')
              ? ({} as TableRow)
              : generateTestTableRow({}, relationshipsToOmit),
          ],
    leaveBoard:
      overrides && overrides.hasOwnProperty('leaveBoard')
        ? overrides.leaveBoard!
        : relationshipsToOmit.has('Board')
          ? ({} as Board)
          : generateTestBoard({}, relationshipsToOmit),
    leaveTodoItems:
      overrides && overrides.hasOwnProperty('leaveTodoItems')
        ? overrides.leaveTodoItems!
        : relationshipsToOmit.has('TodoItems')
          ? ({} as TodoItems)
          : generateTestTodoItems({}, relationshipsToOmit),
    moveBulkTableRow:
      overrides && overrides.hasOwnProperty('moveBulkTableRow')
        ? overrides.moveBulkTableRow!
        : [faker.string.uuid()],
    pinBoard:
      overrides && overrides.hasOwnProperty('pinBoard')
        ? overrides.pinBoard!
        : relationshipsToOmit.has('Board')
          ? ({} as Board)
          : generateTestBoard({}, relationshipsToOmit),
    reactionCommentTableRow:
      overrides && overrides.hasOwnProperty('reactionCommentTableRow')
        ? overrides.reactionCommentTableRow!
        : relationshipsToOmit.has('TableRowComment')
          ? ({} as TableRowComment)
          : generateTestTableRowComment({}, relationshipsToOmit),
    readLastCommentTableRow:
      overrides && overrides.hasOwnProperty('readLastCommentTableRow')
        ? overrides.readLastCommentTableRow!
        : faker.lorem.word(),
    removeBoardParticipant:
      overrides && overrides.hasOwnProperty('removeBoardParticipant')
        ? overrides.removeBoardParticipant!
        : relationshipsToOmit.has('Board')
          ? ({} as Board)
          : generateTestBoard({}, relationshipsToOmit),
    sendCommentTableRow:
      overrides && overrides.hasOwnProperty('sendCommentTableRow')
        ? overrides.sendCommentTableRow!
        : relationshipsToOmit.has('TableRowComment')
          ? ({} as TableRowComment)
          : generateTestTableRowComment({}, relationshipsToOmit),
    syncTodoBoards:
      overrides && overrides.hasOwnProperty('syncTodoBoards')
        ? overrides.syncTodoBoards!
        : [
            relationshipsToOmit.has('TodoList')
              ? ({} as TodoList)
              : generateTestTodoList({}, relationshipsToOmit),
          ],
    updateBoard:
      overrides && overrides.hasOwnProperty('updateBoard')
        ? overrides.updateBoard!
        : relationshipsToOmit.has('Board')
          ? ({} as Board)
          : generateTestBoard({}, relationshipsToOmit),
    updateBoardParticipantRole:
      overrides && overrides.hasOwnProperty('updateBoardParticipantRole')
        ? overrides.updateBoardParticipantRole!
        : relationshipsToOmit.has('Board')
          ? ({} as Board)
          : generateTestBoard({}, relationshipsToOmit),
    updateBulkTableRow:
      overrides && overrides.hasOwnProperty('updateBulkTableRow')
        ? overrides.updateBulkTableRow!
        : faker.datatype.boolean(),
    updateColumn:
      overrides && overrides.hasOwnProperty('updateColumn')
        ? overrides.updateColumn!
        : relationshipsToOmit.has('TableColumns')
          ? ({} as TableColumns)
          : generateTestTableColumns({}, relationshipsToOmit),
    updateColumnOption:
      overrides && overrides.hasOwnProperty('updateColumnOption')
        ? overrides.updateColumnOption!
        : relationshipsToOmit.has('TableColumns')
          ? ({} as TableColumns)
          : generateTestTableColumns({}, relationshipsToOmit),
    updateCommentTableRow:
      overrides && overrides.hasOwnProperty('updateCommentTableRow')
        ? overrides.updateCommentTableRow!
        : relationshipsToOmit.has('TableRowComment')
          ? ({} as TableRowComment)
          : generateTestTableRowComment({}, relationshipsToOmit),
    updateTable:
      overrides && overrides.hasOwnProperty('updateTable')
        ? overrides.updateTable!
        : relationshipsToOmit.has('Table')
          ? ({} as Table)
          : generateTestTable({}, relationshipsToOmit),
    updateTableRow:
      overrides && overrides.hasOwnProperty('updateTableRow')
        ? overrides.updateTableRow!
        : relationshipsToOmit.has('TableRow')
          ? ({} as TableRow)
          : generateTestTableRow({}, relationshipsToOmit),
    updateTableView:
      overrides && overrides.hasOwnProperty('updateTableView')
        ? overrides.updateTableView!
        : relationshipsToOmit.has('TableView')
          ? ({} as TableView)
          : generateTestTableView({}, relationshipsToOmit),
    updateTableViewColumn:
      overrides && overrides.hasOwnProperty('updateTableViewColumn')
        ? overrides.updateTableViewColumn!
        : relationshipsToOmit.has('TableViewColumn')
          ? ({} as TableViewColumn)
          : generateTestTableViewColumn({}, relationshipsToOmit),
    updateTodoItems:
      overrides && overrides.hasOwnProperty('updateTodoItems')
        ? overrides.updateTodoItems!
        : relationshipsToOmit.has('TodoItems')
          ? ({} as TodoItems)
          : generateTestTodoItems({}, relationshipsToOmit),
    updateTodoList:
      overrides && overrides.hasOwnProperty('updateTodoList')
        ? overrides.updateTodoList!
        : relationshipsToOmit.has('TodoList')
          ? ({} as TodoList)
          : generateTestTodoList({}, relationshipsToOmit),
    updateTodoParticipant:
      overrides && overrides.hasOwnProperty('updateTodoParticipant')
        ? overrides.updateTodoParticipant!
        : relationshipsToOmit.has('TodoItems')
          ? ({} as TodoItems)
          : generateTestTodoItems({}, relationshipsToOmit),
    updateTodoTag:
      overrides && overrides.hasOwnProperty('updateTodoTag')
        ? overrides.updateTodoTag!
        : relationshipsToOmit.has('TodoItems')
          ? ({} as TodoItems)
          : generateTestTodoItems({}, relationshipsToOmit),
  };
};

export const generateTestPinBoardInput = (
  overrides?: Partial<PinBoardInput>,
  _relationshipsToOmit: Set<string> = new Set(),
): PinBoardInput => {
  const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
  relationshipsToOmit.add('PinBoardInput');
  return {
    boardId:
      overrides && overrides.hasOwnProperty('boardId')
        ? overrides.boardId!
        : faker.string.uuid(),
    pinned:
      overrides && overrides.hasOwnProperty('pinned')
        ? overrides.pinned!
        : faker.datatype.boolean(),
  };
};

export const generateTestQuery = (
  overrides?: Partial<Query>,
  _relationshipsToOmit: Set<string> = new Set(),
): Query => {
  const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
  relationshipsToOmit.add('Query');
  return {
    board:
      overrides && overrides.hasOwnProperty('board')
        ? overrides.board!
        : relationshipsToOmit.has('Board')
          ? ({} as Board)
          : generateTestBoard({}, relationshipsToOmit),
    boardTemplates:
      overrides && overrides.hasOwnProperty('boardTemplates')
        ? overrides.boardTemplates!
        : [
            relationshipsToOmit.has('BoardTemplates')
              ? ({} as BoardTemplates)
              : generateTestBoardTemplates({}, relationshipsToOmit),
          ],
    boards:
      overrides && overrides.hasOwnProperty('boards')
        ? overrides.boards!
        : [
            relationshipsToOmit.has('Board')
              ? ({} as Board)
              : generateTestBoard({}, relationshipsToOmit),
          ],
    filter:
      overrides && overrides.hasOwnProperty('filter')
        ? overrides.filter!
        : [
            relationshipsToOmit.has('TableRow')
              ? ({} as TableRow)
              : generateTestTableRow({}, relationshipsToOmit),
          ],
    health:
      overrides && overrides.hasOwnProperty('health')
        ? overrides.health!
        : faker.lorem.word(),
    me:
      overrides && overrides.hasOwnProperty('me')
        ? overrides.me!
        : relationshipsToOmit.has('User')
          ? ({} as User)
          : generateTestUser({}, relationshipsToOmit),
    table:
      overrides && overrides.hasOwnProperty('table')
        ? overrides.table!
        : relationshipsToOmit.has('Table')
          ? ({} as Table)
          : generateTestTable({}, relationshipsToOmit),
    tableRow:
      overrides && overrides.hasOwnProperty('tableRow')
        ? overrides.tableRow!
        : relationshipsToOmit.has('TableRow')
          ? ({} as TableRow)
          : generateTestTableRow({}, relationshipsToOmit),
    tableRowComments:
      overrides && overrides.hasOwnProperty('tableRowComments')
        ? overrides.tableRowComments!
        : relationshipsToOmit.has('TableRowCommentPagination')
          ? ({} as TableRowCommentPagination)
          : generateTestTableRowCommentPagination({}, relationshipsToOmit),
    tableRowHistory:
      overrides && overrides.hasOwnProperty('tableRowHistory')
        ? overrides.tableRowHistory!
        : [
            relationshipsToOmit.has('TableRowHistory')
              ? ({} as TableRowHistory)
              : generateTestTableRowHistory({}, relationshipsToOmit),
          ],
    tableRowRoom:
      overrides && overrides.hasOwnProperty('tableRowRoom')
        ? overrides.tableRowRoom!
        : relationshipsToOmit.has('TableRowRoomComment')
          ? ({} as TableRowRoomComment)
          : generateTestTableRowRoomComment({}, relationshipsToOmit),
    tableRows:
      overrides && overrides.hasOwnProperty('tableRows')
        ? overrides.tableRows!
        : [
            relationshipsToOmit.has('TableRow')
              ? ({} as TableRow)
              : generateTestTableRow({}, relationshipsToOmit),
          ],
    tableView:
      overrides && overrides.hasOwnProperty('tableView')
        ? overrides.tableView!
        : relationshipsToOmit.has('TableView')
          ? ({} as TableView)
          : generateTestTableView({}, relationshipsToOmit),
    tables:
      overrides && overrides.hasOwnProperty('tables')
        ? overrides.tables!
        : [
            relationshipsToOmit.has('Table')
              ? ({} as Table)
              : generateTestTable({}, relationshipsToOmit),
          ],
    todoItems:
      overrides && overrides.hasOwnProperty('todoItems')
        ? overrides.todoItems!
        : [
            relationshipsToOmit.has('TodoItems')
              ? ({} as TodoItems)
              : generateTestTodoItems({}, relationshipsToOmit),
          ],
    todoList:
      overrides && overrides.hasOwnProperty('todoList')
        ? overrides.todoList!
        : [
            relationshipsToOmit.has('TodoList')
              ? ({} as TodoList)
              : generateTestTodoList({}, relationshipsToOmit),
          ],
    todoRecurrenceItems:
      overrides && overrides.hasOwnProperty('todoRecurrenceItems')
        ? overrides.todoRecurrenceItems!
        : [
            relationshipsToOmit.has('TodoItems')
              ? ({} as TodoItems)
              : generateTestTodoItems({}, relationshipsToOmit),
          ],
  };
};

export const generateTestQueryTableFilterInput = (
  overrides?: Partial<QueryTableFilterInput>,
  _relationshipsToOmit: Set<string> = new Set(),
): QueryTableFilterInput => {
  const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
  relationshipsToOmit.add('QueryTableFilterInput');
  return {
    boardId:
      overrides && overrides.hasOwnProperty('boardId')
        ? overrides.boardId!
        : faker.string.uuid(),
    filter:
      overrides && overrides.hasOwnProperty('filter')
        ? overrides.filter!
        : null,
    tableId:
      overrides && overrides.hasOwnProperty('tableId')
        ? overrides.tableId!
        : faker.string.uuid(),
  };
};

export const generateTestQueryTableInput = (
  overrides?: Partial<QueryTableInput>,
  _relationshipsToOmit: Set<string> = new Set(),
): QueryTableInput => {
  const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
  relationshipsToOmit.add('QueryTableInput');
  return {
    boardId:
      overrides && overrides.hasOwnProperty('boardId')
        ? overrides.boardId!
        : faker.string.uuid(),
    tableId:
      overrides && overrides.hasOwnProperty('tableId')
        ? overrides.tableId!
        : faker.string.uuid(),
  };
};

export const generateTestQueryTableRowCommentInput = (
  overrides?: Partial<QueryTableRowCommentInput>,
  _relationshipsToOmit: Set<string> = new Set(),
): QueryTableRowCommentInput => {
  const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
  relationshipsToOmit.add('QueryTableRowCommentInput');
  return {
    after:
      overrides && overrides.hasOwnProperty('after') ? overrides.after! : null,
    around:
      overrides && overrides.hasOwnProperty('around')
        ? overrides.around!
        : null,
    before:
      overrides && overrides.hasOwnProperty('before')
        ? overrides.before!
        : null,
    boardId:
      overrides && overrides.hasOwnProperty('boardId')
        ? overrides.boardId!
        : faker.string.uuid(),
    rowId:
      overrides && overrides.hasOwnProperty('rowId')
        ? overrides.rowId!
        : faker.string.uuid(),
    tableId:
      overrides && overrides.hasOwnProperty('tableId')
        ? overrides.tableId!
        : faker.string.uuid(),
  };
};

export const generateTestQueryTableRowHistoryInput = (
  overrides?: Partial<QueryTableRowHistoryInput>,
  _relationshipsToOmit: Set<string> = new Set(),
): QueryTableRowHistoryInput => {
  const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
  relationshipsToOmit.add('QueryTableRowHistoryInput');
  return {
    rowId:
      overrides && overrides.hasOwnProperty('rowId')
        ? overrides.rowId!
        : faker.string.uuid(),
    tableId:
      overrides && overrides.hasOwnProperty('tableId')
        ? overrides.tableId!
        : faker.string.uuid(),
  };
};

export const generateTestQueryTableRowInput = (
  overrides?: Partial<QueryTableRowInput>,
  _relationshipsToOmit: Set<string> = new Set(),
): QueryTableRowInput => {
  const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
  relationshipsToOmit.add('QueryTableRowInput');
  return {
    rowId:
      overrides && overrides.hasOwnProperty('rowId')
        ? overrides.rowId!
        : faker.string.uuid(),
    tableId:
      overrides && overrides.hasOwnProperty('tableId')
        ? overrides.tableId!
        : faker.string.uuid(),
  };
};

export const generateTestQueryTableRowRoomInput = (
  overrides?: Partial<QueryTableRowRoomInput>,
  _relationshipsToOmit: Set<string> = new Set(),
): QueryTableRowRoomInput => {
  const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
  relationshipsToOmit.add('QueryTableRowRoomInput');
  return {
    boardId:
      overrides && overrides.hasOwnProperty('boardId')
        ? overrides.boardId!
        : faker.string.uuid(),
    rowId:
      overrides && overrides.hasOwnProperty('rowId')
        ? overrides.rowId!
        : faker.string.uuid(),
    tableId:
      overrides && overrides.hasOwnProperty('tableId')
        ? overrides.tableId!
        : faker.string.uuid(),
  };
};

export const generateTestQueryTableRowsInput = (
  overrides?: Partial<QueryTableRowsInput>,
  _relationshipsToOmit: Set<string> = new Set(),
): QueryTableRowsInput => {
  const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
  relationshipsToOmit.add('QueryTableRowsInput');
  return {
    boardId:
      overrides && overrides.hasOwnProperty('boardId')
        ? overrides.boardId!
        : faker.string.uuid(),
    filter:
      overrides && overrides.hasOwnProperty('filter')
        ? overrides.filter!
        : null,
    groupBy:
      overrides && overrides.hasOwnProperty('groupBy')
        ? overrides.groupBy!
        : null,
    limit:
      overrides && overrides.hasOwnProperty('limit') ? overrides.limit! : null,
    skip:
      overrides && overrides.hasOwnProperty('skip') ? overrides.skip! : null,
    sortBy:
      overrides && overrides.hasOwnProperty('sortBy')
        ? overrides.sortBy!
        : null,
    tableId:
      overrides && overrides.hasOwnProperty('tableId')
        ? overrides.tableId!
        : faker.string.uuid(),
    viewId:
      overrides && overrides.hasOwnProperty('viewId')
        ? overrides.viewId!
        : null,
  };
};

export const generateTestQueryTableViewInput = (
  overrides?: Partial<QueryTableViewInput>,
  _relationshipsToOmit: Set<string> = new Set(),
): QueryTableViewInput => {
  const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
  relationshipsToOmit.add('QueryTableViewInput');
  return {
    boardId:
      overrides && overrides.hasOwnProperty('boardId')
        ? overrides.boardId!
        : faker.string.uuid(),
    tableId:
      overrides && overrides.hasOwnProperty('tableId')
        ? overrides.tableId!
        : faker.string.uuid(),
    viewId:
      overrides && overrides.hasOwnProperty('viewId')
        ? overrides.viewId!
        : faker.string.uuid(),
  };
};

export const generateTestQueryTablesInput = (
  overrides?: Partial<QueryTablesInput>,
  _relationshipsToOmit: Set<string> = new Set(),
): QueryTablesInput => {
  const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
  relationshipsToOmit.add('QueryTablesInput');
  return {
    boardId:
      overrides && overrides.hasOwnProperty('boardId')
        ? overrides.boardId!
        : faker.string.uuid(),
    filter:
      overrides && overrides.hasOwnProperty('filter')
        ? overrides.filter!
        : null,
  };
};

export const generateTestReactionCommentTableRowInput = (
  overrides?: Partial<ReactionCommentTableRowInput>,
  _relationshipsToOmit: Set<string> = new Set(),
): ReactionCommentTableRowInput => {
  const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
  relationshipsToOmit.add('ReactionCommentTableRowInput');
  return {
    boardId:
      overrides && overrides.hasOwnProperty('boardId')
        ? overrides.boardId!
        : faker.string.uuid(),
    messageId:
      overrides && overrides.hasOwnProperty('messageId')
        ? overrides.messageId!
        : faker.string.uuid(),
    reaction:
      overrides && overrides.hasOwnProperty('reaction')
        ? overrides.reaction!
        : faker.lorem.word(),
    rowId:
      overrides && overrides.hasOwnProperty('rowId')
        ? overrides.rowId!
        : faker.string.uuid(),
    tableId:
      overrides && overrides.hasOwnProperty('tableId')
        ? overrides.tableId!
        : faker.string.uuid(),
  };
};

export const generateTestReadLastCommentTableRowInput = (
  overrides?: Partial<ReadLastCommentTableRowInput>,
  _relationshipsToOmit: Set<string> = new Set(),
): ReadLastCommentTableRowInput => {
  const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
  relationshipsToOmit.add('ReadLastCommentTableRowInput');
  return {
    boardId:
      overrides && overrides.hasOwnProperty('boardId')
        ? overrides.boardId!
        : faker.string.uuid(),
    messageId:
      overrides && overrides.hasOwnProperty('messageId')
        ? overrides.messageId!
        : faker.string.uuid(),
    rowId:
      overrides && overrides.hasOwnProperty('rowId')
        ? overrides.rowId!
        : faker.string.uuid(),
    tableId:
      overrides && overrides.hasOwnProperty('tableId')
        ? overrides.tableId!
        : faker.string.uuid(),
  };
};

export const generateTestRoleDetail = (
  overrides?: Partial<RoleDetail>,
  _relationshipsToOmit: Set<string> = new Set(),
): RoleDetail => {
  const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
  relationshipsToOmit.add('RoleDetail');
  return {
    key:
      overrides && overrides.hasOwnProperty('key')
        ? overrides.key!
        : faker.lorem.word(),
    value:
      overrides && overrides.hasOwnProperty('value')
        ? overrides.value!
        : faker.datatype.boolean(),
  };
};

export const generateTestSendCommentTableRowInput = (
  overrides?: Partial<SendCommentTableRowInput>,
  _relationshipsToOmit: Set<string> = new Set(),
): SendCommentTableRowInput => {
  const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
  relationshipsToOmit.add('SendCommentTableRowInput');
  return {
    boardId:
      overrides && overrides.hasOwnProperty('boardId')
        ? overrides.boardId!
        : faker.string.uuid(),
    content:
      overrides && overrides.hasOwnProperty('content')
        ? overrides.content!
        : null,
    contentType:
      overrides && overrides.hasOwnProperty('contentType')
        ? overrides.contentType!
        : null,
    fileName:
      overrides && overrides.hasOwnProperty('fileName')
        ? overrides.fileName!
        : null,
    fileSize:
      overrides && overrides.hasOwnProperty('fileSize')
        ? overrides.fileSize!
        : null,
    mediaRef:
      overrides && overrides.hasOwnProperty('mediaRef')
        ? overrides.mediaRef!
        : null,
    mimeType:
      overrides && overrides.hasOwnProperty('mimeType')
        ? overrides.mimeType!
        : null,
    replyTo:
      overrides && overrides.hasOwnProperty('replyTo')
        ? overrides.replyTo!
        : null,
    rowId:
      overrides && overrides.hasOwnProperty('rowId')
        ? overrides.rowId!
        : faker.string.uuid(),
    tableId:
      overrides && overrides.hasOwnProperty('tableId')
        ? overrides.tableId!
        : faker.string.uuid(),
  };
};

export const generateTestSyncTodoBoardsInput = (
  overrides?: Partial<SyncTodoBoardsInput>,
  _relationshipsToOmit: Set<string> = new Set(),
): SyncTodoBoardsInput => {
  const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
  relationshipsToOmit.add('SyncTodoBoardsInput');
  return {
    boardTables:
      overrides && overrides.hasOwnProperty('boardTables')
        ? overrides.boardTables!
        : null,
  };
};

export const generateTestTable = (
  overrides?: Partial<Table>,
  _relationshipsToOmit: Set<string> = new Set(),
): Table => {
  const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
  relationshipsToOmit.add('Table');
  return {
    _id:
      overrides && overrides.hasOwnProperty('_id')
        ? overrides._id!
        : faker.string.uuid(),
    activeAutomations:
      overrides && overrides.hasOwnProperty('activeAutomations')
        ? overrides.activeAutomations!
        : faker.number.int({ min: 0, max: 9999 }),
    board:
      overrides && overrides.hasOwnProperty('board')
        ? overrides.board!
        : faker.string.uuid(),
    columns:
      overrides && overrides.hasOwnProperty('columns')
        ? overrides.columns!
        : [
            relationshipsToOmit.has('TableColumns')
              ? ({} as TableColumns)
              : generateTestTableColumns({}, relationshipsToOmit),
          ],
    createdAt:
      overrides && overrides.hasOwnProperty('createdAt')
        ? overrides.createdAt!
        : faker.lorem.word(),
    name:
      overrides && overrides.hasOwnProperty('name')
        ? overrides.name!
        : faker.lorem.word(),
    order:
      overrides && overrides.hasOwnProperty('order')
        ? overrides.order!
        : faker.number.int({ min: 0, max: 9999 }),
    owner:
      overrides && overrides.hasOwnProperty('owner')
        ? overrides.owner!
        : faker.string.uuid(),
    rows:
      overrides && overrides.hasOwnProperty('rows')
        ? overrides.rows!
        : [
            relationshipsToOmit.has('TableRow')
              ? ({} as TableRow)
              : generateTestTableRow({}, relationshipsToOmit),
          ],
    updatedAt:
      overrides && overrides.hasOwnProperty('updatedAt')
        ? overrides.updatedAt!
        : faker.lorem.word(),
    views:
      overrides && overrides.hasOwnProperty('views')
        ? overrides.views!
        : [
            relationshipsToOmit.has('TableView')
              ? ({} as TableView)
              : generateTestTableView({}, relationshipsToOmit),
          ],
  };
};

export const generateTestTableColumnFuction = (
  overrides?: Partial<TableColumnFuction>,
  _relationshipsToOmit: Set<string> = new Set(),
): TableColumnFuction => {
  const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
  relationshipsToOmit.add('TableColumnFuction');
  return {
    columns:
      overrides && overrides.hasOwnProperty('columns')
        ? overrides.columns!
        : [faker.string.uuid()],
    operator:
      overrides && overrides.hasOwnProperty('operator')
        ? overrides.operator!
        : TableColumnFuctionOperator.Add,
    result:
      overrides && overrides.hasOwnProperty('result')
        ? overrides.result!
        : null,
  };
};

export const generateTestTableColumnFuctionInput = (
  overrides?: Partial<TableColumnFuctionInput>,
  _relationshipsToOmit: Set<string> = new Set(),
): TableColumnFuctionInput => {
  const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
  relationshipsToOmit.add('TableColumnFuctionInput');
  return {
    columns:
      overrides && overrides.hasOwnProperty('columns')
        ? overrides.columns!
        : [faker.string.uuid()],
    operator:
      overrides && overrides.hasOwnProperty('operator')
        ? overrides.operator!
        : null,
    result:
      overrides && overrides.hasOwnProperty('result')
        ? overrides.result!
        : null,
  };
};

export const generateTestTableColumnLinkForm = (
  overrides?: Partial<TableColumnLinkForm>,
  _relationshipsToOmit: Set<string> = new Set(),
): TableColumnLinkForm => {
  const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
  relationshipsToOmit.add('TableColumnLinkForm');
  return {
    fields:
      overrides && overrides.hasOwnProperty('fields')
        ? overrides.fields!
        : [
            relationshipsToOmit.has('TableColumnLinkFormField')
              ? ({} as TableColumnLinkFormField)
              : generateTestTableColumnLinkFormField({}, relationshipsToOmit),
          ],
    label:
      overrides && overrides.hasOwnProperty('label') ? overrides.label! : null,
    linkColumnId:
      overrides && overrides.hasOwnProperty('linkColumnId')
        ? overrides.linkColumnId!
        : faker.string.uuid(),
  };
};

export const generateTestTableColumnLinkFormField = (
  overrides?: Partial<TableColumnLinkFormField>,
  _relationshipsToOmit: Set<string> = new Set(),
): TableColumnLinkFormField => {
  const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
  relationshipsToOmit.add('TableColumnLinkFormField');
  return {
    columnId:
      overrides && overrides.hasOwnProperty('columnId')
        ? overrides.columnId!
        : faker.string.uuid(),
    defaultValue:
      overrides && overrides.hasOwnProperty('defaultValue')
        ? overrides.defaultValue!
        : null,
    required:
      overrides && overrides.hasOwnProperty('required')
        ? overrides.required!
        : faker.datatype.boolean(),
    visible:
      overrides && overrides.hasOwnProperty('visible')
        ? overrides.visible!
        : faker.datatype.boolean(),
  };
};

export const generateTestTableColumnNumberOptions = (
  overrides?: Partial<TableColumnNumberOptions>,
  _relationshipsToOmit: Set<string> = new Set(),
): TableColumnNumberOptions => {
  const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
  relationshipsToOmit.add('TableColumnNumberOptions');
  return {
    allowNegative:
      overrides && overrides.hasOwnProperty('allowNegative')
        ? overrides.allowNegative!
        : null,
    decimalPlaces:
      overrides && overrides.hasOwnProperty('decimalPlaces')
        ? overrides.decimalPlaces!
        : null,
    prefix:
      overrides && overrides.hasOwnProperty('prefix')
        ? overrides.prefix!
        : null,
    separator:
      overrides && overrides.hasOwnProperty('separator')
        ? overrides.separator!
        : null,
    suffix:
      overrides && overrides.hasOwnProperty('suffix')
        ? overrides.suffix!
        : null,
  };
};

export const generateTestTableColumnNumberOptionsInput = (
  overrides?: Partial<TableColumnNumberOptionsInput>,
  _relationshipsToOmit: Set<string> = new Set(),
): TableColumnNumberOptionsInput => {
  const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
  relationshipsToOmit.add('TableColumnNumberOptionsInput');
  return {
    allowNegative:
      overrides && overrides.hasOwnProperty('allowNegative')
        ? overrides.allowNegative!
        : null,
    decimalPlaces:
      overrides && overrides.hasOwnProperty('decimalPlaces')
        ? overrides.decimalPlaces!
        : null,
    prefix:
      overrides && overrides.hasOwnProperty('prefix')
        ? overrides.prefix!
        : null,
    separator:
      overrides && overrides.hasOwnProperty('separator')
        ? overrides.separator!
        : null,
    suffix:
      overrides && overrides.hasOwnProperty('suffix')
        ? overrides.suffix!
        : null,
  };
};

export const generateTestTableColumnOption = (
  overrides?: Partial<TableColumnOption>,
  _relationshipsToOmit: Set<string> = new Set(),
): TableColumnOption => {
  const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
  relationshipsToOmit.add('TableColumnOption');
  return {
    _id:
      overrides && overrides.hasOwnProperty('_id')
        ? overrides._id!
        : faker.string.uuid(),
    color:
      overrides && overrides.hasOwnProperty('color')
        ? overrides.color!
        : faker.lorem.word(),
    createdAt:
      overrides && overrides.hasOwnProperty('createdAt')
        ? overrides.createdAt!
        : faker.lorem.word(),
    label:
      overrides && overrides.hasOwnProperty('label')
        ? overrides.label!
        : faker.lorem.word(),
    order:
      overrides && overrides.hasOwnProperty('order')
        ? overrides.order!
        : faker.number.int({ min: 0, max: 9999 }),
    statusGroup:
      overrides && overrides.hasOwnProperty('statusGroup')
        ? overrides.statusGroup!
        : null,
    system:
      overrides && overrides.hasOwnProperty('system')
        ? overrides.system!
        : null,
    updatedAt:
      overrides && overrides.hasOwnProperty('updatedAt')
        ? overrides.updatedAt!
        : faker.lorem.word(),
  };
};

export const generateTestTableColumnOptionInput = (
  overrides?: Partial<TableColumnOptionInput>,
  _relationshipsToOmit: Set<string> = new Set(),
): TableColumnOptionInput => {
  const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
  relationshipsToOmit.add('TableColumnOptionInput');
  return {
    _id: overrides && overrides.hasOwnProperty('_id') ? overrides._id! : null,
    color:
      overrides && overrides.hasOwnProperty('color')
        ? overrides.color!
        : faker.lorem.word(),
    label:
      overrides && overrides.hasOwnProperty('label')
        ? overrides.label!
        : faker.lorem.word(),
    order:
      overrides && overrides.hasOwnProperty('order')
        ? overrides.order!
        : faker.number.int({ min: 0, max: 9999 }),
    statusGroup:
      overrides && overrides.hasOwnProperty('statusGroup')
        ? overrides.statusGroup!
        : null,
    system:
      overrides && overrides.hasOwnProperty('system')
        ? overrides.system!
        : null,
  };
};

export const generateTestTableColumns = (
  overrides?: Partial<TableColumns>,
  _relationshipsToOmit: Set<string> = new Set(),
): TableColumns => {
  const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
  relationshipsToOmit.add('TableColumns');
  return {
    _id:
      overrides && overrides.hasOwnProperty('_id')
        ? overrides._id!
        : faker.string.uuid(),
    aggregator:
      overrides && overrides.hasOwnProperty('aggregator')
        ? overrides.aggregator!
        : null,
    canNotify:
      overrides && overrides.hasOwnProperty('canNotify')
        ? overrides.canNotify!
        : null,
    columnRef:
      overrides && overrides.hasOwnProperty('columnRef')
        ? overrides.columnRef!
        : null,
    columnRefValue:
      overrides && overrides.hasOwnProperty('columnRefValue')
        ? overrides.columnRefValue!
        : null,
    createdAt:
      overrides && overrides.hasOwnProperty('createdAt')
        ? overrides.createdAt!
        : faker.lorem.word(),
    dateType:
      overrides && overrides.hasOwnProperty('dateType')
        ? overrides.dateType!
        : null,
    defaultValue:
      overrides && overrides.hasOwnProperty('defaultValue')
        ? overrides.defaultValue!
        : null,
    field:
      overrides && overrides.hasOwnProperty('field') ? overrides.field! : null,
    format:
      overrides && overrides.hasOwnProperty('format')
        ? overrides.format!
        : null,
    function:
      overrides && overrides.hasOwnProperty('function')
        ? overrides.function!
        : null,
    label:
      overrides && overrides.hasOwnProperty('label')
        ? overrides.label!
        : faker.lorem.word(),
    linkForm:
      overrides && overrides.hasOwnProperty('linkForm')
        ? overrides.linkForm!
        : null,
    linkingColumnRef:
      overrides && overrides.hasOwnProperty('linkingColumnRef')
        ? overrides.linkingColumnRef!
        : null,
    minWidth:
      overrides && overrides.hasOwnProperty('minWidth')
        ? overrides.minWidth!
        : null,
    numberOptions:
      overrides && overrides.hasOwnProperty('numberOptions')
        ? overrides.numberOptions!
        : null,
    options:
      overrides && overrides.hasOwnProperty('options')
        ? overrides.options!
        : null,
    resizable:
      overrides && overrides.hasOwnProperty('resizable')
        ? overrides.resizable!
        : null,
    syncLink:
      overrides && overrides.hasOwnProperty('syncLink')
        ? overrides.syncLink!
        : null,
    system:
      overrides && overrides.hasOwnProperty('system')
        ? overrides.system!
        : null,
    tableId:
      overrides && overrides.hasOwnProperty('tableId')
        ? overrides.tableId!
        : faker.string.uuid(),
    tableRef:
      overrides && overrides.hasOwnProperty('tableRef')
        ? overrides.tableRef!
        : null,
    type:
      overrides && overrides.hasOwnProperty('type')
        ? overrides.type!
        : TableColumnType.Checkbox,
    updatedAt:
      overrides && overrides.hasOwnProperty('updatedAt')
        ? overrides.updatedAt!
        : faker.lorem.word(),
    valueType:
      overrides && overrides.hasOwnProperty('valueType')
        ? overrides.valueType!
        : TableColumnValueType.Bool,
  };
};

export const generateTestTableFilter = (
  overrides?: Partial<TableFilter>,
  _relationshipsToOmit: Set<string> = new Set(),
): TableFilter => {
  const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
  relationshipsToOmit.add('TableFilter');
  return {
    conditions:
      overrides && overrides.hasOwnProperty('conditions')
        ? overrides.conditions!
        : [
            relationshipsToOmit.has('FilterConditionDate')
              ? ({} as FilterConditionDate)
              : generateTestFilterConditionDate({}, relationshipsToOmit),
          ],
    matchStrategy:
      overrides && overrides.hasOwnProperty('matchStrategy')
        ? overrides.matchStrategy!
        : null,
  };
};

export const generateTestTableRow = (
  overrides?: Partial<TableRow>,
  _relationshipsToOmit: Set<string> = new Set(),
): TableRow => {
  const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
  relationshipsToOmit.add('TableRow');
  return {
    _id:
      overrides && overrides.hasOwnProperty('_id')
        ? overrides._id!
        : faker.string.uuid(),
    columns:
      overrides && overrides.hasOwnProperty('columns')
        ? overrides.columns!
        : [
            relationshipsToOmit.has('TableRowColumn')
              ? ({} as TableRowColumn)
              : generateTestTableRowColumn({}, relationshipsToOmit),
          ],
    completed:
      overrides && overrides.hasOwnProperty('completed')
        ? overrides.completed!
        : faker.datatype.boolean(),
    completedAt:
      overrides && overrides.hasOwnProperty('completedAt')
        ? overrides.completedAt!
        : null,
    completedBy:
      overrides && overrides.hasOwnProperty('completedBy')
        ? overrides.completedBy!
        : null,
    createdAt:
      overrides && overrides.hasOwnProperty('createdAt')
        ? overrides.createdAt!
        : faker.lorem.word(),
    hasComments:
      overrides && overrides.hasOwnProperty('hasComments')
        ? overrides.hasComments!
        : null,
    hasDescription:
      overrides && overrides.hasOwnProperty('hasDescription')
        ? overrides.hasDescription!
        : null,
    order:
      overrides && overrides.hasOwnProperty('order')
        ? overrides.order!
        : faker.number.int({ min: 0, max: 9999 }),
    owner:
      overrides && overrides.hasOwnProperty('owner') ? overrides.owner! : null,
    ownerId:
      overrides && overrides.hasOwnProperty('ownerId')
        ? overrides.ownerId!
        : faker.string.uuid(),
    rowId:
      overrides && overrides.hasOwnProperty('rowId')
        ? overrides.rowId!
        : faker.number.int({ min: 0, max: 9999 }),
    tableId:
      overrides && overrides.hasOwnProperty('tableId')
        ? overrides.tableId!
        : faker.string.uuid(),
    unreadComments:
      overrides && overrides.hasOwnProperty('unreadComments')
        ? overrides.unreadComments!
        : null,
    updatedAt:
      overrides && overrides.hasOwnProperty('updatedAt')
        ? overrides.updatedAt!
        : faker.lorem.word(),
    updatedBy:
      overrides && overrides.hasOwnProperty('updatedBy')
        ? overrides.updatedBy!
        : null,
  };
};

export const generateTestTableRowColumn = (
  overrides?: Partial<TableRowColumn>,
  _relationshipsToOmit: Set<string> = new Set(),
): TableRowColumn => {
  const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
  relationshipsToOmit.add('TableRowColumn');
  return {
    columnId:
      overrides && overrides.hasOwnProperty('columnId')
        ? overrides.columnId!
        : faker.string.uuid(),
    linkValue:
      overrides && overrides.hasOwnProperty('linkValue')
        ? overrides.linkValue!
        : null,
    value:
      overrides && overrides.hasOwnProperty('value')
        ? overrides.value!
        : faker.lorem.word(),
  };
};

export const generateTestTableRowComment = (
  overrides?: Partial<TableRowComment>,
  _relationshipsToOmit: Set<string> = new Set(),
): TableRowComment => {
  const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
  relationshipsToOmit.add('TableRowComment');
  return {
    _id:
      overrides && overrides.hasOwnProperty('_id')
        ? overrides._id!
        : faker.string.uuid(),
    author:
      overrides && overrides.hasOwnProperty('author')
        ? overrides.author!
        : faker.string.uuid(),
    boardId:
      overrides && overrides.hasOwnProperty('boardId')
        ? overrides.boardId!
        : faker.string.uuid(),
    content:
      overrides && overrides.hasOwnProperty('content')
        ? overrides.content!
        : null,
    contentType:
      overrides && overrides.hasOwnProperty('contentType')
        ? overrides.contentType!
        : null,
    createdAt:
      overrides && overrides.hasOwnProperty('createdAt')
        ? overrides.createdAt!
        : faker.lorem.word(),
    edited:
      overrides && overrides.hasOwnProperty('edited')
        ? overrides.edited!
        : null,
    fileName:
      overrides && overrides.hasOwnProperty('fileName')
        ? overrides.fileName!
        : null,
    fileSize:
      overrides && overrides.hasOwnProperty('fileSize')
        ? overrides.fileSize!
        : null,
    mediaRef:
      overrides && overrides.hasOwnProperty('mediaRef')
        ? overrides.mediaRef!
        : null,
    mediaThumbnailRef:
      overrides && overrides.hasOwnProperty('mediaThumbnailRef')
        ? overrides.mediaThumbnailRef!
        : null,
    mentions:
      overrides && overrides.hasOwnProperty('mentions')
        ? overrides.mentions!
        : null,
    mimeType:
      overrides && overrides.hasOwnProperty('mimeType')
        ? overrides.mimeType!
        : null,
    reactions:
      overrides && overrides.hasOwnProperty('reactions')
        ? overrides.reactions!
        : null,
    replyTo:
      overrides && overrides.hasOwnProperty('replyTo')
        ? overrides.replyTo!
        : null,
    room:
      overrides && overrides.hasOwnProperty('room')
        ? overrides.room!
        : faker.string.uuid(),
    rowId:
      overrides && overrides.hasOwnProperty('rowId')
        ? overrides.rowId!
        : faker.string.uuid(),
    tableId:
      overrides && overrides.hasOwnProperty('tableId')
        ? overrides.tableId!
        : faker.string.uuid(),
    updatedAt:
      overrides && overrides.hasOwnProperty('updatedAt')
        ? overrides.updatedAt!
        : faker.lorem.word(),
  };
};

export const generateTestTableRowCommentPageInfo = (
  overrides?: Partial<TableRowCommentPageInfo>,
  _relationshipsToOmit: Set<string> = new Set(),
): TableRowCommentPageInfo => {
  const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
  relationshipsToOmit.add('TableRowCommentPageInfo');
  return {
    endCursor:
      overrides && overrides.hasOwnProperty('endCursor')
        ? overrides.endCursor!
        : null,
    hasNextPage:
      overrides && overrides.hasOwnProperty('hasNextPage')
        ? overrides.hasNextPage!
        : null,
    hasPreviousPage:
      overrides && overrides.hasOwnProperty('hasPreviousPage')
        ? overrides.hasPreviousPage!
        : null,
    startCursor:
      overrides && overrides.hasOwnProperty('startCursor')
        ? overrides.startCursor!
        : null,
  };
};

export const generateTestTableRowCommentPagination = (
  overrides?: Partial<TableRowCommentPagination>,
  _relationshipsToOmit: Set<string> = new Set(),
): TableRowCommentPagination => {
  const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
  relationshipsToOmit.add('TableRowCommentPagination');
  return {
    items:
      overrides && overrides.hasOwnProperty('items')
        ? overrides.items!
        : [
            relationshipsToOmit.has('TableRowComment')
              ? ({} as TableRowComment)
              : generateTestTableRowComment({}, relationshipsToOmit),
          ],
    pageInfo:
      overrides && overrides.hasOwnProperty('pageInfo')
        ? overrides.pageInfo!
        : relationshipsToOmit.has('TableRowCommentPageInfo')
          ? ({} as TableRowCommentPageInfo)
          : generateTestTableRowCommentPageInfo({}, relationshipsToOmit),
  };
};

export const generateTestTableRowCommentReaction = (
  overrides?: Partial<TableRowCommentReaction>,
  _relationshipsToOmit: Set<string> = new Set(),
): TableRowCommentReaction => {
  const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
  relationshipsToOmit.add('TableRowCommentReaction');
  return {
    emoji:
      overrides && overrides.hasOwnProperty('emoji')
        ? overrides.emoji!
        : faker.lorem.word(),
    users:
      overrides && overrides.hasOwnProperty('users')
        ? overrides.users!
        : [faker.string.uuid()],
  };
};

export const generateTestTableRowHistory = (
  overrides?: Partial<TableRowHistory>,
  _relationshipsToOmit: Set<string> = new Set(),
): TableRowHistory => {
  const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
  relationshipsToOmit.add('TableRowHistory');
  return {
    _id:
      overrides && overrides.hasOwnProperty('_id')
        ? overrides._id!
        : faker.string.uuid(),
    after:
      overrides && overrides.hasOwnProperty('after') ? overrides.after! : null,
    author:
      overrides && overrides.hasOwnProperty('author')
        ? overrides.author!
        : null,
    before:
      overrides && overrides.hasOwnProperty('before')
        ? overrides.before!
        : null,
    columnId:
      overrides && overrides.hasOwnProperty('columnId')
        ? overrides.columnId!
        : null,
    createdAt:
      overrides && overrides.hasOwnProperty('createdAt')
        ? overrides.createdAt!
        : faker.lorem.word(),
    data:
      overrides && overrides.hasOwnProperty('data') ? overrides.data! : null,
    rowId:
      overrides && overrides.hasOwnProperty('rowId')
        ? overrides.rowId!
        : faker.string.uuid(),
    tableId:
      overrides && overrides.hasOwnProperty('tableId')
        ? overrides.tableId!
        : faker.string.uuid(),
    workspace:
      overrides && overrides.hasOwnProperty('workspace')
        ? overrides.workspace!
        : faker.string.uuid(),
  };
};

export const generateTestTableRowRoomComment = (
  overrides?: Partial<TableRowRoomComment>,
  _relationshipsToOmit: Set<string> = new Set(),
): TableRowRoomComment => {
  const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
  relationshipsToOmit.add('TableRowRoomComment');
  return {
    _id:
      overrides && overrides.hasOwnProperty('_id')
        ? overrides._id!
        : faker.string.uuid(),
    boardId:
      overrides && overrides.hasOwnProperty('boardId')
        ? overrides.boardId!
        : faker.string.uuid(),
    createdBy:
      overrides && overrides.hasOwnProperty('createdBy')
        ? overrides.createdBy!
        : faker.string.uuid(),
    hasUnreadMessages:
      overrides && overrides.hasOwnProperty('hasUnreadMessages')
        ? overrides.hasUnreadMessages!
        : null,
    lastReadMessage:
      overrides && overrides.hasOwnProperty('lastReadMessage')
        ? overrides.lastReadMessage!
        : null,
    name:
      overrides && overrides.hasOwnProperty('name') ? overrides.name! : null,
    participants:
      overrides && overrides.hasOwnProperty('participants')
        ? overrides.participants!
        : [
            relationshipsToOmit.has('WorkspaceParticipantTeam')
              ? ({} as WorkspaceParticipantTeam)
              : generateTestWorkspaceParticipantTeam({}, relationshipsToOmit),
          ],
    rowId:
      overrides && overrides.hasOwnProperty('rowId')
        ? overrides.rowId!
        : faker.string.uuid(),
    tableId:
      overrides && overrides.hasOwnProperty('tableId')
        ? overrides.tableId!
        : faker.string.uuid(),
    type:
      overrides && overrides.hasOwnProperty('type') ? overrides.type! : null,
    workspace:
      overrides && overrides.hasOwnProperty('workspace')
        ? overrides.workspace!
        : faker.string.uuid(),
  };
};

export const generateTestTableSortInput = (
  overrides?: Partial<TableSortInput>,
  _relationshipsToOmit: Set<string> = new Set(),
): TableSortInput => {
  const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
  relationshipsToOmit.add('TableSortInput');
  return {
    column:
      overrides && overrides.hasOwnProperty('column')
        ? overrides.column!
        : faker.string.uuid(),
    dir:
      overrides && overrides.hasOwnProperty('dir')
        ? overrides.dir!
        : SortDirection.Asc,
  };
};

export const generateTestTableView = (
  overrides?: Partial<TableView>,
  _relationshipsToOmit: Set<string> = new Set(),
): TableView => {
  const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
  relationshipsToOmit.add('TableView');
  return {
    _id:
      overrides && overrides.hasOwnProperty('_id')
        ? overrides._id!
        : faker.string.uuid(),
    access:
      overrides && overrides.hasOwnProperty('access')
        ? overrides.access!
        : null,
    boardId:
      overrides && overrides.hasOwnProperty('boardId')
        ? overrides.boardId!
        : faker.string.uuid(),
    columns:
      overrides && overrides.hasOwnProperty('columns')
        ? overrides.columns!
        : [
            relationshipsToOmit.has('TableViewColumn')
              ? ({} as TableViewColumn)
              : generateTestTableViewColumn({}, relationshipsToOmit),
          ],
    createdAt:
      overrides && overrides.hasOwnProperty('createdAt')
        ? overrides.createdAt!
        : faker.lorem.word(),
    creator:
      overrides && overrides.hasOwnProperty('creator')
        ? overrides.creator!
        : null,
    creatorId:
      overrides && overrides.hasOwnProperty('creatorId')
        ? overrides.creatorId!
        : faker.string.uuid(),
    filter:
      overrides && overrides.hasOwnProperty('filter')
        ? overrides.filter!
        : null,
    groupBy:
      overrides && overrides.hasOwnProperty('groupBy')
        ? overrides.groupBy!
        : null,
    order:
      overrides && overrides.hasOwnProperty('order')
        ? overrides.order!
        : faker.number.int({ min: 0, max: 9999 }),
    participants:
      overrides && overrides.hasOwnProperty('participants')
        ? overrides.participants!
        : null,
    rows:
      overrides && overrides.hasOwnProperty('rows')
        ? overrides.rows!
        : [
            relationshipsToOmit.has('TableRow')
              ? ({} as TableRow)
              : generateTestTableRow({}, relationshipsToOmit),
          ],
    showSummary:
      overrides && overrides.hasOwnProperty('showSummary')
        ? overrides.showSummary!
        : null,
    sortBy:
      overrides && overrides.hasOwnProperty('sortBy')
        ? overrides.sortBy!
        : null,
    tableId:
      overrides && overrides.hasOwnProperty('tableId')
        ? overrides.tableId!
        : faker.string.uuid(),
    title:
      overrides && overrides.hasOwnProperty('title')
        ? overrides.title!
        : faker.lorem.word(),
    type:
      overrides && overrides.hasOwnProperty('type')
        ? overrides.type!
        : TableViewType.Calendar,
    updatedAt:
      overrides && overrides.hasOwnProperty('updatedAt')
        ? overrides.updatedAt!
        : faker.lorem.word(),
  };
};

export const generateTestTableViewColumn = (
  overrides?: Partial<TableViewColumn>,
  _relationshipsToOmit: Set<string> = new Set(),
): TableViewColumn => {
  const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
  relationshipsToOmit.add('TableViewColumn');
  return {
    _id:
      overrides && overrides.hasOwnProperty('_id')
        ? overrides._id!
        : faker.string.uuid(),
    column:
      overrides && overrides.hasOwnProperty('column')
        ? overrides.column!
        : relationshipsToOmit.has('TableColumns')
          ? ({} as TableColumns)
          : generateTestTableColumns({}, relationshipsToOmit),
    columnId:
      overrides && overrides.hasOwnProperty('columnId')
        ? overrides.columnId!
        : faker.string.uuid(),
    fixed:
      overrides && overrides.hasOwnProperty('fixed') ? overrides.fixed! : null,
    hidden:
      overrides && overrides.hasOwnProperty('hidden')
        ? overrides.hidden!
        : null,
    order:
      overrides && overrides.hasOwnProperty('order')
        ? overrides.order!
        : faker.number.int({ min: 0, max: 9999 }),
    width:
      overrides && overrides.hasOwnProperty('width') ? overrides.width! : null,
  };
};

export const generateTestTableViewParticipantInput = (
  overrides?: Partial<TableViewParticipantInput>,
  _relationshipsToOmit: Set<string> = new Set(),
): TableViewParticipantInput => {
  const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
  relationshipsToOmit.add('TableViewParticipantInput');
  return {
    team:
      overrides && overrides.hasOwnProperty('team') ? overrides.team! : null,
    user:
      overrides && overrides.hasOwnProperty('user') ? overrides.user! : null,
  };
};

export const generateTestTableViewSort = (
  overrides?: Partial<TableViewSort>,
  _relationshipsToOmit: Set<string> = new Set(),
): TableViewSort => {
  const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
  relationshipsToOmit.add('TableViewSort');
  return {
    column:
      overrides && overrides.hasOwnProperty('column')
        ? overrides.column!
        : faker.string.uuid(),
    direction:
      overrides && overrides.hasOwnProperty('direction')
        ? overrides.direction!
        : SortDirection.Asc,
  };
};

export const generateTestTableViewSortInput = (
  overrides?: Partial<TableViewSortInput>,
  _relationshipsToOmit: Set<string> = new Set(),
): TableViewSortInput => {
  const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
  relationshipsToOmit.add('TableViewSortInput');
  return {
    column:
      overrides && overrides.hasOwnProperty('column')
        ? overrides.column!
        : faker.string.uuid(),
    direction:
      overrides && overrides.hasOwnProperty('direction')
        ? overrides.direction!
        : SortDirection.Asc,
  };
};

export const generateTestTeam = (
  overrides?: Partial<Team>,
  _relationshipsToOmit: Set<string> = new Set(),
): Team => {
  const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
  relationshipsToOmit.add('Team');
  return {
    _id:
      overrides && overrides.hasOwnProperty('_id')
        ? overrides._id!
        : faker.string.uuid(),
    main:
      overrides && overrides.hasOwnProperty('main')
        ? overrides.main!
        : faker.datatype.boolean(),
    name:
      overrides && overrides.hasOwnProperty('name')
        ? overrides.name!
        : faker.lorem.word(),
    participants:
      overrides && overrides.hasOwnProperty('participants')
        ? overrides.participants!
        : [
            relationshipsToOmit.has('User')
              ? ({} as User)
              : generateTestUser({}, relationshipsToOmit),
          ],
    picture:
      overrides && overrides.hasOwnProperty('picture')
        ? overrides.picture!
        : null,
    workspace:
      overrides && overrides.hasOwnProperty('workspace')
        ? overrides.workspace!
        : relationshipsToOmit.has('Workspace')
          ? ({} as Workspace)
          : generateTestWorkspace({}, relationshipsToOmit),
  };
};

export const generateTestTodoItemRecurrence = (
  overrides?: Partial<TodoItemRecurrence>,
  _relationshipsToOmit: Set<string> = new Set(),
): TodoItemRecurrence => {
  const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
  relationshipsToOmit.add('TodoItemRecurrence');
  return {
    end: overrides && overrides.hasOwnProperty('end') ? overrides.end! : null,
    endAfter:
      overrides && overrides.hasOwnProperty('endAfter')
        ? overrides.endAfter!
        : null,
    endOn:
      overrides && overrides.hasOwnProperty('endOn') ? overrides.endOn! : null,
    startDate:
      overrides && overrides.hasOwnProperty('startDate')
        ? overrides.startDate!
        : null,
    when:
      overrides && overrides.hasOwnProperty('when') ? overrides.when! : null,
    whenRepeat:
      overrides && overrides.hasOwnProperty('whenRepeat')
        ? overrides.whenRepeat!
        : null,
    whenStep:
      overrides && overrides.hasOwnProperty('whenStep')
        ? overrides.whenStep!
        : null,
    whenWeekDays:
      overrides && overrides.hasOwnProperty('whenWeekDays')
        ? overrides.whenWeekDays!
        : null,
  };
};

export const generateTestTodoItems = (
  overrides?: Partial<TodoItems>,
  _relationshipsToOmit: Set<string> = new Set(),
): TodoItems => {
  const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
  relationshipsToOmit.add('TodoItems');
  return {
    _id:
      overrides && overrides.hasOwnProperty('_id')
        ? overrides._id!
        : faker.lorem.word(),
    color:
      overrides && overrides.hasOwnProperty('color') ? overrides.color! : null,
    completed:
      overrides && overrides.hasOwnProperty('completed')
        ? overrides.completed!
        : null,
    createdAt:
      overrides && overrides.hasOwnProperty('createdAt')
        ? overrides.createdAt!
        : null,
    description:
      overrides && overrides.hasOwnProperty('description')
        ? overrides.description!
        : null,
    dueDate:
      overrides && overrides.hasOwnProperty('dueDate')
        ? overrides.dueDate!
        : null,
    googleEventId:
      overrides && overrides.hasOwnProperty('googleEventId')
        ? overrides.googleEventId!
        : null,
    id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : null,
    list:
      overrides && overrides.hasOwnProperty('list')
        ? overrides.list!
        : faker.lorem.word(),
    order:
      overrides && overrides.hasOwnProperty('order') ? overrides.order! : null,
    owner:
      overrides && overrides.hasOwnProperty('owner') ? overrides.owner! : null,
    participants:
      overrides && overrides.hasOwnProperty('participants')
        ? overrides.participants!
        : null,
    recurrence:
      overrides && overrides.hasOwnProperty('recurrence')
        ? overrides.recurrence!
        : null,
    rrule:
      overrides && overrides.hasOwnProperty('rrule') ? overrides.rrule! : null,
    rruleText:
      overrides && overrides.hasOwnProperty('rruleText')
        ? overrides.rruleText!
        : null,
    tags:
      overrides && overrides.hasOwnProperty('tags') ? overrides.tags! : null,
    title:
      overrides && overrides.hasOwnProperty('title')
        ? overrides.title!
        : faker.lorem.word(),
    updatedAt:
      overrides && overrides.hasOwnProperty('updatedAt')
        ? overrides.updatedAt!
        : null,
  };
};

export const generateTestTodoList = (
  overrides?: Partial<TodoList>,
  _relationshipsToOmit: Set<string> = new Set(),
): TodoList => {
  const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
  relationshipsToOmit.add('TodoList');
  return {
    _id:
      overrides && overrides.hasOwnProperty('_id')
        ? overrides._id!
        : faker.lorem.word(),
    boardId:
      overrides && overrides.hasOwnProperty('boardId')
        ? overrides.boardId!
        : null,
    color:
      overrides && overrides.hasOwnProperty('color') ? overrides.color! : null,
    default:
      overrides && overrides.hasOwnProperty('default')
        ? overrides.default!
        : null,
    googleCalendars:
      overrides && overrides.hasOwnProperty('googleCalendars')
        ? overrides.googleCalendars!
        : null,
    icon:
      overrides && overrides.hasOwnProperty('icon') ? overrides.icon! : null,
    id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : null,
    list:
      overrides && overrides.hasOwnProperty('list') ? overrides.list! : null,
    name:
      overrides && overrides.hasOwnProperty('name')
        ? overrides.name!
        : faker.lorem.word(),
    order:
      overrides && overrides.hasOwnProperty('order')
        ? overrides.order!
        : faker.number.int({ min: 0, max: 9999 }),
    participants:
      overrides && overrides.hasOwnProperty('participants')
        ? overrides.participants!
        : null,
    tableId:
      overrides && overrides.hasOwnProperty('tableId')
        ? overrides.tableId!
        : null,
    tags:
      overrides && overrides.hasOwnProperty('tags') ? overrides.tags! : null,
  };
};

export const generateTestTodoParticipantInput = (
  overrides?: Partial<TodoParticipantInput>,
  _relationshipsToOmit: Set<string> = new Set(),
): TodoParticipantInput => {
  const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
  relationshipsToOmit.add('TodoParticipantInput');
  return {
    id:
      overrides && overrides.hasOwnProperty('id')
        ? overrides.id!
        : faker.lorem.word(),
    participants:
      overrides && overrides.hasOwnProperty('participants')
        ? overrides.participants!
        : [faker.lorem.word()],
  };
};

export const generateTestTodoTag = (
  overrides?: Partial<TodoTag>,
  _relationshipsToOmit: Set<string> = new Set(),
): TodoTag => {
  const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
  relationshipsToOmit.add('TodoTag');
  return {
    _id:
      overrides && overrides.hasOwnProperty('_id')
        ? overrides._id!
        : faker.lorem.word(),
    color:
      overrides && overrides.hasOwnProperty('color') ? overrides.color! : null,
    id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : null,
    name:
      overrides && overrides.hasOwnProperty('name')
        ? overrides.name!
        : faker.lorem.word(),
  };
};

export const generateTestTodoTagInput = (
  overrides?: Partial<TodoTagInput>,
  _relationshipsToOmit: Set<string> = new Set(),
): TodoTagInput => {
  const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
  relationshipsToOmit.add('TodoTagInput');
  return {
    id:
      overrides && overrides.hasOwnProperty('id')
        ? overrides.id!
        : faker.lorem.word(),
    tagId:
      overrides && overrides.hasOwnProperty('tagId')
        ? overrides.tagId!
        : faker.lorem.word(),
  };
};

export const generateTestUpdateBoardInput = (
  overrides?: Partial<UpdateBoardInput>,
  _relationshipsToOmit: Set<string> = new Set(),
): UpdateBoardInput => {
  const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
  relationshipsToOmit.add('UpdateBoardInput');
  return {
    boardId:
      overrides && overrides.hasOwnProperty('boardId')
        ? overrides.boardId!
        : faker.string.uuid(),
    description:
      overrides && overrides.hasOwnProperty('description')
        ? overrides.description!
        : null,
    icon:
      overrides && overrides.hasOwnProperty('icon') ? overrides.icon! : null,
    name:
      overrides && overrides.hasOwnProperty('name') ? overrides.name! : null,
    picture:
      overrides && overrides.hasOwnProperty('picture')
        ? overrides.picture!
        : null,
  };
};

export const generateTestUpdateBoardParticipantInput = (
  overrides?: Partial<UpdateBoardParticipantInput>,
  _relationshipsToOmit: Set<string> = new Set(),
): UpdateBoardParticipantInput => {
  const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
  relationshipsToOmit.add('UpdateBoardParticipantInput');
  return {
    boardId:
      overrides && overrides.hasOwnProperty('boardId')
        ? overrides.boardId!
        : faker.string.uuid(),
    participants:
      overrides && overrides.hasOwnProperty('participants')
        ? overrides.participants!
        : [faker.string.uuid()],
  };
};

export const generateTestUpdateBoardParticipantRoleInput = (
  overrides?: Partial<UpdateBoardParticipantRoleInput>,
  _relationshipsToOmit: Set<string> = new Set(),
): UpdateBoardParticipantRoleInput => {
  const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
  relationshipsToOmit.add('UpdateBoardParticipantRoleInput');
  return {
    boardId:
      overrides && overrides.hasOwnProperty('boardId')
        ? overrides.boardId!
        : null,
    participantId:
      overrides && overrides.hasOwnProperty('participantId')
        ? overrides.participantId!
        : faker.string.uuid(),
    role:
      overrides && overrides.hasOwnProperty('role')
        ? overrides.role!
        : faker.lorem.word(),
  };
};

export const generateTestUpdateBulkTableRowInput = (
  overrides?: Partial<UpdateBulkTableRowInput>,
  _relationshipsToOmit: Set<string> = new Set(),
): UpdateBulkTableRowInput => {
  const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
  relationshipsToOmit.add('UpdateBulkTableRowInput');
  return {
    columns:
      overrides && overrides.hasOwnProperty('columns')
        ? overrides.columns!
        : null,
    rowIds:
      overrides && overrides.hasOwnProperty('rowIds')
        ? overrides.rowIds!
        : null,
    tableId:
      overrides && overrides.hasOwnProperty('tableId')
        ? overrides.tableId!
        : faker.string.uuid(),
  };
};

export const generateTestUpdateCommentTableRowInput = (
  overrides?: Partial<UpdateCommentTableRowInput>,
  _relationshipsToOmit: Set<string> = new Set(),
): UpdateCommentTableRowInput => {
  const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
  relationshipsToOmit.add('UpdateCommentTableRowInput');
  return {
    boardId:
      overrides && overrides.hasOwnProperty('boardId')
        ? overrides.boardId!
        : faker.string.uuid(),
    content:
      overrides && overrides.hasOwnProperty('content')
        ? overrides.content!
        : faker.lorem.word(),
    messageId:
      overrides && overrides.hasOwnProperty('messageId')
        ? overrides.messageId!
        : faker.string.uuid(),
    rowId:
      overrides && overrides.hasOwnProperty('rowId')
        ? overrides.rowId!
        : faker.string.uuid(),
    tableId:
      overrides && overrides.hasOwnProperty('tableId')
        ? overrides.tableId!
        : faker.string.uuid(),
  };
};

export const generateTestUpdateTableColumnInput = (
  overrides?: Partial<UpdateTableColumnInput>,
  _relationshipsToOmit: Set<string> = new Set(),
): UpdateTableColumnInput => {
  const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
  relationshipsToOmit.add('UpdateTableColumnInput');
  return {
    aggregator:
      overrides && overrides.hasOwnProperty('aggregator')
        ? overrides.aggregator!
        : null,
    canNotify:
      overrides && overrides.hasOwnProperty('canNotify')
        ? overrides.canNotify!
        : null,
    columnId:
      overrides && overrides.hasOwnProperty('columnId')
        ? overrides.columnId!
        : faker.string.uuid(),
    columnRef:
      overrides && overrides.hasOwnProperty('columnRef')
        ? overrides.columnRef!
        : null,
    dateType:
      overrides && overrides.hasOwnProperty('dateType')
        ? overrides.dateType!
        : null,
    defaultValue:
      overrides && overrides.hasOwnProperty('defaultValue')
        ? overrides.defaultValue!
        : null,
    field:
      overrides && overrides.hasOwnProperty('field') ? overrides.field! : null,
    format:
      overrides && overrides.hasOwnProperty('format')
        ? overrides.format!
        : null,
    function:
      overrides && overrides.hasOwnProperty('function')
        ? overrides.function!
        : null,
    label:
      overrides && overrides.hasOwnProperty('label')
        ? overrides.label!
        : faker.lorem.word(),
    linkingColumnRef:
      overrides && overrides.hasOwnProperty('linkingColumnRef')
        ? overrides.linkingColumnRef!
        : null,
    minWidth:
      overrides && overrides.hasOwnProperty('minWidth')
        ? overrides.minWidth!
        : null,
    numberOptions:
      overrides && overrides.hasOwnProperty('numberOptions')
        ? overrides.numberOptions!
        : null,
    options:
      overrides && overrides.hasOwnProperty('options')
        ? overrides.options!
        : null,
    resizable:
      overrides && overrides.hasOwnProperty('resizable')
        ? overrides.resizable!
        : null,
    syncLink:
      overrides && overrides.hasOwnProperty('syncLink')
        ? overrides.syncLink!
        : null,
    tableId:
      overrides && overrides.hasOwnProperty('tableId')
        ? overrides.tableId!
        : faker.string.uuid(),
    tableRef:
      overrides && overrides.hasOwnProperty('tableRef')
        ? overrides.tableRef!
        : null,
    type:
      overrides && overrides.hasOwnProperty('type') ? overrides.type! : null,
    valueType:
      overrides && overrides.hasOwnProperty('valueType')
        ? overrides.valueType!
        : null,
  };
};

export const generateTestUpdateTableColumnOptionInput = (
  overrides?: Partial<UpdateTableColumnOptionInput>,
  _relationshipsToOmit: Set<string> = new Set(),
): UpdateTableColumnOptionInput => {
  const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
  relationshipsToOmit.add('UpdateTableColumnOptionInput');
  return {
    columnId:
      overrides && overrides.hasOwnProperty('columnId')
        ? overrides.columnId!
        : faker.string.uuid(),
    optionData:
      overrides && overrides.hasOwnProperty('optionData')
        ? overrides.optionData!
        : relationshipsToOmit.has('TableColumnOptionInput')
          ? ({} as TableColumnOptionInput)
          : generateTestTableColumnOptionInput({}, relationshipsToOmit),
    optionId:
      overrides && overrides.hasOwnProperty('optionId')
        ? overrides.optionId!
        : faker.string.uuid(),
    tableId:
      overrides && overrides.hasOwnProperty('tableId')
        ? overrides.tableId!
        : faker.string.uuid(),
  };
};

export const generateTestUpdateTableInput = (
  overrides?: Partial<UpdateTableInput>,
  _relationshipsToOmit: Set<string> = new Set(),
): UpdateTableInput => {
  const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
  relationshipsToOmit.add('UpdateTableInput');
  return {
    boardId:
      overrides && overrides.hasOwnProperty('boardId')
        ? overrides.boardId!
        : faker.string.uuid(),
    name:
      overrides && overrides.hasOwnProperty('name') ? overrides.name! : null,
    order:
      overrides && overrides.hasOwnProperty('order') ? overrides.order! : null,
    tableId:
      overrides && overrides.hasOwnProperty('tableId')
        ? overrides.tableId!
        : faker.string.uuid(),
  };
};

export const generateTestUpdateTableRowColumnInput = (
  overrides?: Partial<UpdateTableRowColumnInput>,
  _relationshipsToOmit: Set<string> = new Set(),
): UpdateTableRowColumnInput => {
  const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
  relationshipsToOmit.add('UpdateTableRowColumnInput');
  return {
    columnId:
      overrides && overrides.hasOwnProperty('columnId')
        ? overrides.columnId!
        : faker.string.uuid(),
    value:
      overrides && overrides.hasOwnProperty('value') ? overrides.value! : null,
  };
};

export const generateTestUpdateTableRowInput = (
  overrides?: Partial<UpdateTableRowInput>,
  _relationshipsToOmit: Set<string> = new Set(),
): UpdateTableRowInput => {
  const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
  relationshipsToOmit.add('UpdateTableRowInput');
  return {
    _id:
      overrides && overrides.hasOwnProperty('_id')
        ? overrides._id!
        : faker.string.uuid(),
    attachments:
      overrides && overrides.hasOwnProperty('attachments')
        ? overrides.attachments!
        : null,
    columns:
      overrides && overrides.hasOwnProperty('columns')
        ? overrides.columns!
        : null,
    order:
      overrides && overrides.hasOwnProperty('order') ? overrides.order! : null,
  };
};

export const generateTestUpdateTableViewColumnInput = (
  overrides?: Partial<UpdateTableViewColumnInput>,
  _relationshipsToOmit: Set<string> = new Set(),
): UpdateTableViewColumnInput => {
  const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
  relationshipsToOmit.add('UpdateTableViewColumnInput');
  return {
    boardId:
      overrides && overrides.hasOwnProperty('boardId')
        ? overrides.boardId!
        : faker.string.uuid(),
    columnId:
      overrides && overrides.hasOwnProperty('columnId')
        ? overrides.columnId!
        : faker.string.uuid(),
    fixed:
      overrides && overrides.hasOwnProperty('fixed') ? overrides.fixed! : null,
    hidden:
      overrides && overrides.hasOwnProperty('hidden')
        ? overrides.hidden!
        : null,
    order:
      overrides && overrides.hasOwnProperty('order') ? overrides.order! : null,
    tableId:
      overrides && overrides.hasOwnProperty('tableId')
        ? overrides.tableId!
        : faker.string.uuid(),
    viewId:
      overrides && overrides.hasOwnProperty('viewId')
        ? overrides.viewId!
        : faker.string.uuid(),
    width:
      overrides && overrides.hasOwnProperty('width') ? overrides.width! : null,
  };
};

export const generateTestUpdateTableViewInput = (
  overrides?: Partial<UpdateTableViewInput>,
  _relationshipsToOmit: Set<string> = new Set(),
): UpdateTableViewInput => {
  const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
  relationshipsToOmit.add('UpdateTableViewInput');
  return {
    _id: overrides && overrides.hasOwnProperty('_id') ? overrides._id! : null,
    access:
      overrides && overrides.hasOwnProperty('access')
        ? overrides.access!
        : null,
    boardId:
      overrides && overrides.hasOwnProperty('boardId')
        ? overrides.boardId!
        : faker.string.uuid(),
    filter:
      overrides && overrides.hasOwnProperty('filter')
        ? overrides.filter!
        : null,
    groupBy:
      overrides && overrides.hasOwnProperty('groupBy')
        ? overrides.groupBy!
        : null,
    order:
      overrides && overrides.hasOwnProperty('order') ? overrides.order! : null,
    participants:
      overrides && overrides.hasOwnProperty('participants')
        ? overrides.participants!
        : null,
    showSummary:
      overrides && overrides.hasOwnProperty('showSummary')
        ? overrides.showSummary!
        : null,
    sortBy:
      overrides && overrides.hasOwnProperty('sortBy')
        ? overrides.sortBy!
        : null,
    tableId:
      overrides && overrides.hasOwnProperty('tableId')
        ? overrides.tableId!
        : faker.string.uuid(),
    title:
      overrides && overrides.hasOwnProperty('title') ? overrides.title! : null,
    type:
      overrides && overrides.hasOwnProperty('type') ? overrides.type! : null,
    viewId:
      overrides && overrides.hasOwnProperty('viewId')
        ? overrides.viewId!
        : faker.string.uuid(),
  };
};

export const generateTestUpdateTodoItemsInput = (
  overrides?: Partial<UpdateTodoItemsInput>,
  _relationshipsToOmit: Set<string> = new Set(),
): UpdateTodoItemsInput => {
  const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
  relationshipsToOmit.add('UpdateTodoItemsInput');
  return {
    color:
      overrides && overrides.hasOwnProperty('color') ? overrides.color! : null,
    completed:
      overrides && overrides.hasOwnProperty('completed')
        ? overrides.completed!
        : null,
    dueDate:
      overrides && overrides.hasOwnProperty('dueDate')
        ? overrides.dueDate!
        : null,
    id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : null,
    list:
      overrides && overrides.hasOwnProperty('list') ? overrides.list! : null,
    order:
      overrides && overrides.hasOwnProperty('order') ? overrides.order! : null,
    participants:
      overrides && overrides.hasOwnProperty('participants')
        ? overrides.participants!
        : null,
    recurrence:
      overrides && overrides.hasOwnProperty('recurrence')
        ? overrides.recurrence!
        : null,
    title:
      overrides && overrides.hasOwnProperty('title') ? overrides.title! : null,
  };
};

export const generateTestUpdateTodoListInput = (
  overrides?: Partial<UpdateTodoListInput>,
  _relationshipsToOmit: Set<string> = new Set(),
): UpdateTodoListInput => {
  const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
  relationshipsToOmit.add('UpdateTodoListInput');
  return {
    color:
      overrides && overrides.hasOwnProperty('color') ? overrides.color! : null,
    id:
      overrides && overrides.hasOwnProperty('id')
        ? overrides.id!
        : faker.lorem.word(),
    name:
      overrides && overrides.hasOwnProperty('name') ? overrides.name! : null,
    order:
      overrides && overrides.hasOwnProperty('order') ? overrides.order! : null,
    participants:
      overrides && overrides.hasOwnProperty('participants')
        ? overrides.participants!
        : null,
    tags:
      overrides && overrides.hasOwnProperty('tags') ? overrides.tags! : null,
  };
};

export const generateTestUser = (
  overrides?: Partial<User>,
  _relationshipsToOmit: Set<string> = new Set(),
): User => {
  const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
  relationshipsToOmit.add('User');
  return {
    _id:
      overrides && overrides.hasOwnProperty('_id')
        ? overrides._id!
        : faker.string.uuid(),
    active:
      overrides && overrides.hasOwnProperty('active')
        ? overrides.active!
        : null,
    email:
      overrides && overrides.hasOwnProperty('email')
        ? overrides.email!
        : faker.lorem.word(),
    lastAccess:
      overrides && overrides.hasOwnProperty('lastAccess')
        ? overrides.lastAccess!
        : null,
    name:
      overrides && overrides.hasOwnProperty('name')
        ? overrides.name!
        : faker.lorem.word(),
    owner:
      overrides && overrides.hasOwnProperty('owner') ? overrides.owner! : null,
    picture:
      overrides && overrides.hasOwnProperty('picture')
        ? overrides.picture!
        : null,
    role:
      overrides && overrides.hasOwnProperty('role')
        ? overrides.role!
        : UserRole.Admin,
    settings:
      overrides && overrides.hasOwnProperty('settings')
        ? overrides.settings!
        : null,
    status:
      overrides && overrides.hasOwnProperty('status')
        ? overrides.status!
        : null,
    title:
      overrides && overrides.hasOwnProperty('title') ? overrides.title! : null,
  };
};

export const generateTestUserCredentials = (
  overrides?: Partial<UserCredentials>,
  _relationshipsToOmit: Set<string> = new Set(),
): UserCredentials => {
  const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
  relationshipsToOmit.add('UserCredentials');
  return {
    _id:
      overrides && overrides.hasOwnProperty('_id')
        ? overrides._id!
        : faker.string.uuid(),
    email:
      overrides && overrides.hasOwnProperty('email')
        ? overrides.email!
        : faker.lorem.word(),
    name:
      overrides && overrides.hasOwnProperty('name')
        ? overrides.name!
        : faker.lorem.word(),
    password:
      overrides && overrides.hasOwnProperty('password')
        ? overrides.password!
        : faker.lorem.word(),
    phone:
      overrides && overrides.hasOwnProperty('phone') ? overrides.phone! : null,
    verified:
      overrides && overrides.hasOwnProperty('verified')
        ? overrides.verified!
        : null,
    wizard:
      overrides && overrides.hasOwnProperty('wizard')
        ? overrides.wizard!
        : null,
  };
};

export const generateTestUserCredentialsVerified = (
  overrides?: Partial<UserCredentialsVerified>,
  _relationshipsToOmit: Set<string> = new Set(),
): UserCredentialsVerified => {
  const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
  relationshipsToOmit.add('UserCredentialsVerified');
  return {
    email:
      overrides && overrides.hasOwnProperty('email') ? overrides.email! : null,
    phone:
      overrides && overrides.hasOwnProperty('phone') ? overrides.phone! : null,
  };
};

export const generateTestUserSettings = (
  overrides?: Partial<UserSettings>,
  _relationshipsToOmit: Set<string> = new Set(),
): UserSettings => {
  const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
  relationshipsToOmit.add('UserSettings');
  return {
    themeColorPresets:
      overrides && overrides.hasOwnProperty('themeColorPresets')
        ? overrides.themeColorPresets!
        : null,
    themeContrast:
      overrides && overrides.hasOwnProperty('themeContrast')
        ? overrides.themeContrast!
        : null,
    themeDirection:
      overrides && overrides.hasOwnProperty('themeDirection')
        ? overrides.themeDirection!
        : null,
    themeLayout:
      overrides && overrides.hasOwnProperty('themeLayout')
        ? overrides.themeLayout!
        : null,
    themeMode:
      overrides && overrides.hasOwnProperty('themeMode')
        ? overrides.themeMode!
        : null,
    themeStretch:
      overrides && overrides.hasOwnProperty('themeStretch')
        ? overrides.themeStretch!
        : null,
  };
};

export const generateTestUserVerificationCode = (
  overrides?: Partial<UserVerificationCode>,
  _relationshipsToOmit: Set<string> = new Set(),
): UserVerificationCode => {
  const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
  relationshipsToOmit.add('UserVerificationCode');
  return {
    _id:
      overrides && overrides.hasOwnProperty('_id')
        ? overrides._id!
        : faker.string.uuid(),
    code:
      overrides && overrides.hasOwnProperty('code')
        ? overrides.code!
        : faker.lorem.word(),
    createdAt:
      overrides && overrides.hasOwnProperty('createdAt')
        ? overrides.createdAt!
        : faker.lorem.word(),
    owner:
      overrides && overrides.hasOwnProperty('owner')
        ? overrides.owner!
        : relationshipsToOmit.has('UserCredentials')
          ? ({} as UserCredentials)
          : generateTestUserCredentials({}, relationshipsToOmit),
    updatedAt:
      overrides && overrides.hasOwnProperty('updatedAt')
        ? overrides.updatedAt!
        : faker.lorem.word(),
  };
};

export const generateTestUserWizard = (
  overrides?: Partial<UserWizard>,
  _relationshipsToOmit: Set<string> = new Set(),
): UserWizard => {
  const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
  relationshipsToOmit.add('UserWizard');
  return {
    completedWizard:
      overrides && overrides.hasOwnProperty('completedWizard')
        ? overrides.completedWizard!
        : null,
    workspaceInvite:
      overrides && overrides.hasOwnProperty('workspaceInvite')
        ? overrides.workspaceInvite!
        : null,
  };
};

export const generateTestWorkspace = (
  overrides?: Partial<Workspace>,
  _relationshipsToOmit: Set<string> = new Set(),
): Workspace => {
  const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
  relationshipsToOmit.add('Workspace');
  return {
    createdAt:
      overrides && overrides.hasOwnProperty('createdAt')
        ? overrides.createdAt!
        : faker.lorem.word(),
    id:
      overrides && overrides.hasOwnProperty('id')
        ? overrides.id!
        : faker.string.uuid(),
    name:
      overrides && overrides.hasOwnProperty('name')
        ? overrides.name!
        : faker.lorem.word(),
    owner:
      overrides && overrides.hasOwnProperty('owner')
        ? overrides.owner!
        : relationshipsToOmit.has('User')
          ? ({} as User)
          : generateTestUser({}, relationshipsToOmit),
    pendingInvites:
      overrides && overrides.hasOwnProperty('pendingInvites')
        ? overrides.pendingInvites!
        : null,
    picture:
      overrides && overrides.hasOwnProperty('picture')
        ? overrides.picture!
        : null,
    shortName:
      overrides && overrides.hasOwnProperty('shortName')
        ? overrides.shortName!
        : faker.lorem.word(),
    updatedAt:
      overrides && overrides.hasOwnProperty('updatedAt')
        ? overrides.updatedAt!
        : faker.lorem.word(),
    users:
      overrides && overrides.hasOwnProperty('users') ? overrides.users! : null,
  };
};

export const generateTestWorkspaceInvite = (
  overrides?: Partial<WorkspaceInvite>,
  _relationshipsToOmit: Set<string> = new Set(),
): WorkspaceInvite => {
  const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
  relationshipsToOmit.add('WorkspaceInvite');
  return {
    email:
      overrides && overrides.hasOwnProperty('email')
        ? overrides.email!
        : faker.lorem.word(),
    expireAt:
      overrides && overrides.hasOwnProperty('expireAt')
        ? overrides.expireAt!
        : null,
    id:
      overrides && overrides.hasOwnProperty('id')
        ? overrides.id!
        : faker.string.uuid(),
    inviteCode:
      overrides && overrides.hasOwnProperty('inviteCode')
        ? overrides.inviteCode!
        : faker.lorem.word(),
  };
};

export const generateTestWorkspaceParticipantTeam = (
  overrides?: Partial<WorkspaceParticipantTeam>,
  _relationshipsToOmit: Set<string> = new Set(),
): WorkspaceParticipantTeam => {
  const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
  relationshipsToOmit.add('WorkspaceParticipantTeam');
  return {
    team:
      overrides && overrides.hasOwnProperty('team')
        ? overrides.team!
        : faker.string.uuid(),
  };
};

export const generateTestWorkspaceParticipantUser = (
  overrides?: Partial<WorkspaceParticipantUser>,
  _relationshipsToOmit: Set<string> = new Set(),
): WorkspaceParticipantUser => {
  const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
  relationshipsToOmit.add('WorkspaceParticipantUser');
  return {
    user:
      overrides && overrides.hasOwnProperty('user')
        ? overrides.user!
        : faker.string.uuid(),
  };
};

export const seedMocks = (seed: number) => faker.seed(seed);
